$(document).ready(function(){

  var text_title ="";
  var imageLoader = document.getElementById('imageLoader');
      imageLoader.addEventListener('change', handleImage, false);
  var canvas = document.getElementById('imageCanvas');
  var ctx = canvas.getContext('2d');

  var canvas_back = document.getElementById('imageCanvasBack');
  var ctx_back = canvas_back.getContext('2d');

  var img = new Image();
  img.crossOrigin="anonymous";

  var img_back = new Image();
  img_back.crossOrigin="anonymous";

  window.addEventListener('load', DrawPlaceholder);

  function wrapText (context, text, x, y, maxWidth, lineHeight) {

      var words = text.split(' '),
          line = '',
          lineCount = 0,
          i,
          test,
          metrics;

      for (i = 0; i < words.length; i++) {
          test = words[i];
          metrics = context.measureText(test);
          while (metrics.width > maxWidth) {
              // Determine how much of the word will fi
              test = test.substring(0, test.length - 1);
              metrics = context.measureText(test);
          }
          if (words[i] != test) {
              words.splice(i + 1, 0,  words[i].substr(test.length))
              words[i] = test;
          }

          test = line + words[i] + ' ';
          metrics = context.measureText(test);

          if (metrics.width > maxWidth && i > 0) {
              context.fillText(line, x, y);
              line = words[i] + ' ';
              y += lineHeight;
              lineCount++;
          }
          else {
              line = test;
          }
      }

      context.fillText(line, x, y);
  }

  function DrawPlaceholder() {
      img.onload = function() {
          DrawOverlay(img);
          DrawText();
          DynamicText(img)
      };
      img.src = 'https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Circle_Picture_2_pre_1.png?v=1739365830';

      img_back.onload = function() {
          DrawOverlayBack(img_back);
      };
      img_back.src = 'https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Own_What_Matters_-_Yellow.png?v=1733403251';
  }

  function DrawOverlay(img) {
      ctx.drawImage(img,0,0,1699,971);
      ctx.fillStyle = 'rgba(30, 144, 255, 0)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
  }
  function DrawOverlayBack(img_back) {
      ctx_back.drawImage(img_back,0,0,1699,971);
      ctx_back.fillStyle = 'rgba(30, 144, 255, 0)';
      ctx_back.fillRect(0, 0, canvas_back.width, canvas_back.height);
  }
  function DrawText() {
      ctx.fillStyle = "#262a82";
      ctx.textBaseline = 'middle';
      ctx.font = "20px 'CircularStd-Bold'";
      ctx.fillText(text_title,20, 130);
  }
  function DynamicText(img) {
    document.getElementById('name').addEventListener('keyup', function() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      DrawOverlay(img);
      DrawText();
      text_title = this.value;
      ctx.fillText(text_title, 20, 130);
    });
  }
  function handleImage(e) {
      var reader = new FileReader();
      var img = "";
      var src = "";
      reader.onload = function(event) {
          img = new Image();
          img.onload = function() {
              canvas.width = img.width;
              canvas.height = img.height;
              ctx.drawImage(img,0,0,1699,971);

          }
          img.src = event.target.result;
          src = event.target.result;
          canvas.classList.add("show");
          DrawText();
          DynamicText(img);
      }

      reader.readAsDataURL(e.target.files[0]);

  }
  function convertToImage() {
  	window.open(canvas.toDataURL('png'));
  }

  $('.product-business-card-hero-banner-section').attr("data-business-card-step",1);

  $(".business_card_type_filter_block .exp-switch-input.exp-switch-input-main").click(function(){
      var get_filter_option_value = $(this).val();
      if(get_filter_option_value == "Standard"){
        $(".customize_your_business_cards_type_selection_section").attr("data-business-card-type-selected","Standard");

          $(".standard_business_card_option input").each(function(){
             $(this).prop("disabled", false);
          });
          $(".team_business_card_option input").each(function(){
             $(this).prop("disabled", true);
          });

              if($("input[name='properties[Standard - Choose front]']:checked").is(':checked') && $("input[name='properties[Standard - Choose back]']:checked").is(':checked')){
                  $(".customize_your_business_cards_type_selection_btn").removeClass("disable_btn");
              }else{
                  $(".customize_your_business_cards_type_selection_btn").addClass("disable_btn");
              }

      }else{
          $(".customize_your_business_cards_type_selection_section").attr("data-business-card-type-selected","Team");

          $(".standard_business_card_option input").each(function(){
             $(this).prop("disabled", true);
          });
          $(".team_business_card_option input").each(function(){
             $(this).prop("disabled", false);
          });

            if($("input[name='properties[Team - Choose front]']:checked").is(':checked') && $("input[name='properties[Team - Choose back]']:checked").is(':checked')){
                $(".customize_your_business_cards_type_selection_btn").removeClass("disable_btn");
            }else{
                $(".customize_your_business_cards_type_selection_btn").addClass("disable_btn");
            }

      }

  });

  $(".business_card_type_standard_filter_block .exp-switch-input").click(function(){
      var get_filter_option_value = $(this).val();
      if(get_filter_option_value == "Team"){
           $("#team").trigger("click");
           $("#standard_filter_block_standard").prop("checked", true);
           $("#standard_filter_block_team").prop("checked", false);

           $("#team_filter_block_team").prop("checked", true);
           $("#team_filter_block_standard").prop("checked", false);
      }
  });

  $(".business_card_type_team_filter_block .exp-switch-input").click(function(){
      var get_filter_option_value = $(this).val();
      if(get_filter_option_value == "Standard"){
            $("#standard").trigger("click");
            $("#team_filter_block_standard").prop("checked", true);
            $("#team_filter_block_team").prop("checked", false);

            $("#standard_filter_block_standard").prop("checked", true);
            $("#standard_filter_block_team").prop("checked", false);
      }
  });

  $(".customize_your_business_cards_type_selection_btn").click(function(){
     var get_filter_option_type = $(".customize_your_business_cards_type_selection_section").attr("data-business-card-type-selected");

      if(get_filter_option_type == "Standard"){
              if($("input[name='properties[Standard - Choose front]']:checked").is(':checked')){
                  var get_front_image = $("input[name='properties[Standard - Choose front]']:checked").closest(".standard-choose_front_option_item").find('.option_image_block').html();
                  $(".product_business-card_media-wrapper .option_image_block_front").html(get_front_image);
                  var get_front_card_type = $("input[name='properties[Standard - Choose front]']:checked").val();
                  if(get_front_card_type == "No Picture"){
                      $(".main_profile_picture").hide();
                      $(".main_profile_picture #file").prop("disabled", true);

                  }else{
                      $(".main_profile_picture").show();
                      $(".main_profile_picture #file").prop("disabled", false);
                  }

                  if(get_front_card_type == "No Picture"){
                      img.src = 'https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_1_HD.jpg?v=1741179367';
                      ctx.clearRect(0, 0, canvas.width, canvas.height);
                      ctx.drawImage(img,0,0,1699,971);
                  }else if(get_front_card_type == "Circle Picture"){
                      img.src = 'https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_2_HD.jpg?v=1741178630';
                      ctx.clearRect(0, 0, canvas.width, canvas.height);
                      ctx.drawImage(img,0,0,1699,971);
                  }else if(get_front_card_type == "Square Picture"){
                      img.src = 'https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_3_HD.jpg?v=1741178991';
                      ctx.clearRect(0, 0, canvas.width, canvas.height);
                      ctx.drawImage(img,0,0,1699,971);
                  }

              }else {
              }

              if($("input[name='properties[Standard - Choose back]']:checked").is(':checked')){
                  var get_back_image = $("input[name='properties[Standard - Choose back]']:checked").closest(".standard-choose_back_option_item").find('.option_image_block').html();
                  var get_back_image_URL = $("input[name='properties[Standard - Choose back]']:checked").closest(".standard-choose_back_option_item").find('.option_image_block img').attr("src");
                  $(".product_business-card_media-wrapper .option_image_block_back").html(get_back_image);

                  img_back.src = get_back_image_URL;
                  ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                  ctx_back.drawImage(img_back,0,0,1699,971);

                  var get_back_card_type = $("input[name='properties[Standard - Choose back]']:checked").val();
                  if(get_back_card_type == "QR - Yellow" || get_back_card_type == "QR - Half Yellow" || get_back_card_type == "QR - Blue" || get_back_card_type == "QR - Half Blue" || get_back_card_type == "QR - Square Yellow" || get_back_card_type == "QR - Square Blue" || get_back_card_type == "QR - Angle Yellow" || get_back_card_type == "QR - Mix Color"){
                      $(".line-item-property_QR_block").show();
                      $(".line-item-property_QR_block input").each(function(){
                          $(this).prop("disabled", false);
                      });
                  }else{
                      $(".line-item-property_QR_block").hide();
                      $(".line-item-property_QR_block input").each(function(){
                          $(this).prop("disabled", true);
                      });
                  }

              }else {
              }

              if($("input[name='properties[Standard - Choose front]']:checked").is(':checked') && $("input[name='properties[Standard - Choose back]']:checked").is(':checked')){
                 $('product-info.main-product-business-card-section').attr("data-business-card-step",2);
                 $('.product-business-card-hero-banner-section').attr("data-business-card-step",2);
              }
      }else{

              if($("input[name='properties[Team - Choose front]']:checked").is(':checked')){
                  var get_front_image = $("input[name='properties[Team - Choose front]']:checked").closest(".team-choose_front_option_item").find('.option_image_block').html();
                  $(".product_business-card_media-wrapper .option_image_block_front").html(get_front_image);

                  var get_front_card_type = $("input[name='properties[Team - Choose front]']:checked").val();
                  if(get_front_card_type == "No Picture"){
                      $(".main_profile_picture").hide();
                      $(".main_profile_picture #file").prop("disabled", true);

                      img.src = 'https://cdn.shopify.com/s/files/1/0597/0978/4112/files/No_Picture_pre_1.png?v=1739446427';
                      ctx.clearRect(0, 0, canvas.width, canvas.height);
                      ctx.drawImage(img,0,0);
                  }else{
                      $(".main_profile_picture").show();
                      $(".main_profile_picture #file").prop("disabled", false);
                  }

                  if(get_front_card_type == "No Picture"){
                      img.src = 'https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_1_HD.jpg?v=1741179367';
                      ctx.clearRect(0, 0, canvas.width, canvas.height);
                      ctx.drawImage(img,0,0,1699,971);
                  }else if(get_front_card_type == "Circle Picture"){
                      img.src = 'https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_2_HD.jpg?v=1741178630';
                      ctx.clearRect(0, 0, canvas.width, canvas.height);
                      ctx.drawImage(img,0,0,1699,971);
                  }else if(get_front_card_type == "Square Picture"){
                      img.src = 'https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_3_HD.jpg?v=1741178991';
                      ctx.clearRect(0, 0, canvas.width, canvas.height);
                      ctx.drawImage(img,0,0,1699,971);
                  }

              }else {
              }

              if($("input[name='properties[Team - Choose back]']:checked").is(':checked')){
                  var get_back_image = $("input[name='properties[Team - Choose back]']:checked").closest(".team-choose_front_option_item").find('.option_image_block').html();
                  var get_back_image_URL = $("input[name='properties[Team - Choose back]']:checked").closest(".team-choose_front_option_item").find('.option_image_block img').attr("src");
                  $(".product_business-card_media-wrapper .option_image_block_back").html(get_back_image);

                  img_back.src = get_back_image_URL;
                  ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                  ctx_back.drawImage(img_back,0,0,1699,971);

                 var get_back_card_type = $("input[name='properties[Team - Choose back]']:checked").val();

                  if(get_back_card_type == "2 Team Circle" || get_back_card_type == "2 Team Square"){
                      $(".team_member_1").show();
                      $(".team_member_1 input").each(function(){
                          $(this).prop("disabled", false);
                      });
                      $(".team_member_2").show();
                      $(".team_member_2 input").each(function(){
                          $(this).prop("disabled", false);
                      });

                      $(".team_member_3").hide();
                      $(".team_member_3 input").each(function(){
                          $(this).prop("disabled", true);
                      });
                      $(".team_member_4").hide();
                      $(".team_member_4 input").each(function(){
                          $(this).prop("disabled", true);
                      });

                  }else if(get_back_card_type == "3 Team Circle" || get_back_card_type == "3 Team Square"){
                      $(".team_member_1").show();
                      $(".team_member_1 input").each(function(){
                          $(this).prop("disabled", false);
                      });
                      $(".team_member_2").show();
                      $(".team_member_2 input").each(function(){
                          $(this).prop("disabled", false);
                      });
                      $(".team_member_3").show();
                      $(".team_member_3 input").each(function(){
                          $(this).prop("disabled", false);
                      });

                      $(".team_member_4").hide();
                      $(".team_member_4 input").each(function(){
                          $(this).prop("disabled", true);
                      });

                  }else if(get_back_card_type == "4 Team Circle" || get_back_card_type == "4 Team Square"){
                      $(".team_member_1").show();
                      $(".team_member_1 input").each(function(){
                          $(this).prop("disabled", false);
                      });
                      $(".team_member_2").show();
                      $(".team_member_2 input").each(function(){
                          $(this).prop("disabled", false);
                      });
                      $(".team_member_3").show();
                      $(".team_member_3 input").each(function(){
                          $(this).prop("disabled", false);
                      });
                      $(".team_member_4").show();
                      $(".team_member_4 input").each(function(){
                          $(this).prop("disabled", false);
                      });
                  }else{
                      $(".team_member_1").hide();
                      $(".team_member_1 input").each(function(){
                          $(this).prop("disabled", true);
                      });
                      $(".team_member_2").hide();
                      $(".team_member_2 input").each(function(){
                          $(this).prop("disabled", true);
                      });
                      $(".team_member_3").hide();
                      $(".team_member_3 input").each(function(){
                          $(this).prop("disabled", true);
                      });
                      $(".team_member_4").hide();
                      $(".team_member_4 input").each(function(){
                          $(this).prop("disabled", true);
                      });
                  }

              }else {
              }

              if($("input[name='properties[Team - Choose front]']:checked").is(':checked') && $("input[name='properties[Team - Choose back]']:checked").is(':checked')){
                  $('product-info.main-product-business-card-section').attr("data-business-card-step",2);
                  $('.product-business-card-hero-banner-section').attr("data-business-card-step",2);
              }

      }

  });

  $(".pro_back_btn").click(function(){
     var get_filter_option_type = $(".customize_your_business_cards_type_selection_section").attr("data-business-card-type-selected");

      if(get_filter_option_type == "Standard"){
              if($("input[name='properties[Standard - Choose front]']:checked").is(':checked')){
              }else {
              }

              if($("input[name='properties[Standard - Choose back]']:checked").is(':checked')){
              }else {
              }

              if($("input[name='properties[Standard - Choose front]']:checked").is(':checked') && $("input[name='properties[Standard - Choose back]']:checked").is(':checked')){
                  $('product-info.main-product-business-card-section').attr("data-business-card-step",1);
                  $('.product-business-card-hero-banner-section').attr("data-business-card-step",1);
              }
      }else{

              if($("input[name='properties[Team - Choose front]']:checked").is(':checked')){
              }else {
              }

              if($("input[name='properties[Team - Choose back]']:checked").is(':checked')){
              }else {
              }

              if($("input[name='properties[Team - Choose front]']:checked").is(':checked') && $("input[name='properties[Team - Choose back]']:checked").is(':checked')){
                  $('product-info.main-product-business-card-section').attr("data-business-card-step",1);
                  $('.product-business-card-hero-banner-section').attr("data-business-card-step",1);
              }
      }

  });

  $(".customize_your_business_cards_type_selection_section .line-item-property__field input").change(function(){
     var get_filter_option_type = $(".customize_your_business_cards_type_selection_section").attr("data-business-card-type-selected");

      if(get_filter_option_type == "Standard"){

              if($("input[name='properties[Standard - Choose front]']:checked").is(':checked') && $("input[name='properties[Standard - Choose back]']:checked").is(':checked')){
                  $(".customize_your_business_cards_type_selection_btn").removeClass("disable_btn");
              }else{
                  $(".customize_your_business_cards_type_selection_btn").addClass("disable_btn");
              }
      }else{

            if($("input[name='properties[Team - Choose front]']:checked").is(':checked') && $("input[name='properties[Team - Choose back]']:checked").is(':checked')){
                $(".customize_your_business_cards_type_selection_btn").removeClass("disable_btn");
            }else{
                $(".customize_your_business_cards_type_selection_btn").addClass("disable_btn");
            }
      }

  });

  $(".product-form_business_card_submit").click(function(){

      var get_address_count = 0;
      var get_phone_number_count = 0;
      var get_blank_phone_number_count = 0;

      var get_email = $("#email").val();

      var get_street = $("#street").val();
      var get_city = $("#city").val();
      var get_state = $("#state").val();
      var get_zip_code = $("#zip-code").val();

      var get_business = $("#business").val();
      var get_main_mobile = $("#main_mobile").val();
      var get_fax = $("#fax").val();

     if($.trim(get_city).length) {
         $("#city").removeClass("error_input");
         get_address_count = get_address_count + 1;
     }else{
         $("#city").addClass("error_input");
     }

     if($.trim(get_state).length) {
         $("#state").removeClass("error_input");
         get_address_count = get_address_count + 1;
     }else{
         $("#state").addClass("error_input");
     }

     if($.trim(get_zip_code).length) {
         $("#zip-code").removeClass("error_input");
         get_address_count = get_address_count + 1;
     }else{
         $("#zip-code").addClass("error_input");
     }

    if($("input[name='properties[Office #]']").is(':disabled')){
        get_blank_phone_number_count = get_blank_phone_number_count + 1;
        $("#business").removeClass("error_input");
    }else{
        if($.trim(get_business).length) {
            $("#business").removeClass("error_input");
            get_phone_number_count = get_phone_number_count + 1;
        }else{
            $("#business").addClass("error_input");
        }
    }

    if($("input[name='properties[Mobile #]']").is(':disabled')){
        get_blank_phone_number_count = get_blank_phone_number_count + 1;
        $("#main_mobile").removeClass("error_input");
    }else{
        if($.trim(get_main_mobile).length) {
            $("#main_mobile").removeClass("error_input");
            get_phone_number_count = get_phone_number_count + 1;
        }else{
            $("#main_mobile").addClass("error_input");
        }
    }

    if($("input[name='properties[Fax #]']").is(':disabled')){
        get_blank_phone_number_count = get_blank_phone_number_count + 1;
        $("#fax").removeClass("error_input");
    }else{
        if($.trim(get_fax).length) {
            $("#fax").removeClass("error_input");
            get_phone_number_count = get_phone_number_count + 1;
        }else{
            if($('#line-item_switch-rounded-fax-include').is(':checked')){
                $("#fax").addClass("error_input");
            }else{
                $("#fax").removeClass("error_input");
            }

        }
    }

    if(get_phone_number_count >=1 && get_address_count == 3){
        $(".product-form form .product-form__buttons .product-form__submit").trigger("click");
    }else if(get_blank_phone_number_count >=1 && get_address_count == 3){
        $(".product-form form .product-form__buttons .product-form__submit").trigger("click");
    }else{

        if($.trim(get_email).length) {
            $('html, body').animate({
                scrollTop: $("#email").offset().top
            }, 2000);
            $(".customize_search_bottom_panel .search-form-inner-block").removeClass("error_input");
        }else{
            $('html, body').animate({
                scrollTop: $(".product_page_customize_business_card_section").offset().top
            }, 2000);

            $(".customize_search_bottom_panel .search-form-inner-block").addClass("error_input");
        }

    }

  });

  function applyQrCode() {
    $('#qr .bg canvas')[0].toBlob((blob) => {
      const file = new File([blob], "officer-url.png", {type: blob.type} );
      const transfer = new DataTransfer();
      transfer.items.add(file);
      $('#qr_code_file_upload')[0].files = transfer.files;
    });
  }

  function applyFrontCardPreview() {
    $('#imageCanvas')[0].toBlob((blob) => {
      const file = new File([blob], "front_business_card_preview_file_upload.png", {type: blob.type} );
      const transfer = new DataTransfer();
      transfer.items.add(file);
      $('#front_business_card_preview_file_upload')[0].files = transfer.files;
    });
  }

  function applyBackCardPreview() {
    $('#imageCanvasBack')[0].toBlob((blob) => {
      const file = new File([blob], "back_business_card_preview_file_upload.png", {type: blob.type} );
      const transfer = new DataTransfer();
      transfer.items.add(file);
      $('#back_business_card_preview_file_upload')[0].files = transfer.files;
    });
  }

  function generateQrCode() {
    const qrUrl = $('#qrUrl').val();
    if (URL.canParse(qrUrl)) {
      $('#qr .bg').empty().qrcode({
          width: $('#qrWidth').val(),
          height: $('#qrHeight').val(),
          color: $('#qrColor').val(),
          bgColor: $('#qrBgColor').val(),
          text: qrUrl
      });
      $('#qr .bg').css({ background: $('#qrBgColor').val()});
      applyQrCode();
    } else {
      $('#qr .bg').empty();
      $('#qr_code_file_upload').val('');
    }
  }

  $('#generate').click(generateQrCode);

  function download(canvas, filename) {
        var canvas = document.getElementById('canvas');
        var lnk = document.createElement('a'), e;

        lnk.download = filename;

        lnk.href = canvas.toDataURL("image/png;base64");

        if (document.createEvent) {
            e = document.createEvent("MouseEvents");
            e.initMouseEvent("click", true, true, window,
                0, 0, 0, 0, 0, false, false, false,
                false, 0, null);

            lnk.dispatchEvent(e);
        } else if (lnk.fireEvent) {
            lnk.fireEvent("onclick");
        }
    }

    $('.qr-png-download').on('click', function (){
        $('canvas').attr('id', 'canvas');
         var canvas = document.getElementById('canvas');
      download(canvas, 'qrcode.png')

    });

    $('#is-some-information-incorrect-or-missing').on('change', function (){
         var get_line_item_switch_value = $(this).val();
        if($(this).is(':checked')){
          $(this).closest(".customize_additional_information_section").addClass("active_message_box");
          $(this).closest(".customize_additional_information_section").find("textarea").prop("disabled", false);
          $(this).closest(".customize_additional_information_section").find(".line-item-property_some_information_field").slideDown();
        }else {
          $(this).closest(".customize_additional_information_section").removeClass("active_message_box");
          $(this).closest(".customize_additional_information_section").find("textarea").prop("disabled", true);
          $(this).closest(".customize_additional_information_section").find(".line-item-property_some_information_field").slideUp();
        }
    });

    $('.line-item_include_switch input').on('change', function (){
         var get_line_item_switch_value = $(this).val();
        if($(this).is(':checked')){
          $(this).closest(".line-item_switch").addClass("active_toggle");
          $(this).closest(".line-item_switch").find(".line-item_switch_label").html("Include");
          $(this).closest(".line-item-property_include_switch_field").find("input[type='text']").prop("disabled", false);
        }else {
          $(this).closest(".line-item_switch").removeClass("active_toggle");
          $(this).closest(".line-item_switch").find(".line-item_switch_label").html("Don’t include");
          $(this).closest(".line-item-property_include_switch_field").find("input[type='text']").prop("disabled", true);
        }
    });

    $('.line-item_address_toggle_switch input').on('change', function (){
         var get_line_item_switch_value = $(this).val();
        if($(this).is(':checked')){
          $(this).closest(".line-item_switch").addClass("active_toggle");
          $("#street").removeClass("input_lock_field");
          $("#street").closest(".line-item-property__field").addClass("disable_input_lock_field");

          $("#city").removeClass("input_lock_field");
          $("#city").closest(".line-item-property__field_column").addClass("disable_input_lock_field");

          $("#state").removeClass("input_lock_field");
          $("#state").closest(".line-item-property__field_column").addClass("disable_input_lock_field");

          $("#zip-code").removeClass("input_lock_field");
          $("#zip-code").closest(".line-item-property__field_column").addClass("disable_input_lock_field");
        }else {
          $(this).closest(".line-item_switch").removeClass("active_toggle");
          $("#street").addClass("input_lock_field");
          $("#street").closest(".line-item-property__field").removeClass("disable_input_lock_field");
          $("#street").val($("#street").attr("data-street"));

          $("#city").addClass("input_lock_field");
          $("#city").closest(".line-item-property__field_column").removeClass("disable_input_lock_field");
          $("#city").val($("#city").attr("data-city"));

          $("#state").addClass("input_lock_field");
          $("#state").closest(".line-item-property__field_column").removeClass("disable_input_lock_field");
          $("#state").val($("#state").attr("data-state"));

          $("#zip-code").addClass("input_lock_field");
          $("#zip-code").closest(".line-item-property__field_column").removeClass("disable_input_lock_field");
          $("#zip-code").val($("#zip-code").attr("data-zip-code"));
        }
    });

    $('.line-item_business_toggle_switch input').on('change', function (){
         var get_line_item_switch_value = $(this).val();
        if($(this).is(':checked')){
          $(this).closest(".line-item_switch").addClass("active_toggle");
          $("#business").removeClass("input_lock_field");
          $("#business").closest(".line-item-property__field_column").addClass("disable_input_lock_field");
          $("#business").prop("disabled", false);
        }else {
          $(this).closest(".line-item_switch").removeClass("active_toggle");
          $("#business").addClass("input_lock_field");
          $("#business").closest(".line-item-property__field_column").removeClass("disable_input_lock_field");
          $("#business").val($("#business").attr("data-business"));
        }
    });

    $('.line-item_mobile_toggle_switch input').on('change', function (){
         var get_line_item_switch_value = $(this).val();
        if($(this).is(':checked')){
          $(this).closest(".line-item_switch").addClass("active_toggle");
          $("#main_mobile").removeClass("input_lock_field");
          $("#main_mobile").closest(".line-item-property__field_column").addClass("disable_input_lock_field");
          $("#main_mobile").prop("disabled", false);
        }else {
          $(this).closest(".line-item_switch").removeClass("active_toggle");
          $("#main_mobile").addClass("input_lock_field");
          $("#main_mobile").closest(".line-item-property__field_column").removeClass("disable_input_lock_field");
          $("#main_mobile").val($("#main_mobile").attr("data-main-mobile"));
        }
    });

    $('.line-item_fax_toggle_switch input').on('change', function (){
         var get_line_item_switch_value = $(this).val();
        if($(this).is(':checked')){
          $(this).closest(".line-item_switch").addClass("active_toggle");
          $("#fax").removeClass("input_lock_field");
          $("#fax").closest(".line-item-property__field_column").addClass("disable_input_lock_field");
          $("#fax").prop("disabled", false);
        }else {
          $(this).closest(".line-item_switch").removeClass("active_toggle");
          $("#fax").addClass("input_lock_field");
          $("#fax").closest(".line-item-property__field_column").removeClass("disable_input_lock_field");
          $("#fax").val($("#fax").attr("data-fax"));
        }
    });

// Select all links with hashes
$('.back_to_top_btn')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
      &&
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });

  $('.customize_search_bottom_panel .search-text').on('keyup', function (){
      var get_input_search_value = $(this).val();
      if(get_input_search_value.length >=2){
          fetch("/apps/konnect/search/users?query="+get_input_search_value)
              .then(res => res.json()
                  .then(json => {
                    $(this).closest(".customize_search_bottom_panel").find(".search-form-results-html").empty();
                    for (var i = 0; i < json.length; i++) {
                        if ( typeof(json[i].mail) !== "undefined" && json[i].mail !== null ){
                            $(this).closest(".customize_search_bottom_panel").find(".search-form-results-html").append('<div class="search_item_block" data-search-item-id="'+json[i].id+'"><div class="search_item_info_block"><div class="search_item_info_title"><strong>'+json[i].displayName+'</strong><span>, '+json[i].jobTitle+'</span></div><div class="search_item_info_email">'+json[i].mail+'</div></div><div class="search_item_btn_block"><button type="button" class="button search_item_btn" data-search-item-id="'+json[i].id+'">Select</button></div></div>');
                        }
                    }
                    if(json.length <=0){
                      $(this).closest(".customize_front_form_inputes").find(".import_incorrect_data").css("display","flex");
                    }else{
                      $(this).closest(".customize_front_form_inputes").find(".import_incorrect_data").css("display","none");
                    }
                  }));
      }

  });

  $('.customize_search_bottom_panel .search-button').on('click', function (){
      var get_input_search_value = $(this).closest(".customize_search_bottom_panel").find(".search-text").val();
      if(get_input_search_value.length >=2){
          fetch("/apps/konnect/search/users?query="+get_input_search_value)
              .then(res => res.json()
                  .then(json => {
                    $(this).closest(".customize_search_bottom_panel").find(".search-form-results-html").empty();
                    for (var i = 0; i < json.length; i++) {
                        if ( typeof(json[i].mail) !== "undefined" && json[i].mail !== null ){
                            $(this).closest(".customize_search_bottom_panel").find(".search-form-results-html").append('<div class="search_item_block" data-search-item-id="'+json[i].id+'"><div class="search_item_info_block"><div class="search_item_info_title"><strong>'+json[i].displayName+'</strong><span>, '+json[i].jobTitle+'</span></div><div class="search_item_info_email">'+json[i].mail+'</div></div><div class="search_item_btn_block"><button type="button" class="button search_item_btn" data-search-item-id="'+json[i].id+'">Select</button></div></div>');
                        }
                    }
                    if(json.length <=0){
                      $(this).closest(".customize_front_form_inputes").find(".import_incorrect_data").css("display","flex");
                    }else{
                      $(this).closest(".customize_front_form_inputes").find(".import_incorrect_data").css("display","none");
                    }

                  }));
      }

  });

  $('#qrUrl').on('keyup', generateQrCode);

  $('.customize_your_business_cards_information_section .customize_front_form_inputes .customize_search_bottom_panel .search-clear').on('click', function (){

        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #first-name").val("");
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #last-name").val("");
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #job-title").val("");
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #email").val("");
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #main_mobile").val("");
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #fax").val("");

        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #street").val("");

        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #city").val("");
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #state").val("");
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #zip-code").val("");
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #business").val("");
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #loan-officer-nmls").val("");
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #qrUrl").val("");
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes #custom-url").prop("checked", false);
        $(this).closest(".customize_your_business_cards_information_section").find(".customize_front_form_inputes  #qrUrl").attr("data-officer-url","");

        $(this).closest(".customize_search_bottom_panel").find(".search-form-results-html").empty();
        $(this).closest(".customize_search_bottom_panel").find(".search-text").val("");
        $(this).closest(".customize_front_form_inputes").find(".import_incorrect_data").css("display","none");

  });

  $(document).on("click",".customize_front_section .customize_search_bottom_panel .search-form-results-html .search_item_block",function() {

        var get_profile_id = $(this).attr("data-search-item-id");
          fetch("/apps/konnect/users/"+get_profile_id)
              .then(res => res.json()
                  .then(profile_json => {
                    $(this).closest(".product_page_customize_business_card_section").find("#first-name").val(profile_json.givenName);
                    $(this).closest(".product_page_customize_business_card_section").find("#last-name").val(profile_json.surname);
                    $(this).closest(".product_page_customize_business_card_section").find("#job-title").val(profile_json.jobTitle);
                    $(this).closest(".product_page_customize_business_card_section").find("#email").val(profile_json.mail);

                    $(this).closest(".product_page_customize_business_card_section").find("#main_mobile").val(profile_json.mobilePhone);
                    $(this).closest(".product_page_customize_business_card_section").find("#main_mobile").attr("data-main-mobile",profile_json.mobilePhone);

                    $(this).closest(".product_page_customize_business_card_section").find("#fax").val(profile_json.faxNumber);
                    $(this).closest(".product_page_customize_business_card_section").find("#fax").attr("data-fax",profile_json.faxNumber);

                    if(profile_json.streetAddress == null){
                        $(this).closest(".product_page_customize_business_card_section").find("#street").val(profile_json.officeLocation);
                        $(this).closest(".product_page_customize_business_card_section").find("#street").attr("data-street",profile_json.officeLocation);
                    }else{
                        $(this).closest(".product_page_customize_business_card_section").find("#street").val(profile_json.streetAddress);
                        $(this).closest(".product_page_customize_business_card_section").find("#street").attr("data-street",profile_json.streetAddress);
                    }

                    $(this).closest(".product_page_customize_business_card_section").find("#city").val(profile_json.city);
                    $(this).closest(".product_page_customize_business_card_section").find("#state").val(profile_json.state);
                    $(this).closest(".product_page_customize_business_card_section").find("#zip-code").val(profile_json.postalCode);

                    $(this).closest(".product_page_customize_business_card_section").find("#city").attr("data-city",profile_json.city);
                    $(this).closest(".product_page_customize_business_card_section").find("#state").attr("data-state",profile_json.state);
                    $(this).closest(".product_page_customize_business_card_section").find("#zip-code").attr("data-zip-code",profile_json.postalCode);

                    $(this).closest(".product_page_customize_business_card_section").find("#business").val(profile_json.businessPhones);
                    $(this).closest(".product_page_customize_business_card_section").find("#business").attr("data-business",profile_json.businessPhones);

                    $(this).closest(".product_page_customize_business_card_section").find("#loan-officer-nmls").val(profile_json.nlmsNumber);
                    $(this).closest(".product_page_customize_business_card_section").find("#qrUrl").val(profile_json.officerUrl);
                    $(this).closest(".product_page_customize_business_card_section").find("#qrUrl").attr("data-officer-url",profile_json.officerUrl);
                    $(this).closest(".product_page_customize_business_card_section").find("#custom-url").prop("checked", false);

                    let licensedStates = "";
                    if (profile_json.licensedStates) {
                      licensedStates = profile_json.licensedStates.join(", ");
                      if (profile_json.licensedStates.length > 1) {
                        const last = licensedStates.lastIndexOf(", ");
                        licensedStates = `${licensedStates.slice(0, last)} and ${licensedStates.slice(last + 2)}`;
                      }
                    }
                    $(this).closest(".product_page_customize_business_card_section").find("#licensed-in-ex-nc-and-va").val(licensedStates);

                    $(this).closest(".customize_search_bottom_panel").find(".search-text").val("");
                    $(this).closest(".customize_front_form_inputes").find(".import_incorrect_data").css("display","none");
                    $(this).closest(".customize_search_bottom_panel").find(".search-form-results-html").empty();

                    generateQrCode();

                    var get_front_card_type = $("input[name='properties[Standard - Choose front]']:checked").val();
                    DrawOverlay(img);

                 var get_filter_option_type = $(".customize_your_business_cards_type_selection_section").attr("data-business-card-type-selected");

                  if(get_filter_option_type == "Standard"){

                          var get_front_card_type = $("input[name='properties[Standard - Choose front]']:checked").val();

                          if(get_front_card_type == "No Picture"){
                              img.src = 'https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_1_HD_blank.jpg?v=1741181203';
                              ctx.clearRect(0, 0, canvas.width, canvas.height);
                              ctx.drawImage(img,0,0,1699,971);

                              setTimeout(function(){

                                  var text_name_title = profile_json.givenName + " "+ profile_json.surname;
                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "80px 'CircularStd-Bold'";

                                  if ( typeof(text_name_title) !== "undefined" && text_name_title !== null ){
                                      ctx.fillText(text_name_title, 60, 380);
                                  }else{
                                      ctx.fillText("-", 60, 380);
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "50px 'CircularStd-Bold'";

                                  var text_job_NMLS_id = "NMLS ID "+ profile_json.nlmsNumber;
                                  if ( typeof(text_job_NMLS_id) !== "undefined" && profile_json.nlmsNumber !== null ){
                                      if ( typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                          var text_job_title = profile_json.jobTitle + " | NMLS ID "+ profile_json.nlmsNumber;
                                          ctx.fillText(text_job_title, 60, 480);
                                      }else{
                                          var text_job_title = profile_json.jobTitle ;
                                          ctx.fillText(text_job_title, 60, 480);
                                      }
                                  }else{
                                      var text_job_title = profile_json.jobTitle + " | NMLS ID - ";
                                      ctx.fillText(text_job_title, 60, 480);
                                  }

                                  ctx.fillStyle = "#994396";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "48px 'CircularStd-Medium'";
                                  if ( typeof(profile_json.mail) !== "undefined" && profile_json.mail !== null ){
                                      ctx.fillText(profile_json.mail, 60, 545);
                                  }else{
                                      ctx.fillText(" - ", 60, 545);
                                  }

                                  var get_faxNumber = profile_json.faxNumber;
                                  var get_mobileNumber = profile_json.mobilePhone;
                                  var get_businessNumber = profile_json.businessPhones;

                                  var arr_card_contact_number = [];

                                  // append new value to the array
                                  if ( typeof(profile_json.faxNumber) !== "undefined" && profile_json.faxNumber !== null ){
                                      let obj_contact = { name: "faxNumber", value: profile_json.faxNumber };
                                      arr_card_contact_number.push(obj_contact);
                                  }
                                  if ( typeof(profile_json.mobilePhone) !== "undefined" && profile_json.mobilePhone !== null ){
                                      let obj_contact = { name: "mobilePhone", value: profile_json.mobilePhone };
                                      arr_card_contact_number.push(obj_contact);
                                  }

                                  if ( typeof(profile_json.businessPhones) !== "undefined" && profile_json.businessPhones !== null && profile_json.businessPhones.length != 0 ){
                                      let obj_contact = { name: "businessPhones", value: profile_json.businessPhones };
                                      arr_card_contact_number.push(obj_contact);
                                  }

                                  if(arr_card_contact_number.length > 0){
                                        for (var i = 0; i < arr_card_contact_number.length; i++) {
                                            var text_label_number = "";
                                            var get_value_Number = "";
                                            if(arr_card_contact_number[i].name == "faxNumber"){
                                                text_label_number = "F ";
                                                get_value_Number = arr_card_contact_number[i].value;
                                            }
                                            if(arr_card_contact_number[i].name == "mobilePhone"){
                                                text_label_number = "M ";
                                                get_value_Number = arr_card_contact_number[i].value;
                                            }
                                            if(arr_card_contact_number[i].name == "businessPhones"){
                                                text_label_number = "O ";
                                                get_value_Number = arr_card_contact_number[i].value;
                                            }

                                            if (i == 0){
                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Bold'";
                                                ctx.fillText(text_label_number, 60, 620);

                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Book'";
                                                ctx.fillText(get_value_Number, 115, 620);
                                            }

                                            if (i == 1){
                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Bold'";
                                                ctx.fillText(text_label_number, 60, 690);

                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Book'";
                                                ctx.fillText(get_value_Number, 115, 690);
                                            }

                                            if (i == 2){
                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Bold'";
                                                ctx.fillText(text_label_number, 60, 760);

                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Book'";
                                                ctx.fillText(get_value_Number, 115, 760);
                                            }

                                        }
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "50px 'CircularStd-Book'";
                                  var text_upper_address = profile_json.streetAddress;

                                  if ( typeof(text_upper_address) !== "undefined" && text_upper_address !== null ){
                                  }else{
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "50px 'CircularStd-Book'";
                                  var text_lower_address = " ";
                                  var text_lower_address_city = profile_json.city;
                                  var text_lower_address_state = profile_json.state;
                                  var text_lower_address_postalCode = profile_json.postalCode;

                                  if ( typeof(text_upper_address) !== "undefined" && text_upper_address !== null ){
                                      text_lower_address = text_upper_address +", ";
                                  }else{
                                      text_lower_address = " ";
                                  }

                                  if ( typeof(text_lower_address_city) !== "undefined" && text_lower_address_city !== null ){
                                      text_lower_address = text_lower_address + text_lower_address_city +", ";
                                  }else{
                                      text_lower_address = text_lower_address + " ";
                                  }
                                  if ( typeof(text_lower_address_state) !== "undefined" && text_lower_address_state !== null ){
                                      text_lower_address = text_lower_address + text_lower_address_state +", ";
                                  }else{
                                      text_lower_address = text_lower_address + " ";
                                  }

                                  if ( typeof(text_lower_address_postalCode) !== "undefined" && text_lower_address_postalCode !== null ){
                                      text_lower_address = text_lower_address + text_lower_address_postalCode;
                                  }else{
                                      text_lower_address = text_lower_address + " ";
                                  }

                                  if ( typeof(text_lower_address) !== "undefined" && text_lower_address !== null ){
                                      wrapText(ctx, text_lower_address, 480, 620, 670, 75);
                                  }else{
                                      ctx.fillText(" - ", 480, 620);
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "42px 'CircularStd-Book'";
                                  var text_company_nmls_text = "Company NMLS ID 3274, Equal Housing Opportunity.";
                                  ctx.fillText(text_company_nmls_text, 60, 880);

                              },500);

                          }else if(get_front_card_type == "Circle Picture"){
                              img.src = 'https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_2_HD_blank_B.jpg?v=1746442711';
                              ctx.clearRect(0, 0, canvas.width, canvas.height);
                              ctx.drawImage(img,0,0,1699,971);

                              setTimeout(function(){

                                  var text_name_title = profile_json.givenName + " "+ profile_json.surname;
                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "80px 'CircularStd-Bold'";

                                  if ( typeof(text_name_title) !== "undefined" && text_name_title !== null ){
                                      ctx.fillText(text_name_title, 60, 270);
                                  }else{
                                      ctx.fillText("-", 60, 270);
                                  }

                                  ctx.fillStyle = "#01b5f0";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "50px 'CircularStd-Bold'";

                                  var text_job_title = profile_json.jobTitle;

                                  if ( typeof(text_job_title) !== "undefined" && text_job_title !== null ){

                                      if(text_job_title.length > 43){
                                          wrapText(ctx, text_job_title, 60, 360, 800, 45);

                                          ctx.fillStyle = "#262a82";
                                          ctx.textBaseline = 'middle';
                                          ctx.font = "50px 'CircularStd-Bold'";

                                          var text_job_NMLS_id = "NMLS ID "+ profile_json.nlmsNumber;
                                          if ( typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                              ctx.fillText(text_job_NMLS_id, 60, 459);
                                          }else{
                                              ctx.fillText("NMLS ID - ", 60, 459);
                                          }

                                      }else{
                                          ctx.fillText(text_job_title, 60, 360);

                                          ctx.fillStyle = "#262a82";
                                          ctx.textBaseline = 'middle';
                                          ctx.font = "50px 'CircularStd-Bold'";

                                          var text_job_NMLS_id = "NMLS ID "+ profile_json.nlmsNumber;
                                          if ( typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                              ctx.fillText(text_job_NMLS_id, 60, 430);
                                          }else{
                                              ctx.fillText("NMLS ID - ", 60, 430);
                                          }

                                      }

                                  }else{
                                      ctx.fillStyle = "#262a82";
                                      ctx.textBaseline = 'middle';
                                      ctx.font = "50px 'CircularStd-Bold'";

                                      var text_job_NMLS_id = "NMLS ID "+ profile_json.nlmsNumber;
                                      if ( typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                          ctx.fillText(text_job_NMLS_id, 60, 430);
                                      }else{
                                          ctx.fillText("NMLS ID - ", 60, 430);
                                      }
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "48px 'CircularStd-Medium'";
                                  if ( typeof(profile_json.mail) !== "undefined" && profile_json.mail !== null ){
                                      ctx.fillText(profile_json.mail, 60, 545);
                                  }else{
                                      ctx.fillText(" - ", 60, 545);
                                  }

                                  var arr_card_contact_number = [];

                                  // append new value to the array
                                  if ( typeof(profile_json.faxNumber) !== "undefined" && profile_json.faxNumber !== null ){
                                      let obj_contact = { name: "faxNumber", value: profile_json.faxNumber };
                                      arr_card_contact_number.push(obj_contact);
                                  }
                                  if ( typeof(profile_json.mobilePhone) !== "undefined" && profile_json.mobilePhone !== null ){
                                      let obj_contact = { name: "mobilePhone", value: profile_json.mobilePhone };
                                      arr_card_contact_number.push(obj_contact);
                                  }

                                  if ( typeof(profile_json.businessPhones) !== "undefined" && profile_json.businessPhones !== null && profile_json.businessPhones.length != 0 ){
                                      let obj_contact = { name: "businessPhones", value: profile_json.businessPhones };
                                      arr_card_contact_number.push(obj_contact);
                                  }

                                  if(arr_card_contact_number.length > 0){
                                        for (var i = 0; i < arr_card_contact_number.length; i++) {
                                            var text_label_number = "";
                                            var get_value_Number = "";
                                            if(arr_card_contact_number[i].name == "faxNumber"){
                                                text_label_number = "F ";
                                                get_value_Number = arr_card_contact_number[i].value;
                                            }
                                            if(arr_card_contact_number[i].name == "mobilePhone"){
                                                text_label_number = "M ";
                                                get_value_Number = arr_card_contact_number[i].value;
                                            }
                                            if(arr_card_contact_number[i].name == "businessPhones"){
                                                text_label_number = "O ";
                                                get_value_Number = arr_card_contact_number[i].value;
                                            }

                                            if (i == 0){
                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Bold'";
                                                ctx.fillText(text_label_number, 60, 620);

                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Book'";
                                                ctx.fillText(get_value_Number, 115, 620);
                                            }

                                            if (i == 1){
                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Bold'";
                                                ctx.fillText(text_label_number, 60, 690);

                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Book'";
                                                ctx.fillText(get_value_Number, 115, 690);
                                            }

                                            if (i == 2){
                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Bold'";
                                                ctx.fillText(text_label_number, 60, 760);

                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Book'";
                                                ctx.fillText(get_value_Number, 115, 760);
                                            }

                                        }
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "50px 'CircularStd-Book'";
                                  var text_upper_address = profile_json.streetAddress;

                                  if ( typeof(text_upper_address) !== "undefined" && text_upper_address !== null ){
                                  }else{
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "50px 'CircularStd-Book'";
                                  var text_lower_address = " ";
                                  var text_lower_address_city = profile_json.city;
                                  var text_lower_address_state = profile_json.state;
                                  var text_lower_address_postalCode = profile_json.postalCode;

                                  if ( typeof(text_upper_address) !== "undefined" && text_upper_address !== null ){
                                      text_lower_address = text_upper_address +", ";
                                  }else{
                                      text_lower_address = " ";
                                  }

                                  if ( typeof(text_lower_address_city) !== "undefined" && text_lower_address_city !== null ){
                                      text_lower_address = text_lower_address + text_lower_address_city +", ";
                                  }else{
                                      text_lower_address = text_lower_address + " ";
                                  }
                                  if ( typeof(text_lower_address_state) !== "undefined" && text_lower_address_state !== null ){
                                      text_lower_address = text_lower_address + text_lower_address_state +", ";
                                  }else{
                                      text_lower_address = text_lower_address + " ";
                                  }

                                  if ( typeof(text_lower_address_postalCode) !== "undefined" && text_lower_address_postalCode !== null ){
                                      text_lower_address = text_lower_address + text_lower_address_postalCode;
                                  }else{
                                      text_lower_address = text_lower_address + " ";
                                  }

                                  if ( typeof(text_lower_address) !== "undefined" && text_lower_address !== null ){
                                      wrapText(ctx, text_lower_address, 480, 620, 670, 75);
                                  }else{
                                      ctx.fillText(" - ", 480, 620);
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "42px 'CircularStd-Book'";
                                  var text_company_nmls_text = "Company NMLS ID 3274, Equal Housing Opportunity.";
                                  ctx.fillText(text_company_nmls_text, 60, 880);

                              },500);

                          }else if(get_front_card_type == "Square Picture"){
                              img.src = 'https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_3_HD_blankB_3.jpg?v=1751628418';

                              ctx.clearRect(0, 0, canvas.width, canvas.height);
                              ctx.drawImage(img,0,0,1699,971);

                              setTimeout(function(){

                                  var text_name_title = profile_json.givenName + " "+ profile_json.surname;
                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "80px 'CircularStd-Bold'";

                                  if ( typeof(text_name_title) !== "undefined" && text_name_title !== null ){
                                      ctx.fillText(text_name_title, 60, 400);
                                  }else{
                                      ctx.fillText("-", 60, 400);
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "50px 'CircularStd-Bold'";

                                  var text_job_NMLS_id = "NMLS ID "+ profile_json.nlmsNumber;
                                  if ( typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                      var text_job_title = profile_json.jobTitle + " | NMLS ID "+ profile_json.nlmsNumber;
                                      ctx.fillText(text_job_title, 60, 480);

                                      if(text_job_title.length > 45){

                                      }else{

                                      }

                                  }else{
                                      var text_job_title = profile_json.jobTitle + " ";
                                      ctx.fillText(text_job_title, 60, 480);
                                  }

                                  ctx.fillStyle = "#994396";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "48px 'CircularStd-Medium'";
                                  if ( typeof(profile_json.mail) !== "undefined" && profile_json.mail !== null ){
                                      ctx.fillText(profile_json.mail, 60, 545);
                                  }else{
                                  }

                                  var arr_card_contact_number = [];

                                  // append new value to the array
                                  if ( typeof(profile_json.faxNumber) !== "undefined" && profile_json.faxNumber !== null ){
                                      let obj_contact = { name: "faxNumber", value: profile_json.faxNumber };
                                      arr_card_contact_number.push(obj_contact);
                                  }
                                  if ( typeof(profile_json.mobilePhone) !== "undefined" && profile_json.mobilePhone !== null ){
                                      let obj_contact = { name: "mobilePhone", value: profile_json.mobilePhone };
                                      arr_card_contact_number.push(obj_contact);
                                  }

                                  if ( typeof(profile_json.businessPhones) !== "undefined" && profile_json.businessPhones !== null && profile_json.businessPhones.length != 0 ){
                                      let obj_contact = { name: "businessPhones", value: profile_json.businessPhones };
                                      arr_card_contact_number.push(obj_contact);
                                  }

                                  if(arr_card_contact_number.length > 0){
                                        for (var i = 0; i < arr_card_contact_number.length; i++) {
                                            var text_label_number = "";
                                            var get_value_Number = "";
                                            if(arr_card_contact_number[i].name == "faxNumber"){
                                                text_label_number = "F ";
                                                get_value_Number = arr_card_contact_number[i].value;
                                            }
                                            if(arr_card_contact_number[i].name == "mobilePhone"){
                                                text_label_number = "M ";
                                                get_value_Number = arr_card_contact_number[i].value;
                                            }
                                            if(arr_card_contact_number[i].name == "businessPhones"){
                                                text_label_number = "O ";
                                                get_value_Number = arr_card_contact_number[i].value;
                                            }

                                            if (i == 0){
                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Bold'";
                                                ctx.fillText(text_label_number, 60, 620);

                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Book'";
                                                ctx.fillText(get_value_Number, 115, 620);
                                            }

                                            if (i == 1){
                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Bold'";
                                                ctx.fillText(text_label_number, 60, 690);

                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Book'";
                                                ctx.fillText(get_value_Number, 115, 690);
                                            }

                                            if (i == 2){
                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Bold'";
                                                ctx.fillText(text_label_number, 60, 760);

                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Book'";
                                                ctx.fillText(get_value_Number, 115, 760);
                                            }

                                        }
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "50px 'CircularStd-Book'";

                                  var text_lower_address = " ";

                                  var text_upper_address = profile_json.streetAddress;

                                  if ( typeof(text_upper_address) !== "undefined" && text_upper_address !== null ){
                                      text_lower_address = text_upper_address +", ";
                                  }else{
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "50px 'CircularStd-Book'";

                                  var text_lower_address_city = profile_json.city;
                                  var text_lower_address_state = profile_json.state;
                                  var text_lower_address_postalCode = profile_json.postalCode;

                                  if ( typeof(text_lower_address_city) !== "undefined" && text_lower_address_city !== null ){
                                      text_lower_address = text_lower_address + text_lower_address_city +", ";
                                  }else{
                                      text_lower_address = " ";
                                  }
                                  if ( typeof(text_lower_address_state) !== "undefined" && text_lower_address_state !== null ){
                                      text_lower_address = text_lower_address + text_lower_address_state +", ";
                                  }else{
                                      text_lower_address = text_lower_address + " ";
                                  }

                                  if ( typeof(text_lower_address_postalCode) !== "undefined" && text_lower_address_postalCode !== null ){
                                      text_lower_address = text_lower_address + text_lower_address_postalCode;
                                  }else{
                                      text_lower_address = text_lower_address + " ";
                                  }

                                  if ( typeof(text_lower_address) !== "undefined" && text_lower_address !== null ){
                                      wrapText(ctx, text_lower_address, 480, 620, 640, 75);
                                  }else{
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "42px 'CircularStd-Book'";
                                  var text_company_nmls_text = "Company NMLS ID 3274, Equal Housing Opportunity.";
                                  ctx.fillText(text_company_nmls_text, 60, 880);

                              },500);

                          }

                          var get_back_card_type = $("input[name='properties[Standard - Choose back]']:checked").val();

                          if(get_back_card_type == "Own What Matters - Yellow"){

                              img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Own_What_Matters_-_Yellow_pre_1.jpg?v=1739543587";
                              ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                              ctx_back.drawImage(img_back,0,0,1600,922);

                              setTimeout(function(){

                                  ctx_back.fillStyle = "#262a82";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.textAlign = "center";
                                  ctx_back.font = "50px 'CircularStd-Bold'";

                                  var get_officer_url_split = profile_json.officerUrl;

                                  if(get_officer_url_split.indexOf("www.") != -1){
                                      var text_Officer_URL_text = get_officer_url_split.split("www.");
                                      ctx_back.fillText(text_Officer_URL_text[1], 850, 600);
                                  }

                                  ctx_back.fillStyle = "#262a82";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.textAlign = "center";
                                  ctx_back.font = "50px 'CircularStd-Bold'";
                                  var text_Officer_Licensed_text = "Licensed in State(s) option";

                                  if ( typeof(profile_json.licensedStates) !== "undefined" && profile_json.licensedStates !== null ){
                                      text_Officer_Licensed_text = "Licensed in State(s) "+profile_json.licensedStates;
                                      ctx_back.fillText(text_Officer_Licensed_text, 850, 680);
                                  }else{
                                      text_Officer_Licensed_text = " ";
                                      ctx_back.fillText(text_Officer_Licensed_text, 850, 680);
                                  }

                                  ctx_back.fillStyle = "#262a82";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.textAlign = "center";
                                  ctx_back.font = "50px 'CircularStd-Bold'";
                                  var text_Officer_additional_text = "Se habla espanol";

                                  var get_spanish = $("#spanish-se-habla-espanol").val();

                                  if(get_spanish == "Yes"){
                                      text_Officer_additional_text = "Se habla espanol";
                                      ctx_back.fillText(text_Officer_additional_text, 850, 760);
                                  }else{
                                      text_Officer_additional_text = " ";
                                      ctx_back.fillText(text_Officer_additional_text, 850, 760);
                                  }

                              },500);

                          }else if(get_back_card_type == "Own What Matters - Blue"){

                              img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Own_What_Matters_-_Blue_pre_1.jpg?v=1739543587";
                              ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                              ctx_back.drawImage(img_back,0,0,1600,922);

                              setTimeout(function(){

                                  ctx_back.fillStyle = "#ffffff";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.textAlign = "center";
                                  ctx_back.font = "50px 'CircularStd-Bold'";

                                  var get_officer_url_split = profile_json.officerUrl;

                                  if(get_officer_url_split.indexOf("www.") != -1){
                                      var text_Officer_URL_text = get_officer_url_split.split("www.");
                                      ctx_back.fillText(text_Officer_URL_text[1], 850, 600);
                                  }

                                  ctx_back.fillStyle = "#ffffff";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.textAlign = "center";
                                  ctx_back.font = "50px 'CircularStd-Bold'";
                                  var text_Officer_Licensed_text = "Licensed in State(s) option";
                                  ctx_back.fillText(text_Officer_Licensed_text, 850, 680);

                              },500);

                          }else if(get_back_card_type == "Own What Matters - Half Yellow"){

                              img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Own_What_Matters_-_Half_Yellow_pre_1.jpg?v=1739543587";
                              ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                              ctx_back.drawImage(img_back,0,0,1600,922);

                              setTimeout(function(){

                                  ctx_back.fillStyle = "#262a82";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.textAlign = "center";
                                  ctx_back.font = "50px 'CircularStd-Bold'";

                                  var get_officer_url_split = profile_json.officerUrl;

                                  if(get_officer_url_split.indexOf("www.") != -1){
                                      var text_Officer_URL_text = get_officer_url_split.split("www.");
                                      ctx_back.fillText(text_Officer_URL_text[1], 850, 640);
                                  }

                                  ctx_back.fillStyle = "#262a82";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.textAlign = "center";
                                  ctx_back.font = "60px 'CircularStd-Bold'";
                                  var text_Officer_Licensed_text = "Licensed in State(s) option";
                                  ctx_back.fillText(text_Officer_Licensed_text, 850, 730);

                                  ctx_back.fillStyle = "#262a82";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.textAlign = "center";
                                  ctx_back.font = "60px 'CircularStd-Bold'";
                                  var text_Officer_additional_text = "Se habla espanol";
                                  ctx_back.fillText(text_Officer_additional_text, 850, 810);

                              },500);

                          }else if(get_back_card_type == "Own What Matters - Half Blue"){

                              img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Own_What_Matters_-_Half_Blue_pre_1.jpg?v=1739543587";
                              ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                              ctx_back.drawImage(img_back,0,0,1600,922);

                              setTimeout(function(){

                                  ctx_back.fillStyle = "#262a82";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.textAlign = "center";
                                  ctx_back.font = "50px 'CircularStd-Bold'";

                                  var get_officer_url_split = profile_json.officerUrl;

                                  if(get_officer_url_split.indexOf("www.") != -1){
                                      var text_Officer_URL_text = get_officer_url_split.split("www.");
                                      ctx_back.fillText(text_Officer_URL_text[1], 850, 690);
                                  }

                                  ctx_back.fillStyle = "#262a82";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.textAlign = "center";
                                  ctx_back.font = "60px 'CircularStd-Bold'";
                                  var text_Officer_Licensed_text = "Licensed in State(s) option";
                                  ctx_back.fillText(text_Officer_Licensed_text, 850, 770);

                              },500);

                          }else if(get_back_card_type == "QR - Yellow"){

                              img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_QR-Y8_HD_Yellow_blank.jpg?v=1742215689";
                              ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                              ctx_back.drawImage(img_back,0,0,1600,922);

                              setTimeout(function(){

                                  ctx_back.fillStyle = "#262a82";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.font = "50px 'CircularStd-Bold'";

                                  var get_officer_url_split = profile_json.officerUrl;

                                  if(get_officer_url_split.indexOf("www.") != -1){
                                      var text_Officer_URL_text = get_officer_url_split.split("www.");
                                      ctx_back.fillText(text_Officer_URL_text[1], 140, 640);
                                  }

                                  ctx_back.fillStyle = "#262a82";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.font = "50px 'CircularStd-Bold'";
                                  var text_Officer_Licensed_text = "Licensed in State(s) option";

                                  if ( typeof(profile_json.licensedStates) !== "undefined" && profile_json.licensedStates !== null ){
                                      text_Officer_Licensed_text = "Licensed in State(s) "+profile_json.licensedStates;
                                      if(profile_json.licensedStates.length > 10){
                                            wrapText(ctx_back, text_Officer_Licensed_text, 140, 720, 1400, 55);

                                            ctx_back.fillStyle = "#262a82";
                                            ctx_back.textBaseline = 'middle';
                                            ctx_back.font = "60px 'CircularStd-Bold'";
                                            var text_Officer_additional_text = "Se habla espanol";

                                            var get_spanish = $("#spanish-se-habla-espanol").val();

                                            if(get_spanish == "Yes"){
                                                text_Officer_additional_text = "Se habla espanol";
                                                ctx_back.fillText(text_Officer_additional_text, 140, 850);
                                            }

                                      }else{
                                            ctx_back.fillText(text_Officer_Licensed_text, 140, 720);

                                            ctx_back.fillStyle = "#262a82";
                                            ctx_back.textBaseline = 'middle';
                                            ctx_back.font = "60px 'CircularStd-Bold'";
                                            var text_Officer_additional_text = "Se habla espanol";

                                            var get_spanish = $("#spanish-se-habla-espanol").val();

                                            if(get_spanish == "Yes"){
                                                text_Officer_additional_text = "Se habla espanol";
                                                ctx_back.fillText(text_Officer_additional_text, 140, 800);
                                            }else{
                                                text_Officer_additional_text = " ";
                                                ctx_back.fillText(text_Officer_additional_text, 140, 800);
                                            }

                                      }

                                  }else{
                                      text_Officer_Licensed_text = " ";
                                      ctx_back.fillText(text_Officer_Licensed_text, 140, 720);

                                      ctx_back.fillStyle = "#262a82";
                                      ctx_back.textBaseline = 'middle';
                                      ctx_back.font = "60px 'CircularStd-Bold'";
                                      var text_Officer_additional_text = "Se habla espanol";

                                      var get_spanish = $("#spanish-se-habla-espanol").val();

                                      if(get_spanish == "Yes"){
                                          text_Officer_additional_text = "Se habla espanol";
                                          ctx_back.fillText(text_Officer_additional_text, 140, 800);
                                      }else{
                                          text_Officer_additional_text = " ";
                                          ctx_back.fillText(text_Officer_additional_text, 140, 800);
                                      }

                                  }

                                  // select QR canvas elements
                                  var sourceCanvas = document.querySelectorAll(".bg canvas")[0];
                                  if (sourceCanvas) {
                                      ctx_back.drawImage(sourceCanvas,1250,110,360,360);
                                  }

                              },500);

                          }else if(get_back_card_type == "QR - Blue"){

                              img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_QR-Y8_Blue_HD_blank.jpg?v=1742219405";
                              ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                              ctx_back.drawImage(img_back,0,0,1600,922);

                              setTimeout(function(){

                                  ctx_back.fillStyle = "#ffffff";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.font = "50px 'CircularStd-Bold'";

                                  var get_officer_url_split = profile_json.officerUrl;

                                  if(get_officer_url_split.indexOf("www.") != -1){
                                      var text_Officer_URL_text = get_officer_url_split.split("www.");
                                      ctx_back.fillText(text_Officer_URL_text[1], 140, 640);
                                  }

                                  ctx_back.fillStyle = "#ffffff";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.font = "50px 'CircularStd-Bold'";
                                  var text_Officer_Licensed_text = "Licensed in State(s) option";

                                  if ( typeof(profile_json.licensedStates) !== "undefined" && profile_json.licensedStates !== null ){
                                      text_Officer_Licensed_text = "Licensed in State(s) "+profile_json.licensedStates;

                                      if(profile_json.licensedStates.length > 10){
                                            wrapText(ctx_back, text_Officer_Licensed_text, 140, 720, 1400, 55);

                                            ctx_back.fillStyle = "#ffffff";
                                            ctx_back.textBaseline = 'middle';
                                            ctx_back.font = "60px 'CircularStd-Bold'";
                                            var text_Officer_additional_text = "Se habla espanol";

                                            var get_spanish = $("#spanish-se-habla-espanol").val();

                                            if(get_spanish == "Yes"){
                                                text_Officer_additional_text = "Se habla espanol";
                                                ctx_back.fillText(text_Officer_additional_text, 140, 850);
                                            }

                                      }else{
                                            ctx_back.fillText(text_Officer_Licensed_text, 140, 720);

                                            ctx_back.fillStyle = "#ffffff";
                                            ctx_back.textBaseline = 'middle';
                                            ctx_back.font = "60px 'CircularStd-Bold'";
                                            var text_Officer_additional_text = "Se habla espanol";

                                            var get_spanish = $("#spanish-se-habla-espanol").val();

                                            if(get_spanish == "Yes"){
                                                text_Officer_additional_text = "Se habla espanol";
                                                ctx_back.fillText(text_Officer_additional_text, 140, 800);
                                            }else{
                                                text_Officer_additional_text = " ";
                                                ctx_back.fillText(text_Officer_additional_text, 140, 800);
                                            }

                                      }

                                  }else{
                                      text_Officer_Licensed_text = " ";
                                      ctx_back.fillText(text_Officer_Licensed_text, 140, 720);

                                      ctx_back.fillStyle = "#ffffff";
                                      ctx_back.textBaseline = 'middle';
                                      ctx_back.font = "60px 'CircularStd-Bold'";
                                      var text_Officer_additional_text = "Se habla espanol";

                                      var get_spanish = $("#spanish-se-habla-espanol").val();

                                      if(get_spanish == "Yes"){
                                          text_Officer_additional_text = "Se habla espanol";
                                          ctx_back.fillText(text_Officer_additional_text, 140, 800);
                                      }else{
                                          text_Officer_additional_text = " ";
                                          ctx_back.fillText(text_Officer_additional_text, 140, 800);
                                      }

                                  }

                                  // select QR canvas elements
                                  var sourceCanvas = document.querySelectorAll(".bg canvas")[0];
                                  if (sourceCanvas) {
                                      ctx_back.drawImage(sourceCanvas,1250,90,360,360);
                                  }

                              },500);

                          }else if(get_back_card_type == "QR - Half Yellow"){

                              img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/QR_-_Half_Yellow_pre_1.jpg?v=1739543587";
                              ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                              ctx_back.drawImage(img_back,0,0,1600,922);

                          }else if(get_back_card_type == "QR - Half Blue"){

                              img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/QR_-_Half_Blue_pre_1.jpg?v=1739543587";
                              ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                              ctx_back.drawImage(img_back,0,0,1600,922);

                          }else if(get_back_card_type == "QR - Square Yellow"){

                              img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/QR_-_Square_Yellow_pre_1.jpg?v=1739543587";
                              ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                              ctx_back.drawImage(img_back,0,0,1600,922);

                          }else if(get_back_card_type == "QR - Square Blue"){

                              img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/QR_-_Square_Blue_pre_1.jpg?v=1739543587";
                              ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                              ctx_back.drawImage(img_back,0,0,1600,922);

                          }else if(get_back_card_type == "QR - Mix Color"){

                            img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_QR-NEW-HD_blank.jpg?v=1742284474";

                              ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                              ctx_back.drawImage(img_back,0,0,1600,922);

                              setTimeout(function(){

                                  ctx_back.fillStyle = "#ffffff";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.textAlign = "right";
                                  ctx_back.font = "50px 'CircularStd-Bold'";

                                  var get_officer_url_split = profile_json.officerUrl;

                                  if(get_officer_url_split.indexOf("www.") != -1){
                                      var text_Officer_URL_text = get_officer_url_split.split("www.");
                                      wrapText(ctx_back, text_Officer_URL_text[1], 1580, 540, 1000, 50);
                                  }

                                  ctx_back.fillStyle = "#ffffff";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.textAlign = "right";
                                  ctx_back.font = "50px 'CircularStd-Bold'";
                                  var text_Officer_Licensed_text = "Licensed in State(s) option";

                                  if ( typeof(profile_json.licensedStates) !== "undefined" && profile_json.licensedStates !== null ){
                                      text_Officer_Licensed_text = "Licensed in State(s) "+profile_json.licensedStates;

                                      if(profile_json.licensedStates.length > 10){
                                            wrapText(ctx_back, text_Officer_Licensed_text, 1580, 670, 1000, 55);

                                            ctx_back.fillStyle = "#ffffff";
                                            ctx_back.textBaseline = 'middle';
                                            ctx_back.textAlign = "right";
                                            ctx_back.font = "60px 'CircularStd-Bold'";
                                            var text_Officer_additional_text = "Se habla espanol";

                                            var get_spanish = $("#spanish-se-habla-espanol").val();

                                            if(get_spanish == "Yes"){
                                                text_Officer_additional_text = "Se habla espanol";
                                                ctx_back.fillText(text_Officer_additional_text, 1580, 850);
                                            }else{
                                                text_Officer_additional_text = " ";
                                                ctx_back.fillText(text_Officer_additional_text, 1580, 850);
                                            }

                                      }else{
                                            ctx_back.fillText(text_Officer_Licensed_text, 1580, 670);

                                            ctx_back.fillStyle = "#ffffff";
                                            ctx_back.textBaseline = 'middle';
                                            ctx_back.textAlign = "right";
                                            ctx_back.font = "60px 'CircularStd-Bold'";
                                            var text_Officer_additional_text = "Se habla espanol";

                                            var get_spanish = $("#spanish-se-habla-espanol").val();

                                            if(get_spanish == "Yes"){
                                                text_Officer_additional_text = "Se habla espanol";
                                                ctx_back.fillText(text_Officer_additional_text, 1580, 750);
                                            }else{
                                                text_Officer_additional_text = " ";
                                                ctx_back.fillText(text_Officer_additional_text, 1580, 750);
                                            }

                                      }

                                  }else{
                                      text_Officer_Licensed_text = " ";
                                      ctx_back.fillText(text_Officer_Licensed_text, 1580, 670);

                                      ctx_back.fillStyle = "#ffffff";
                                      ctx_back.textBaseline = 'middle';
                                      ctx_back.textAlign = "right";
                                      ctx_back.font = "60px 'CircularStd-Bold'";
                                      var text_Officer_additional_text = "Se habla espanol";

                                      var get_spanish = $("#spanish-se-habla-espanol").val();

                                      if(get_spanish == "Yes"){
                                          text_Officer_additional_text = "Se habla espanol";
                                          ctx_back.fillText(text_Officer_additional_text, 1580, 750);
                                      }else{
                                          text_Officer_additional_text = " ";
                                          ctx_back.fillText(text_Officer_additional_text, 1580, 750);
                                      }

                                  }

                                  // select QR canvas elements
                                  var sourceCanvas = document.querySelectorAll(".bg canvas")[0];
                                  if (sourceCanvas) {
                                      ctx_back.drawImage(sourceCanvas,85,525,360,360);
                                  }

                              },500);

                          }else if(get_back_card_type == "QR - Angle Yellow"){

                            img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_QR-Y8_angle_HD_blank.jpg?v=1742216438";

                              ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                              ctx_back.drawImage(img_back,0,0,1600,922);

                              setTimeout(function(){

                                  ctx_back.fillStyle = "#262a82";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.font = "50px 'CircularStd-Bold'";

                                  var get_officer_url_split = profile_json.officerUrl;

                                  if(get_officer_url_split.indexOf("www.") != -1){
                                      var text_Officer_URL_text = get_officer_url_split.split("www.");
                                      ctx_back.fillText(text_Officer_URL_text[1], 130, 540);
                                  }

                                  ctx_back.fillStyle = "#262a82";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.font = "50px 'CircularStd-Bold'";
                                  var text_Officer_Licensed_text = "Licensed in State(s) option";

                                  if ( typeof(profile_json.licensedStates) !== "undefined" && profile_json.licensedStates !== null ){
                                      text_Officer_Licensed_text = "Licensed in State(s) "+profile_json.licensedStates;

                                      if(profile_json.licensedStates.length > 10){
                                            wrapText(ctx_back, text_Officer_Licensed_text, 130, 620, 1400, 55);

                                            ctx_back.fillStyle = "#262a82";
                                            ctx_back.textBaseline = 'middle';
                                            ctx_back.font = "60px 'CircularStd-Bold'";
                                            var text_Officer_additional_text = "Se habla espanol";

                                            var get_spanish = $("#spanish-se-habla-espanol").val();

                                            if(get_spanish == "Yes"){
                                                text_Officer_additional_text = "Se habla espanol";
                                                ctx_back.fillText(text_Officer_additional_text, 130, 750);
                                            }

                                      }else{
                                            ctx_back.fillText(text_Officer_Licensed_text, 140, 720);

                                            ctx_back.fillStyle = "#262a82";
                                            ctx_back.textBaseline = 'middle';
                                            ctx_back.font = "60px 'CircularStd-Bold'";
                                            var text_Officer_additional_text = "Se habla espanol";

                                            var get_spanish = $("#spanish-se-habla-espanol").val();

                                            if(get_spanish == "Yes"){
                                                text_Officer_additional_text = "Se habla espanol";
                                                ctx_back.fillText(text_Officer_additional_text, 130, 700);
                                            }else{
                                                text_Officer_additional_text = " ";
                                                ctx_back.fillText(text_Officer_additional_text, 130, 700);
                                            }

                                      }

                                  }else{
                                      text_Officer_Licensed_text = " ";
                                      ctx_back.fillText(text_Officer_Licensed_text, 130, 620);

                                      ctx_back.fillStyle = "#262a82";
                                      ctx_back.textBaseline = 'middle';
                                      ctx_back.font = "60px 'CircularStd-Bold'";
                                      var text_Officer_additional_text = "Se habla espanol";

                                      var get_spanish = $("#spanish-se-habla-espanol").val();

                                      if(get_spanish == "Yes"){
                                          text_Officer_additional_text = "Se habla espanol";
                                          ctx_back.fillText(text_Officer_additional_text, 130, 700);
                                      }else{
                                          text_Officer_additional_text = " ";
                                          ctx_back.fillText(text_Officer_additional_text, 130, 700);
                                      }

                                  }

                                  // select QR canvas elements
                                  var sourceCanvas = document.querySelectorAll(".bg canvas")[0];
                                  if (sourceCanvas) {
                                      ctx_back.drawImage(sourceCanvas,1200,95,370,370);
                                  }

                              },500);

                          }

                          setTimeout(function(){

                              // Card Back side

                            if(get_back_card_type == "Own What Matters - Yellow"){
                            }else if(get_back_card_type == "Own What Matters - Blue"){

                            }else if(get_back_card_type == "Own What Matters - Half Yellow"){

                            }else if(get_back_card_type == "Own What Matters - Half Blue"){

                            }else if(get_back_card_type == "QR - Yellow"){

                            }else if(get_back_card_type == "QR - Blue"){

                            }else if(get_back_card_type == "QR - Half Yellow"){

                                  ctx_back.fillStyle = "#262a82";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.font = "15px 'CircularStd-Medium'";

                                  var get_officer_url_split = profile_json.officerUrl;

                                  if(get_officer_url_split.indexOf("www.") != -1){
                                      var text_Officer_URL_text = get_officer_url_split.split("www.");
                                      ctx_back.fillText(text_Officer_URL_text[1], 19, 195);
                                  }

                                  ctx_back.fillStyle = "#262a82";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.font = "15px 'CircularStd-Medium'";
                                  var text_Officer_Licensed_text = "Licensed in State(s) option";

                                  if ( typeof(profile_json.licensedStates) !== "undefined" && profile_json.licensedStates !== null ){
                                      text_Officer_Licensed_text = "Licensed in State(s) "+profile_json.licensedStates;
                                      ctx_back.fillText(text_Officer_Licensed_text, 19, 220);
                                  }else{
                                      text_Officer_Licensed_text = " ";
                                      ctx_back.fillText(text_Officer_Licensed_text, 19, 220);
                                  }

                                  ctx_back.fillStyle = "#262a82";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.font = "15px 'CircularStd-Medium'";
                                  var text_Officer_additional_text = "Se habla espanol";

                                  // select QR canvas elements
                                  var sourceCanvas = document.querySelectorAll(".bg canvas")[0];
                                  if (sourceCanvas) {
                                      ctx_back.drawImage(sourceCanvas,346,153,100,100);
                                  }

                            }else if(get_back_card_type == "QR - Half Blue"){

                                  ctx_back.fillStyle = "#262a82";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.font = "15px 'CircularStd-Medium'";

                                  var get_officer_url_split = profile_json.officerUrl;

                                  if(get_officer_url_split.indexOf("www.") != -1){
                                      var text_Officer_URL_text = get_officer_url_split.split("www.");
                                      ctx_back.fillText(text_Officer_URL_text[1], 19, 180);
                                  }

                                  ctx_back.fillStyle = "#262a82";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.font = "15px 'CircularStd-Medium'";
                                  var text_Officer_Licensed_text = "Licensed in State(s) option";

                                  if ( typeof(profile_json.licensedStates) !== "undefined" && profile_json.licensedStates !== null ){
                                      text_Officer_Licensed_text = "Licensed in State(s) "+profile_json.licensedStates;
                                      ctx_back.fillText(text_Officer_Licensed_text, 19, 203);
                                  }else{
                                      text_Officer_Licensed_text = " ";
                                      ctx_back.fillText(text_Officer_Licensed_text, 19, 203);
                                  }

                                  ctx_back.fillStyle = "#262a82";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.font = "15px 'CircularStd-Medium'";
                                  var text_Officer_additional_text = "Se habla espanol";

                                  var get_spanish = $("#spanish-se-habla-espanol").val();

                                  if(get_spanish == "Yes"){
                                      text_Officer_additional_text = "Se habla espanol";
                                      ctx_back.fillText(text_Officer_additional_text, 19, 223);
                                  }else{
                                      text_Officer_additional_text = " ";
                                      ctx_back.fillText(text_Officer_additional_text, 19, 223);
                                  }

                                  // select QR canvas elements
                                  var sourceCanvas = document.querySelectorAll(".bg canvas")[0];
                                  if (sourceCanvas) {
                                      ctx_back.drawImage(sourceCanvas,346,153,100,100);
                                  }

                            }else if(get_back_card_type == "QR - Square Yellow"){

                                  ctx_back.fillStyle = "#262a82";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.font = "15px 'CircularStd-Medium'";

                                  var get_officer_url_split = profile_json.officerUrl;

                                  if(get_officer_url_split.indexOf("www.") != -1){
                                      var text_Officer_URL_text = get_officer_url_split.split("www.");
                                      ctx_back.fillText(text_Officer_URL_text[1], 19, 180);
                                  }

                                  ctx_back.fillStyle = "#262a82";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.font = "15px 'CircularStd-Medium'";
                                  var text_Officer_Licensed_text = "Licensed in State(s) option";

                                  if ( typeof(profile_json.licensedStates) !== "undefined" && profile_json.licensedStates !== null ){
                                      text_Officer_Licensed_text = "Licensed in State(s) "+profile_json.licensedStates;
                                      ctx_back.fillText(text_Officer_Licensed_text, 19, 205);
                                  }else{
                                      text_Officer_Licensed_text = " ";
                                      ctx_back.fillText(text_Officer_Licensed_text, 19, 205);
                                  }

                                  ctx_back.fillStyle = "#262a82";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.font = "15px 'CircularStd-Medium'";
                                  var text_Officer_additional_text = "Se habla espanol";

                                  // select QR canvas elements
                                  var sourceCanvas = document.querySelectorAll(".bg canvas")[0];
                                  if (sourceCanvas) {
                                      ctx_back.drawImage(sourceCanvas,330,83,100,100);
                                  }

                            }else if(get_back_card_type == "QR - Square Blue"){

                                  ctx_back.fillStyle = "#262a82";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.font = "15px 'CircularStd-Medium'";

                                  var get_officer_url_split = profile_json.officerUrl;
                                  if(get_officer_url_split.indexOf("www.") != -1){
                                      var text_Officer_URL_text = get_officer_url_split.split("www.");
                                      ctx_back.fillText(text_Officer_URL_text[1], 19, 158);
                                  }

                                  ctx_back.fillStyle = "#262a82";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.font = "15px 'CircularStd-Medium'";
                                  var text_Officer_Licensed_text = "Licensed in State(s) option";

                                  if ( typeof(profile_json.licensedStates) !== "undefined" && profile_json.licensedStates !== null ){
                                      text_Officer_Licensed_text = "Licensed in State(s) "+profile_json.licensedStates;
                                      ctx_back.fillText(text_Officer_Licensed_text, 19, 180);
                                  }else{
                                      text_Officer_Licensed_text = " ";
                                      ctx_back.fillText(text_Officer_Licensed_text, 19, 180);
                                  }

                                  ctx_back.fillStyle = "#262a82";
                                  ctx_back.textBaseline = 'middle';
                                  ctx_back.font = "15px 'CircularStd-Medium'";
                                  var text_Officer_additional_text = "Se habla espanol";

                                  var get_spanish = $("#spanish-se-habla-espanol").val();

                                  if(get_spanish == "Yes"){
                                      text_Officer_additional_text = "Se habla espanol";
                                      ctx_back.fillText(text_Officer_additional_text, 19, 200);
                                  }else{
                                      text_Officer_additional_text = " ";
                                      ctx_back.fillText(text_Officer_additional_text, 19, 200);
                                  }

                                  // select QR canvas elements
                                  var sourceCanvas = document.querySelectorAll(".bg canvas")[0];
                                  if (sourceCanvas) {
                                      ctx_back.drawImage(sourceCanvas,330,83,100,100);
                                  }

                            }else if(get_back_card_type == "QR - Angle Yellow"){
                            }

                          },500);

                  }else{

                          var get_front_card_type = $("input[name='properties[Team - Choose front]']:checked").val();

                          if(get_front_card_type == "No Picture"){
                              img.src = 'https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_1_HD_blank.jpg?v=1741181203';
                              ctx.clearRect(0, 0, canvas.width, canvas.height);
                              ctx.drawImage(img,0,0,1699,971);

                              setTimeout(function(){

                                  var text_name_title = profile_json.givenName + " "+ profile_json.surname;
                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "80px 'CircularStd-Bold'";

                                  if ( typeof(text_name_title) !== "undefined" && text_name_title !== null ){
                                      ctx.fillText(text_name_title, 60, 380);
                                  }else{
                                      ctx.fillText("-", 60, 380);
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "50px 'CircularStd-Bold'";

                                  var text_job_NMLS_id = "NMLS ID "+ profile_json.nlmsNumber;
                                  if ( typeof(text_job_NMLS_id) !== "undefined" && profile_json.nlmsNumber !== null ){

                                      if ( typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                          var text_job_title = profile_json.jobTitle + " | NMLS ID "+ profile_json.nlmsNumber;
                                          ctx.fillText(text_job_title, 60, 480);
                                      }else{
                                          var text_job_title = profile_json.jobTitle;
                                          ctx.fillText(text_job_title, 60, 480);
                                      }
                                  }else{
                                      var text_job_title = profile_json.jobTitle + " | NMLS ID - ";
                                      ctx.fillText(text_job_title, 60, 480);
                                  }

                                  ctx.fillStyle = "#994396";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "48px 'CircularStd-Medium'";
                                  if ( typeof(profile_json.mail) !== "undefined" && profile_json.mail !== null ){
                                      ctx.fillText(profile_json.mail, 60, 545);
                                  }else{
                                      ctx.fillText(" - ", 60, 545);
                                  }

                                  var arr_card_contact_number = [];

                                  // append new value to the array
                                  if ( typeof(profile_json.faxNumber) !== "undefined" && profile_json.faxNumber !== null ){
                                      let obj_contact = { name: "faxNumber", value: profile_json.faxNumber };
                                      arr_card_contact_number.push(obj_contact);
                                  }
                                  if ( typeof(profile_json.mobilePhone) !== "undefined" && profile_json.mobilePhone !== null ){
                                      let obj_contact = { name: "mobilePhone", value: profile_json.mobilePhone };
                                      arr_card_contact_number.push(obj_contact);
                                  }

                                  if ( typeof(profile_json.businessPhones) !== "undefined" && profile_json.businessPhones !== null && profile_json.businessPhones.length != 0 ){
                                      let obj_contact = { name: "businessPhones", value: profile_json.businessPhones };
                                      arr_card_contact_number.push(obj_contact);
                                  }

                                  if(arr_card_contact_number.length > 0){
                                        for (var i = 0; i < arr_card_contact_number.length; i++) {
                                            var text_label_number = "";
                                            var get_value_Number = "";
                                            if(arr_card_contact_number[i].name == "faxNumber"){
                                                text_label_number = "F ";
                                                get_value_Number = arr_card_contact_number[i].value;
                                            }
                                            if(arr_card_contact_number[i].name == "mobilePhone"){
                                                text_label_number = "M ";
                                                get_value_Number = arr_card_contact_number[i].value;
                                            }
                                            if(arr_card_contact_number[i].name == "businessPhones"){
                                                text_label_number = "O ";
                                                get_value_Number = arr_card_contact_number[i].value;
                                            }

                                            if (i == 0){
                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Bold'";
                                                ctx.fillText(text_label_number, 60, 620);

                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Book'";
                                                ctx.fillText(get_value_Number, 115, 620);
                                            }

                                            if (i == 1){
                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Bold'";
                                                ctx.fillText(text_label_number, 60, 690);

                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Book'";
                                                ctx.fillText(get_value_Number, 115, 690);
                                            }

                                            if (i == 2){
                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Bold'";
                                                ctx.fillText(text_label_number, 60, 760);

                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Book'";
                                                ctx.fillText(get_value_Number, 115, 760);
                                            }

                                        }
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "50px 'CircularStd-Book'";
                                  var text_upper_address = profile_json.streetAddress;

                                  if ( typeof(text_upper_address) !== "undefined" && text_upper_address !== null ){
                                  }else{
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "50px 'CircularStd-Book'";
                                  var text_lower_address = " ";
                                  var text_lower_address_city = profile_json.city;
                                  var text_lower_address_state = profile_json.state;
                                  var text_lower_address_postalCode = profile_json.postalCode;

                                  if ( typeof(text_upper_address) !== "undefined" && text_upper_address !== null ){
                                      text_lower_address = text_upper_address +", ";
                                  }else{
                                      text_lower_address = " ";
                                  }

                                  if ( typeof(text_lower_address_city) !== "undefined" && text_lower_address_city !== null ){
                                      text_lower_address = text_lower_address + text_lower_address_city +", ";
                                  }else{
                                      text_lower_address = text_lower_address + " ";
                                  }
                                  if ( typeof(text_lower_address_state) !== "undefined" && text_lower_address_state !== null ){
                                      text_lower_address = text_lower_address + text_lower_address_state +", ";
                                  }else{
                                      text_lower_address = text_lower_address + " ";
                                  }

                                  if ( typeof(text_lower_address_postalCode) !== "undefined" && text_lower_address_postalCode !== null ){
                                      text_lower_address = text_lower_address + text_lower_address_postalCode;
                                  }else{
                                      text_lower_address = text_lower_address + " ";
                                  }

                                  if ( typeof(text_lower_address) !== "undefined" && text_lower_address !== null ){
                                      wrapText(ctx, text_lower_address, 480, 620, 670, 75);
                                  }else{
                                      ctx.fillText(" - ", 480, 620);
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "42px 'CircularStd-Book'";
                                  var text_company_nmls_text = "Company NMLS ID 3274, Equal Housing Opportunity.";
                                  ctx.fillText(text_company_nmls_text, 60, 880);

                              },500);

                          }else if(get_front_card_type == "Circle Picture"){
                              img.src = 'https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_2_HD_blank_B.jpg?v=1746442711';
                              ctx.clearRect(0, 0, canvas.width, canvas.height);
                              ctx.drawImage(img,0,0,1699,971);

                              setTimeout(function(){

                                  var text_name_title = profile_json.givenName + " "+ profile_json.surname;
                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "80px 'CircularStd-Bold'";

                                  if ( typeof(text_name_title) !== "undefined" && text_name_title !== null ){
                                      ctx.fillText(text_name_title, 60, 270);
                                  }else{
                                      ctx.fillText("-", 60, 270);
                                  }

                                  ctx.fillStyle = "#01b5f0";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "50px 'CircularStd-Bold'";

                                  var text_job_title = profile_json.jobTitle;
                                  if ( typeof(text_job_title) !== "undefined" && text_job_title !== null ){
                                      ctx.fillText(text_job_title, 60, 360);
                                  }else{
                                      ctx.fillText("-", 60, 360);
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "50px 'CircularStd-Bold'";

                                  var text_job_NMLS_id = "NMLS ID "+ profile_json.nlmsNumber;
                                  if ( typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                      ctx.fillText(text_job_NMLS_id, 60, 430);
                                  }else{
                                      ctx.fillText("NMLS ID - ", 60, 430);
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "48px 'CircularStd-Medium'";
                                  if ( typeof(profile_json.mail) !== "undefined" && profile_json.mail !== null ){
                                      ctx.fillText(profile_json.mail, 60, 545);
                                  }else{
                                      ctx.fillText(" - ", 60, 545);
                                  }

                                  var arr_card_contact_number = [];

                                  // append new value to the array
                                  if ( typeof(profile_json.faxNumber) !== "undefined" && profile_json.faxNumber !== null ){
                                      let obj_contact = { name: "faxNumber", value: profile_json.faxNumber };
                                      arr_card_contact_number.push(obj_contact);
                                  }
                                  if ( typeof(profile_json.mobilePhone) !== "undefined" && profile_json.mobilePhone !== null ){
                                      let obj_contact = { name: "mobilePhone", value: profile_json.mobilePhone };
                                      arr_card_contact_number.push(obj_contact);
                                  }

                                  if ( typeof(profile_json.businessPhones) !== "undefined" && profile_json.businessPhones !== null && profile_json.businessPhones.length != 0 ){
                                      let obj_contact = { name: "businessPhones", value: profile_json.businessPhones };
                                      arr_card_contact_number.push(obj_contact);
                                  }

                                  if(arr_card_contact_number.length > 0){
                                        for (var i = 0; i < arr_card_contact_number.length; i++) {
                                            var text_label_number = "";
                                            var get_value_Number = "";
                                            if(arr_card_contact_number[i].name == "faxNumber"){
                                                text_label_number = "F ";
                                                get_value_Number = arr_card_contact_number[i].value;
                                            }
                                            if(arr_card_contact_number[i].name == "mobilePhone"){
                                                text_label_number = "M ";
                                                get_value_Number = arr_card_contact_number[i].value;
                                            }
                                            if(arr_card_contact_number[i].name == "businessPhones"){
                                                text_label_number = "O ";
                                                get_value_Number = arr_card_contact_number[i].value;
                                            }

                                            if (i == 0){
                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Bold'";
                                                ctx.fillText(text_label_number, 60, 620);

                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Book'";
                                                ctx.fillText(get_value_Number, 115, 620);
                                            }

                                            if (i == 1){
                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Bold'";
                                                ctx.fillText(text_label_number, 60, 690);

                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Book'";
                                                ctx.fillText(get_value_Number, 115, 690);
                                            }

                                            if (i == 2){
                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Bold'";
                                                ctx.fillText(text_label_number, 60, 760);

                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Book'";
                                                ctx.fillText(get_value_Number, 115, 760);
                                            }

                                        }
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "50px 'CircularStd-Book'";
                                  var text_upper_address = profile_json.streetAddress;

                                  if ( typeof(text_upper_address) !== "undefined" && text_upper_address !== null ){
                                  }else{
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "50px 'CircularStd-Book'";
                                  var text_lower_address = " ";
                                  var text_lower_address_city = profile_json.city;
                                  var text_lower_address_state = profile_json.state;
                                  var text_lower_address_postalCode = profile_json.postalCode;

                                  if ( typeof(text_upper_address) !== "undefined" && text_upper_address !== null ){
                                      text_lower_address = text_upper_address +", ";
                                  }else{
                                      text_lower_address = " ";
                                  }

                                  if ( typeof(text_lower_address_city) !== "undefined" && text_lower_address_city !== null ){
                                      text_lower_address = text_lower_address + text_lower_address_city +", ";
                                  }else{
                                      text_lower_address = text_lower_address + " ";
                                  }
                                  if ( typeof(text_lower_address_state) !== "undefined" && text_lower_address_state !== null ){
                                      text_lower_address = text_lower_address + text_lower_address_state +", ";
                                  }else{
                                      text_lower_address = text_lower_address + " ";
                                  }

                                  if ( typeof(text_lower_address_postalCode) !== "undefined" && text_lower_address_postalCode !== null ){
                                      text_lower_address = text_lower_address + text_lower_address_postalCode;
                                  }else{
                                      text_lower_address = text_lower_address + " ";
                                  }

                                  if ( typeof(text_lower_address) !== "undefined" && text_lower_address !== null ){
                                      wrapText(ctx, text_lower_address, 480, 620, 670, 75);
                                  }else{
                                      ctx.fillText(" - ", 480, 620);
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "42px 'CircularStd-Book'";
                                  var text_company_nmls_text = "Company NMLS ID 3274, Equal Housing Opportunity.";
                                  ctx.fillText(text_company_nmls_text, 60, 880);

                              },500);

                          }else if(get_front_card_type == "Square Picture"){
                              img.src = 'https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_3_HD_blankB_3.jpg?v=1751628418';
                              ctx.clearRect(0, 0, canvas.width, canvas.height);
                              ctx.drawImage(img,0,0,1699,971);

                              setTimeout(function(){

                                  var text_name_title = profile_json.givenName + " "+ profile_json.surname;
                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "80px 'CircularStd-Bold'";

                                  if ( typeof(text_name_title) !== "undefined" && text_name_title !== null ){
                                      ctx.fillText(text_name_title, 60, 400);
                                  }else{
                                      ctx.fillText("-", 60, 400);
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "50px 'CircularStd-Bold'";

                                  var text_job_NMLS_id = "NMLS ID "+ profile_json.nlmsNumber;
                                  if ( typeof(text_job_NMLS_id) !== "undefined" && profile_json.nlmsNumber !== null ){

                                      if ( typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                          var text_job_title = profile_json.jobTitle + " | NMLS ID "+ profile_json.nlmsNumber;
                                          ctx.fillText(text_job_title, 60, 480);
                                      }else{
                                          var text_job_title = profile_json.jobTitle;
                                          ctx.fillText(text_job_title, 60, 480);
                                      }
                                  }else{
                                      var text_job_title = profile_json.jobTitle + " | NMLS ID - ";
                                      ctx.fillText(text_job_title, 60, 480);
                                  }

                                  ctx.fillStyle = "#994396";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "48px 'CircularStd-Medium'";
                                  if ( typeof(profile_json.mail) !== "undefined" && profile_json.mail !== null ){
                                      ctx.fillText(profile_json.mail, 60, 545);
                                  }else{
                                  }

                                  var arr_card_contact_number = [];

                                  // append new value to the array
                                  if ( typeof(profile_json.faxNumber) !== "undefined" && profile_json.faxNumber !== null ){
                                      let obj_contact = { name: "faxNumber", value: profile_json.faxNumber };
                                      arr_card_contact_number.push(obj_contact);
                                  }
                                  if ( typeof(profile_json.mobilePhone) !== "undefined" && profile_json.mobilePhone !== null ){
                                      let obj_contact = { name: "mobilePhone", value: profile_json.mobilePhone };
                                      arr_card_contact_number.push(obj_contact);
                                  }

                                  if ( typeof(profile_json.businessPhones) !== "undefined" && profile_json.businessPhones !== null && profile_json.businessPhones.length != 0 ){
                                      let obj_contact = { name: "businessPhones", value: profile_json.businessPhones };
                                      arr_card_contact_number.push(obj_contact);
                                  }

                                  if(arr_card_contact_number.length > 0){
                                        for (var i = 0; i < arr_card_contact_number.length; i++) {
                                            var text_label_number = "";
                                            var get_value_Number = "";
                                            if(arr_card_contact_number[i].name == "faxNumber"){
                                                text_label_number = "F ";
                                                get_value_Number = arr_card_contact_number[i].value;
                                            }
                                            if(arr_card_contact_number[i].name == "mobilePhone"){
                                                text_label_number = "M ";
                                                get_value_Number = arr_card_contact_number[i].value;
                                            }
                                            if(arr_card_contact_number[i].name == "businessPhones"){
                                                text_label_number = "O ";
                                                get_value_Number = arr_card_contact_number[i].value;
                                            }

                                            if (i == 0){
                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Bold'";
                                                ctx.fillText(text_label_number, 60, 620);

                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Book'";
                                                ctx.fillText(get_value_Number, 115, 620);
                                            }

                                            if (i == 1){
                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Bold'";
                                                ctx.fillText(text_label_number, 60, 690);

                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Book'";
                                                ctx.fillText(get_value_Number, 115, 690);
                                            }

                                            if (i == 2){
                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Bold'";
                                                ctx.fillText(text_label_number, 60, 760);

                                                ctx.fillStyle = "#262a82";
                                                ctx.textBaseline = 'middle';
                                                ctx.font = "50px 'CircularStd-Book'";
                                                ctx.fillText(get_value_Number, 115, 760);
                                            }

                                        }
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "50px 'CircularStd-Book'";
                                  var text_lower_address = " ";

                                  var text_upper_address = profile_json.streetAddress;

                                  if ( typeof(text_upper_address) !== "undefined" && text_upper_address !== null ){
                                      text_lower_address = text_upper_address +", ";
                                  }else{
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "50px 'CircularStd-Book'";

                                  var text_lower_address_city = profile_json.city;
                                  var text_lower_address_state = profile_json.state;
                                  var text_lower_address_postalCode = profile_json.postalCode;

                                  if ( typeof(text_lower_address_city) !== "undefined" && text_lower_address_city !== null ){
                                      text_lower_address = text_lower_address + text_lower_address_city +", ";
                                  }else{
                                      text_lower_address = text_lower_address + " ";
                                  }
                                  if ( typeof(text_lower_address_state) !== "undefined" && text_lower_address_state !== null ){
                                      text_lower_address = text_lower_address + text_lower_address_state +", ";
                                  }else{
                                      text_lower_address = text_lower_address + " ";
                                  }

                                  if ( typeof(text_lower_address_postalCode) !== "undefined" && text_lower_address_postalCode !== null ){
                                      text_lower_address = text_lower_address + text_lower_address_postalCode;
                                  }else{
                                      text_lower_address = text_lower_address + " ";
                                  }

                                  if ( typeof(text_lower_address) !== "undefined" && text_lower_address !== null ){
                                      wrapText(ctx, text_lower_address, 480, 620, 640, 75);
                                  }else{
                                  }

                                  ctx.fillStyle = "#262a82";
                                  ctx.textBaseline = 'middle';
                                  ctx.font = "42px 'CircularStd-Book'";
                                  var text_company_nmls_text = "Company NMLS ID 3274, Equal Housing Opportunity.";
                                  ctx.fillText(text_company_nmls_text, 60, 880);

                              },500);

                          }

                          var get_back_card_type = $("input[name='properties[Team - Choose back]']:checked").val();

                          if(get_back_card_type == "2 Team Circle"){

                              img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_2TeamCrc4_HD_blank_B.jpg?v=1746453584";
                              ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                              ctx_back.drawImage(img_back,0,0,1600,922);

                          }else if(get_back_card_type == "3 Team Circle"){

                              img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_3TeamCrc5_HD_blank_B.jpg?v=1746453584";
                              ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                              ctx_back.drawImage(img_back,0,0,1600,922);

                          }else if(get_back_card_type == "4 Team Circle"){

                              img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_4TeamCrc6_HD_blank_B.jpg?v=1746453584";
                              ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                              ctx_back.drawImage(img_back,0,0,1600,922);

                          }else if(get_back_card_type == "2 Team Square"){

                              img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/2_Team_Square_pre_1.jpg?v=1739543587";
                              ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                              ctx_back.drawImage(img_back,0,0,1600,922);

                          }else if(get_back_card_type == "3 Team Square"){

                              img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/3_Team_Square_pre_1.jpg?v=1739543587";
                              ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                              ctx_back.drawImage(img_back,0,0,1600,922);

                          }else if(get_back_card_type == "4 Team Square"){

                              img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/4_Team_Square_pre_1.jpg?v=1739543587";
                              ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                              ctx_back.drawImage(img_back,0,0,1600,922);

                          }

                          setTimeout(function(){

                              if(get_back_card_type == "2 Team Circle"){

                                    var text_back_top_title = "branches.guildmortgage.com/st/city";
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "50px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "right";
                                    ctx_back.fillText(text_back_top_title, 1600, 100);

                                    ctx_back.fillStyle = "#994396";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "55px 'CircularStd-Bold'";
                                    var text_back_top_subtitle = "Se habla espanol";
                                    ctx_back.textAlign = "right";

                                    var get_spanish = $("#spanish-se-habla-espanol").val();

                                    if(get_spanish == "Yes"){
                                        text_back_top_subtitle = "Se habla espanol";
                                        ctx_back.fillText(text_back_top_subtitle, 1600, 170);
                                    }else{
                                        text_back_top_subtitle = " ";
                                        ctx_back.fillText(text_back_top_subtitle, 1600, 170);
                                    }

                              }else if(get_back_card_type == "3 Team Circle"){

                                    var text_back_top_title = "branches.guildmortgage.com/st/city";
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "50px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "right";
                                    ctx_back.fillText(text_back_top_title, 1600, 100);

                                    ctx_back.fillStyle = "#994396";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "55px 'CircularStd-Bold'";
                                    var text_back_top_subtitle = "Se habla espanol";
                                    ctx_back.textAlign = "right";

                                    var get_spanish = $("#spanish-se-habla-espanol").val();

                                    if(get_spanish == "Yes"){
                                        text_back_top_subtitle = "Se habla espanol";
                                        ctx_back.fillText(text_back_top_subtitle, 1600, 170);
                                    }else{
                                        text_back_top_subtitle = " ";
                                        ctx_back.fillText(text_back_top_subtitle, 1600, 170);
                                    }

                              }else if(get_back_card_type == "4 Team Circle"){

                                    var text_back_top_title = "branches.guildmortgage.com/st/city";
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "50px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "right";
                                    ctx_back.fillText(text_back_top_title, 1600, 100);

                                    ctx_back.fillStyle = "#994396";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "55px 'CircularStd-Bold'";
                                    var text_back_top_subtitle = "Se habla espanol";
                                    ctx_back.textAlign = "right";

                                    var get_spanish = $("#spanish-se-habla-espanol").val();

                                    if(get_spanish == "Yes"){
                                        text_back_top_subtitle = "Se habla espanol";
                                        ctx_back.fillText(text_back_top_subtitle, 1600, 170);
                                    }else{
                                        text_back_top_subtitle = " ";
                                        ctx_back.fillText(text_back_top_subtitle, 1600, 170);
                                    }

                              }else if(get_back_card_type == "2 Team Square"){

                                    var text_back_top_title = "branches.guildmortgage.com/st/city";
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "50px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "left";
                                    ctx_back.fillText(text_back_top_title, 80, 100);

                                    ctx_back.fillStyle = "#994396";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "55px 'CircularStd-Bold'";
                                    var text_back_top_subtitle = "Se habla espanol";
                                    ctx_back.textAlign = "left";

                                    var get_spanish = $("#spanish-se-habla-espanol").val();

                                    if(get_spanish == "Yes"){
                                        text_back_top_subtitle = "Se habla espanol";
                                        ctx_back.fillText(text_back_top_subtitle, 80, 170);
                                    }else{
                                        text_back_top_subtitle = " ";
                                        ctx_back.fillText(text_back_top_subtitle, 80, 170);
                                    }

                              }else if(get_back_card_type == "3 Team Square"){

                                    var text_back_top_title = "branches.guildmortgage.com/st/city";
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "50px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "left";
                                    ctx_back.fillText(text_back_top_title, 80, 100);

                                    ctx_back.fillStyle = "#994396";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "55px 'CircularStd-Bold'";
                                    var text_back_top_subtitle = "Se habla espanol";
                                    ctx_back.textAlign = "left";

                                    var get_spanish = $("#spanish-se-habla-espanol").val();

                                    if(get_spanish == "Yes"){
                                        text_back_top_subtitle = "Se habla espanol";
                                        ctx_back.fillText(text_back_top_subtitle, 80, 170);
                                    }else{
                                        text_back_top_subtitle = " ";
                                        ctx_back.fillText(text_back_top_subtitle, 80, 170);
                                    }

                              }else if(get_back_card_type == "4 Team Square"){

                                    var text_back_top_title = "branches.guildmortgage.com/st/city";
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "50px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "left";
                                    ctx_back.fillText(text_back_top_title, 80, 100);

                                    ctx_back.fillStyle = "#994396";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "55px 'CircularStd-Bold'";
                                    var text_back_top_subtitle = "Se habla espanol";
                                    ctx_back.textAlign = "left";

                                    var get_spanish = $("#spanish-se-habla-espanol").val();

                                    if(get_spanish == "Yes"){
                                        text_back_top_subtitle = "Se habla espanol";
                                        ctx_back.fillText(text_back_top_subtitle, 80, 170);
                                    }else{
                                        text_back_top_subtitle = " ";
                                        ctx_back.fillText(text_back_top_subtitle, 80, 170);
                                    }

                              }

                          },500);
                  }

                    setTimeout(function(){
                        applyFrontCardPreview();
                        applyBackCardPreview();
                    },2000);

                  }));

  });

  $(document).on("click",".customize_team_member_details .search-form-results-html .search_item_block",function() {

        var get_profile_id = $(this).attr("data-search-item-id");
        let get_current_profile_obj = $(this).closest(".customize_team_member_details").find(".team_member_search-box").attr("data-team-member");
          fetch("/apps/konnect/users/"+get_profile_id)
              .then(res => res.json()
                  .then(profile_json => {

                    $(this).closest(".customize_team_member_details").find('[id$="first-name"]').val(profile_json.givenName);
                    $(this).closest(".customize_team_member_details").find('[id$="last-name"]').val(profile_json.surname);
                    $(this).closest(".customize_team_member_details").find('[id$="job-title"]').val(profile_json.jobTitle);
                    $(this).closest(".customize_team_member_details").find('[id$="loan-officer-nmls"]').val(profile_json.nlmsNumber);

                    $(this).closest(".customize_team_member_details").find(".search-text").val("");
                    $(this).closest(".customize_team_member_details").find(".import_incorrect_data").css("display","none");
                    $(this).closest(".customize_team_member_details").find(".search-form-results-html").empty();

                    var get_team_member = get_current_profile_obj;

                    var get_filter_option_type = $(".customize_your_business_cards_type_selection_section").attr("data-business-card-type-selected");

                    if(get_filter_option_type == "Team"){

                          setTimeout(function(){
                              var get_back_card_type = $("input[name='properties[Team - Choose back]']:checked").val();

                              if(get_back_card_type == "2 Team Circle"){

                                if(get_team_member == 1){

                                    var canvas_info_reset = document.getElementById('reset_canvas_info');
                                    var ctx_info_reset = canvas_info_reset.getContext('2d');

                                    ctx_info_reset.rect(0, 0, 1000, 200);
                                    ctx_info_reset.fillStyle = "white";
                                    ctx_info_reset.fill();

                                    var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                    ctx_back.drawImage(sourceReset_canvas_info, 100, 710,750,190);

                                    var text_back_team_memb1_name = profile_json.givenName+" "+profile_json.surname;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "50px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "center";
                                    if ( typeof(text_back_team_memb1_name) !== "undefined" && text_back_team_memb1_name !== null ){
                                        ctx_back.fillText(text_back_team_memb1_name, 500, 750);
                                    }

                                    var text_back_team_memb1_job = profile_json.jobTitle;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "40px 'CircularStd-Book'";
                                    ctx_back.textAlign = "center";

                                    if ( typeof(text_back_team_memb1_job) !== "undefined" && profile_json.jobTitle !== null ){
                                        ctx_back.fillText(text_back_team_memb1_job, 500, 800);
                                    }

                                    var text_back_team_memb1_nmls = "NMLS "+profile_json.nlmsNumber;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "40px 'CircularStd-Book'";
                                    ctx_back.textAlign = "center";

                                    if ( typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                        ctx_back.fillText(text_back_team_memb1_nmls, 500, 850);
                                    }else{
                                        ctx_back.fillText("NMLS -", 500, 850);
                                    }
                                }

                                if(get_team_member == 2){

                                    var canvas_info_reset = document.getElementById('reset_canvas_info');
                                    var ctx_info_reset = canvas_info_reset.getContext('2d');

                                    ctx_info_reset.rect(0, 0, 1000, 200);
                                    ctx_info_reset.fillStyle = "white";
                                    ctx_info_reset.fill();

                                    var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                    ctx_back.drawImage(sourceReset_canvas_info, 850, 710,750,190);

                                    var text_back_team_memb2_name = profile_json.givenName+" "+profile_json.surname;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "50px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "center";

                                    if (typeof(text_back_team_memb2_name) !== "undefined" && text_back_team_memb2_name !== null ){
                                        ctx_back.fillText(text_back_team_memb2_name, 1200, 750);
                                    }

                                    var text_back_team_memb2_job = profile_json.jobTitle;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "40px 'CircularStd-Book'";
                                    ctx_back.textAlign = "center";

                                    if (typeof(text_back_team_memb2_job) !== "undefined" && profile_json.jobTitle !== null ){
                                        ctx_back.fillText(text_back_team_memb2_job, 1200, 800);
                                    }

                                    var text_back_team_memb2_nmls = "NMLS "+profile_json.nlmsNumber;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "40px 'CircularStd-Book'";
                                    ctx_back.textAlign = "center";

                                    if (typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                        ctx_back.fillText(text_back_team_memb2_nmls, 1200, 850);
                                    }else{
                                        ctx_back.fillText("NMLS -", 1200, 850);
                                    }
                                }

                                setTimeout(function(){
                                    applyFrontCardPreview();
                                    applyBackCardPreview();
                                },2000);

                              }else if(get_back_card_type == "3 Team Circle"){

                                if(get_team_member == 1){

                                    var canvas_info_reset = document.getElementById('reset_canvas_info');
                                    var ctx_info_reset = canvas_info_reset.getContext('2d');

                                    ctx_info_reset.rect(0, 0, 1000, 200);
                                    ctx_info_reset.fillStyle = "white";
                                    ctx_info_reset.fill();

                                    var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                    ctx_back.drawImage(sourceReset_canvas_info, 100, 690,450,190);

                                    var text_back_team_memb1_name = profile_json.givenName+" "+profile_json.surname;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "50px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "center";

                                    if (typeof(text_back_team_memb1_name) !== "undefined" && text_back_team_memb1_name !== null ){
                                        ctx_back.fillText(text_back_team_memb1_name, 350, 715);
                                    }

                                    var text_back_team_memb1_job = profile_json.jobTitle;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "40px 'CircularStd-Book'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb1_job) !== "undefined" && profile_json.jobTitle !== null ){
                                        wrapText(ctx_back, text_back_team_memb1_job, 350, 770, 390, 35);
                                        if(text_back_team_memb1_job.length>22){
                                            var text_back_team_memb1_nmls = "NMLS "+profile_json.nlmsNumber;
                                            ctx_back.fillStyle = "#262a82";
                                            ctx_back.textBaseline = 'middle';
                                            ctx_back.font = "40px 'CircularStd-Book'";
                                            ctx_back.textAlign = "center";
                                            if (typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                                ctx_back.fillText(text_back_team_memb1_nmls, 350, 850);
                                            }else{
                                                ctx_back.fillText("NMLS -", 350, 850);
                                            }
                                        }else{
                                            var text_back_team_memb1_nmls = "NMLS "+profile_json.nlmsNumber;
                                            ctx_back.fillStyle = "#262a82";
                                            ctx_back.textBaseline = 'middle';
                                            ctx_back.font = "40px 'CircularStd-Book'";
                                            ctx_back.textAlign = "center";
                                            if (typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                                ctx_back.fillText(text_back_team_memb1_nmls, 350, 820);
                                            }else{
                                                ctx_back.fillText("NMLS -", 350, 820);
                                            }
                                        }
                                    }else{
                                        var text_back_team_memb1_nmls = "NMLS "+profile_json.nlmsNumber;
                                        ctx_back.fillStyle = "#262a82";
                                        ctx_back.textBaseline = 'middle';
                                        ctx_back.font = "40px 'CircularStd-Book'";
                                        ctx_back.textAlign = "center";
                                        if (typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                            ctx_back.fillText(text_back_team_memb1_nmls, 350, 820);
                                        }else{
                                            ctx_back.fillText("NMLS -", 350, 820);
                                        }
                                    }
                                }

                                if(get_team_member == 2){

                                    var canvas_info_reset = document.getElementById('reset_canvas_info');
                                    var ctx_info_reset = canvas_info_reset.getContext('2d');

                                    ctx_info_reset.rect(0, 0, 1000, 200);
                                    ctx_info_reset.fillStyle = "white";
                                    ctx_info_reset.fill();

                                    var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                    ctx_back.drawImage(sourceReset_canvas_info, 550, 690,540,190);

                                    var text_back_team_memb2_name = profile_json.givenName+" "+profile_json.surname;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "50px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "center";

                                    if (typeof(text_back_team_memb2_name) !== "undefined" && text_back_team_memb2_name !== null ){
                                        ctx_back.fillText(text_back_team_memb2_name, 850, 715);
                                    }

                                    var text_back_team_memb2_job = profile_json.jobTitle;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "40px 'CircularStd-Book'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb2_job) !== "undefined" && profile_json.jobTitle !== null ){
                                        wrapText(ctx_back, text_back_team_memb2_job, 850, 770, 390, 35);
                                        if(text_back_team_memb2_job.length>22){
                                            var text_back_team_memb2_nmls = "NMLS "+profile_json.nlmsNumber;
                                            ctx_back.fillStyle = "#262a82";
                                            ctx_back.textBaseline = 'middle';
                                            ctx_back.font = "40px 'CircularStd-Book'";
                                            ctx_back.textAlign = "center";
                                            if (typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                                ctx_back.fillText(text_back_team_memb2_nmls, 850, 850);
                                            }else{
                                                ctx_back.fillText("NMLS -", 850, 850);
                                            }
                                        }else{
                                            var text_back_team_memb2_nmls = "NMLS "+profile_json.nlmsNumber;
                                            ctx_back.fillStyle = "#262a82";
                                            ctx_back.textBaseline = 'middle';
                                            ctx_back.font = "40px 'CircularStd-Book'";
                                            ctx_back.textAlign = "center";
                                            if (typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                                ctx_back.fillText(text_back_team_memb2_nmls, 850, 820);
                                            }else{
                                                ctx_back.fillText("NMLS -", 850, 820);
                                            }
                                        }
                                    }else{
                                        var text_back_team_memb2_nmls = "NMLS "+profile_json.nlmsNumber;
                                        ctx_back.fillStyle = "#262a82";
                                        ctx_back.textBaseline = 'middle';
                                        ctx_back.font = "40px 'CircularStd-Book'";
                                        ctx_back.textAlign = "center";
                                        if (typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                            ctx_back.fillText(text_back_team_memb2_nmls, 850, 820);
                                        }else{
                                            ctx_back.fillText("NMLS -", 850, 820);
                                        }
                                    }

                                }

                                if(get_team_member == 3){

                                    var canvas_info_reset = document.getElementById('reset_canvas_info');
                                    var ctx_info_reset = canvas_info_reset.getContext('2d');

                                    ctx_info_reset.rect(0, 0, 1000, 200);
                                    ctx_info_reset.fillStyle = "white";
                                    ctx_info_reset.fill();

                                    var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                    ctx_back.drawImage(sourceReset_canvas_info, 1150, 690,500,190);

                                    var text_back_team_memb3_name = profile_json.givenName+" "+profile_json.surname;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "50px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb3_name) !== "undefined" && text_back_team_memb3_name !== null ){
                                        ctx_back.fillText(text_back_team_memb3_name, 1350, 715);
                                    }

                                    var text_back_team_memb3_job = profile_json.jobTitle;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "40px 'CircularStd-Book'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb3_job) !== "undefined" && profile_json.jobTitle !== null ){
                                        wrapText(ctx_back, text_back_team_memb3_job, 1350, 770, 390, 35);
                                        if(text_back_team_memb3_job.length>22){
                                            var text_back_team_memb3_nmls = "NMLS "+profile_json.nlmsNumber;
                                            ctx_back.fillStyle = "#262a82";
                                            ctx_back.textBaseline = 'middle';
                                            ctx_back.font = "40px 'CircularStd-Book'";
                                            ctx_back.textAlign = "center";
                                            if (typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                                ctx_back.fillText(text_back_team_memb3_nmls, 1350, 850);
                                            }else{
                                                ctx_back.fillText("NMLS -", 1350, 850);
                                            }
                                        }else{
                                            var text_back_team_memb3_nmls = "NMLS "+profile_json.nlmsNumber;
                                            ctx_back.fillStyle = "#262a82";
                                            ctx_back.textBaseline = 'middle';
                                            ctx_back.font = "40px 'CircularStd-Book'";
                                            ctx_back.textAlign = "center";
                                            if (typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                                ctx_back.fillText(text_back_team_memb3_nmls, 1350, 820);
                                            }else{
                                                ctx_back.fillText("NMLS -", 1350, 820);
                                            }
                                        }
                                    }else{
                                        var text_back_team_memb3_nmls = "NMLS "+profile_json.nlmsNumber;
                                        ctx_back.fillStyle = "#262a82";
                                        ctx_back.textBaseline = 'middle';
                                        ctx_back.font = "40px 'CircularStd-Book'";
                                        ctx_back.textAlign = "center";
                                        if (typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                            ctx_back.fillText(text_back_team_memb3_nmls, 1350, 820);
                                        }else{
                                            ctx_back.fillText("NMLS -", 1350, 820);
                                        }
                                    }

                                }

                                setTimeout(function(){
                                    applyFrontCardPreview();
                                    applyBackCardPreview();
                                },2000);

                              }else if(get_back_card_type == "4 Team Circle"){

                                if(get_team_member == 1){

                                    var canvas_info_reset = document.getElementById('reset_canvas_info');
                                    var ctx_info_reset = canvas_info_reset.getContext('2d');

                                    ctx_info_reset.rect(0, 0, 1000, 200);
                                    ctx_info_reset.fillStyle = "white";
                                    ctx_info_reset.fill();

                                    var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                    ctx_back.drawImage(sourceReset_canvas_info, 80, 660,410,200);

                                    var text_back_team_memb1_name = profile_json.givenName+" "+profile_json.surname;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "40px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb1_name) !== "undefined" && text_back_team_memb1_name !== null ){
                                        ctx_back.fillText(text_back_team_memb1_name, 280, 700);
                                    }

                                    var text_back_team_memb1_job = profile_json.jobTitle;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "32px 'CircularStd-Book'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb1_job) !== "undefined" && profile_json.jobTitle !== null ){
                                        wrapText(ctx_back, text_back_team_memb1_job, 280, 750, 350, 35);
                                        if(text_back_team_memb1_job.length>20){
                                            var text_back_team_memb1_nmls = "NMLS "+profile_json.nlmsNumber;
                                            ctx_back.fillStyle = "#262a82";
                                            ctx_back.textBaseline = 'middle';
                                            ctx_back.font = "32px 'CircularStd-Book'";
                                            ctx_back.textAlign = "center";
                                            if (typeof(text_back_team_memb1_nmls) !== "undefined" && profile_json.nlmsNumber !== null ){
                                                ctx_back.fillText(text_back_team_memb1_nmls, 280, 830);
                                            }else{
                                                ctx_back.fillText("NMLS -", 280, 830);
                                            }
                                        }else{
                                            var text_back_team_memb1_nmls = "NMLS "+profile_json.nlmsNumber;
                                            ctx_back.fillStyle = "#262a82";
                                            ctx_back.textBaseline = 'middle';
                                            ctx_back.font = "32px 'CircularStd-Book'";
                                            ctx_back.textAlign = "center";
                                            if (typeof(text_back_team_memb1_nmls) !== "undefined" && profile_json.nlmsNumber !== null ){
                                                ctx_back.fillText(text_back_team_memb1_nmls, 280, 800);
                                            }else{
                                                ctx_back.fillText("NMLS -", 280, 800);
                                            }
                                        }
                                    }else{
                                        var text_back_team_memb1_nmls = "NMLS "+profile_json.nlmsNumber;
                                        ctx_back.fillStyle = "#262a82";
                                        ctx_back.textBaseline = 'middle';
                                        ctx_back.font = "32px 'CircularStd-Book'";
                                        ctx_back.textAlign = "center";
                                        if (typeof(text_back_team_memb1_nmls) !== "undefined" && profile_json.nlmsNumber !== null ){
                                            ctx_back.fillText(text_back_team_memb1_nmls, 280, 800);
                                        }else{
                                            ctx_back.fillText("NMLS -", 280, 800);
                                        }
                                    }

                                }

                                if(get_team_member == 2){

                                    var canvas_info_reset = document.getElementById('reset_canvas_info');
                                    var ctx_info_reset = canvas_info_reset.getContext('2d');

                                    ctx_info_reset.rect(0, 0, 1000, 200);
                                    ctx_info_reset.fillStyle = "white";
                                    ctx_info_reset.fill();

                                    var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                    ctx_back.drawImage(sourceReset_canvas_info, 500, 660,410,200);

                                    var text_back_team_memb2_name = profile_json.givenName+" "+profile_json.surname;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "40px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb2_name) !== "undefined" && text_back_team_memb2_name !== null ){
                                        ctx_back.fillText(text_back_team_memb2_name, 660, 700);
                                    }

                                    var text_back_team_memb2_job = profile_json.jobTitle;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "32px 'CircularStd-Book'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb2_job) !== "undefined" && profile_json.jobTitle !== null ){
                                        wrapText(ctx_back, text_back_team_memb2_job, 660, 750, 350, 35);
                                        if(text_back_team_memb2_job.length>20){
                                            var text_back_team_memb2_nmls = "NMLS "+profile_json.nlmsNumber;
                                            ctx_back.fillStyle = "#262a82";
                                            ctx_back.textBaseline = 'middle';
                                            ctx_back.font = "32px 'CircularStd-Book'";
                                            ctx_back.textAlign = "center";
                                            if (typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                                ctx_back.fillText(text_back_team_memb2_nmls, 660, 830);
                                            }else{
                                                ctx_back.fillText("NMLS -", 660, 830);
                                            }
                                        }else{
                                            var text_back_team_memb2_nmls = "NMLS "+profile_json.nlmsNumber;
                                            ctx_back.fillStyle = "#262a82";
                                            ctx_back.textBaseline = 'middle';
                                            ctx_back.font = "32px 'CircularStd-Book'";
                                            ctx_back.textAlign = "center";
                                            if (typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                                ctx_back.fillText(text_back_team_memb2_nmls, 660, 800);
                                            }else{
                                                ctx_back.fillText("NMLS -", 660, 800);
                                            }
                                        }
                                    }else{
                                        var text_back_team_memb2_nmls = "NMLS "+profile_json.nlmsNumber;
                                        ctx_back.fillStyle = "#262a82";
                                        ctx_back.textBaseline = 'middle';
                                        ctx_back.font = "32px 'CircularStd-Book'";
                                        ctx_back.textAlign = "center";
                                        if (typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                            ctx_back.fillText(text_back_team_memb2_nmls, 660, 800);
                                        }else{
                                            ctx_back.fillText("NMLS -", 660, 800);
                                        }
                                    }

                                }

                                if(get_team_member == 3){

                                    var canvas_info_reset = document.getElementById('reset_canvas_info');
                                    var ctx_info_reset = canvas_info_reset.getContext('2d');

                                    ctx_info_reset.rect(0, 0, 1000, 200);
                                    ctx_info_reset.fillStyle = "white";
                                    ctx_info_reset.fill();

                                    var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                    ctx_back.drawImage(sourceReset_canvas_info, 900, 660,390,200);

                                    var text_back_team_memb3_name = profile_json.givenName+" "+profile_json.surname;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "40px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb3_name) !== "undefined" && text_back_team_memb3_name !== null ){
                                        ctx_back.fillText(text_back_team_memb3_name, 1040, 700);
                                    }

                                    var text_back_team_memb3_job = profile_json.jobTitle;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "32px 'CircularStd-Book'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb3_job) !== "undefined" && profile_json.jobTitle !== null ){
                                        wrapText(ctx_back, text_back_team_memb3_job, 1040, 750, 350, 35);
                                        if(text_back_team_memb3_job.length>20){
                                            var text_back_team_memb3_nmls = "NMLS "+profile_json.nlmsNumber;
                                            ctx_back.fillStyle = "#262a82";
                                            ctx_back.textBaseline = 'middle';
                                            ctx_back.font = "32px 'CircularStd-Book'";
                                            ctx_back.textAlign = "center";
                                            if (typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                                ctx_back.fillText(text_back_team_memb3_nmls, 1040, 830);
                                            }else{
                                                ctx_back.fillText("NMLS -", 1040, 830);
                                            }
                                        }else{
                                            var text_back_team_memb3_nmls = "NMLS "+profile_json.nlmsNumber;
                                            ctx_back.fillStyle = "#262a82";
                                            ctx_back.textBaseline = 'middle';
                                            ctx_back.font = "32px 'CircularStd-Book'";
                                            ctx_back.textAlign = "center";
                                            if (typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                                ctx_back.fillText(text_back_team_memb3_nmls, 1040, 800);
                                            }else{
                                                ctx_back.fillText("NMLS -", 1040, 800);
                                            }
                                        }
                                    }else{
                                        var text_back_team_memb3_nmls = "NMLS "+profile_json.nlmsNumber;
                                        ctx_back.fillStyle = "#262a82";
                                        ctx_back.textBaseline = 'middle';
                                        ctx_back.font = "32px 'CircularStd-Book'";
                                        ctx_back.textAlign = "center";
                                        if (typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                            ctx_back.fillText(text_back_team_memb3_nmls, 1040, 800);
                                        }else{
                                            ctx_back.fillText("NMLS -", 1040, 800);
                                        }
                                    }

                                }

                                if(get_team_member == 4){

                                    var canvas_info_reset = document.getElementById('reset_canvas_info');
                                    var ctx_info_reset = canvas_info_reset.getContext('2d');

                                    ctx_info_reset.rect(0, 0, 1000, 200);
                                    ctx_info_reset.fillStyle = "white";
                                    ctx_info_reset.fill();

                                    var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                    ctx_back.drawImage(sourceReset_canvas_info, 1250, 660,410,200);

                                    var text_back_team_memb4_name = profile_json.givenName+" "+profile_json.surname;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "40px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb4_name) !== "undefined" && text_back_team_memb4_name !== null ){
                                        ctx_back.fillText(text_back_team_memb4_name, 1430, 700);
                                    }

                                    var text_back_team_memb4_job = profile_json.jobTitle;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "32px 'CircularStd-Book'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb4_job) !== "undefined" && profile_json.jobTitle !== null ){
                                        wrapText(ctx_back, text_back_team_memb4_job, 1430, 750, 350, 35);
                                        if(text_back_team_memb4_job.length>20){
                                            var text_back_team_memb4_nmls = "NMLS "+profile_json.nlmsNumber;
                                            ctx_back.fillStyle = "#262a82";
                                            ctx_back.textBaseline = 'middle';
                                            ctx_back.font = "32px 'CircularStd-Book'";
                                            ctx_back.textAlign = "center";
                                            if (typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                                ctx_back.fillText(text_back_team_memb4_nmls, 1430, 830);
                                            }else{
                                                ctx_back.fillText("NMLS -", 1430, 830);
                                            }
                                        }else{
                                            var text_back_team_memb4_nmls = "NMLS "+profile_json.nlmsNumber;
                                            ctx_back.fillStyle = "#262a82";
                                            ctx_back.textBaseline = 'middle';
                                            ctx_back.font = "32px 'CircularStd-Book'";
                                            ctx_back.textAlign = "center";
                                            if (typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                                ctx_back.fillText(text_back_team_memb4_nmls, 1430, 800);
                                            }else{
                                                ctx_back.fillText("NMLS -", 1430, 800);
                                            }
                                        }
                                    }else{
                                        var text_back_team_memb4_nmls = "NMLS "+profile_json.nlmsNumber;
                                        ctx_back.fillStyle = "#262a82";
                                        ctx_back.textBaseline = 'middle';
                                        ctx_back.font = "32px 'CircularStd-Book'";
                                        ctx_back.textAlign = "center";
                                        if (typeof(profile_json.nlmsNumber) !== "undefined" && profile_json.nlmsNumber !== null ){
                                            ctx_back.fillText(text_back_team_memb4_nmls, 1430, 800);
                                        }else{
                                            ctx_back.fillText("NMLS -", 1430, 800);
                                        }
                                    }

                                }

                                setTimeout(function(){
                                    applyFrontCardPreview();
                                    applyBackCardPreview();
                                },2000);

                              }else if(get_back_card_type == "2 Team Square"){

                                if(get_team_member == 1){
                                    var text_back_team_memb1_name = profile_json.givenName+" "+profile_json.surname;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "13px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb1_name) !== "undefined" && text_back_team_memb1_name !== null ){
                                        ctx_back.fillText(text_back_team_memb1_name, 135, 210);
                                    }

                                    var text_back_team_memb1_job = profile_json.jobTitle;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "12px 'CircularSpotifyText-Light'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb1_job) !== "undefined" && profile_json.jobTitle !== null ){
                                        ctx_back.fillText(text_back_team_memb1_job, 135, 228);
                                    }

                                    var text_back_team_memb1_nmls = "NMLS "+profile_json.nlmsNumber;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "12px 'CircularSpotifyText-Light'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb1_nmls) !== "undefined" && profile_json.nlmsNumber !== null ){
                                        ctx_back.fillText(text_back_team_memb1_nmls, 135, 242);
                                    }
                                }

                                if(get_team_member == 2){
                                    var text_back_team_memb2_name = profile_json.givenName+" "+profile_json.surname;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "13px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb2_name) !== "undefined" && text_back_team_memb2_name !== null ){
                                        ctx_back.fillText(text_back_team_memb2_name, 325, 210);
                                    }

                                    var text_back_team_memb2_job = profile_json.jobTitle;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "12px 'CircularSpotifyText-Light'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb2_job) !== "undefined" && profile_json.jobTitle !== null ){
                                        ctx_back.fillText(text_back_team_memb2_job, 325, 228);
                                    }

                                    var text_back_team_memb2_nmls = "NMLS "+profile_json.nlmsNumber;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "12px 'CircularSpotifyText-Light'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb2_nmls) !== "undefined" && profile_json.nlmsNumber !== null ){
                                        ctx_back.fillText(text_back_team_memb2_nmls, 325, 242);
                                    }
                                }

                              }else if(get_back_card_type == "3 Team Square"){

                                if(get_team_member == 1){
                                    var text_back_team_memb1_name = profile_json.givenName+" "+profile_json.surname;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "13px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb1_name) !== "undefined" && text_back_team_memb1_name !== null ){
                                        ctx_back.fillText(text_back_team_memb1_name, 85, 210);
                                    }

                                    var text_back_team_memb1_job = profile_json.jobTitle;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "12px 'CircularSpotifyText-Light'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb1_job) !== "undefined" && profile_json.jobTitle !== null ){
                                        ctx_back.fillText(text_back_team_memb1_job, 85, 228);
                                    }

                                    var text_back_team_memb1_nmls = "NMLS "+profile_json.nlmsNumber;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "12px 'CircularSpotifyText-Light'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb1_nmls) !== "undefined" && profile_json.nlmsNumber !== null ){
                                        ctx_back.fillText(text_back_team_memb1_nmls, 85, 242);
                                    }
                                }

                                if(get_team_member == 2){
                                    var text_back_team_memb2_name = profile_json.givenName+" "+profile_json.surname;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "13px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb2_name) !== "undefined" && text_back_team_memb2_name !== null ){
                                        ctx_back.fillText(text_back_team_memb2_name, 230, 210);
                                    }

                                    var text_back_team_memb2_job = profile_json.jobTitle;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "12px 'CircularSpotifyText-Light'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb2_job) !== "undefined" && profile_json.jobTitle !== null ){
                                        ctx_back.fillText(text_back_team_memb2_job, 230, 228);
                                    }

                                    var text_back_team_memb2_nmls = "NMLS "+profile_json.nlmsNumber;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "12px 'CircularSpotifyText-Light'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb2_nmls) !== "undefined" && profile_json.nlmsNumber !== null ){
                                        ctx_back.fillText(text_back_team_memb2_nmls, 230, 242);
                                    }
                                }

                                if(get_team_member == 3){
                                    var text_back_team_memb3_name = profile_json.givenName+" "+profile_json.surname;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "13px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb3_name) !== "undefined" && text_back_team_memb3_name !== null ){
                                        ctx_back.fillText(text_back_team_memb3_name, 377, 210);
                                    }

                                    var text_back_team_memb3_job = profile_json.jobTitle;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "12px 'CircularSpotifyText-Light'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb3_job) !== "undefined" && profile_json.jobTitle !== null ){
                                        ctx_back.fillText(text_back_team_memb3_job, 377, 228);
                                    }

                                    var text_back_team_memb3_nmls = "NMLS "+profile_json.nlmsNumber;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "12px 'CircularSpotifyText-Light'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb3_nmls) !== "undefined" && profile_json.nlmsNumber !== null ){
                                        ctx_back.fillText(text_back_team_memb3_nmls, 377, 242);
                                    }
                                }

                              }else if(get_back_card_type == "4 Team Square"){

                                if(get_team_member == 1){
                                    var text_back_team_memb1_name = profile_json.givenName+" "+profile_json.surname;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "12px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb1_name) !== "undefined" && text_back_team_memb1_name !== null ){
                                        ctx_back.fillText(text_back_team_memb1_name, 68, 200);
                                    }

                                    var text_back_team_memb1_job = profile_json.jobTitle;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "9px 'CircularSpotifyText-Light'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb1_job) !== "undefined" && profile_json.jobTitle !== null ){
                                        ctx_back.fillText(text_back_team_memb1_job, 68, 218);
                                    }

                                    var text_back_team_memb1_nmls = "NMLS "+profile_json.nlmsNumber;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "9px 'CircularSpotifyText-Light'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb1_nmls) !== "undefined" && profile_json.nlmsNumber !== null ){
                                        ctx_back.fillText(text_back_team_memb1_nmls, 68, 232);
                                    }
                                }

                                if(get_team_member == 2){
                                    var text_back_team_memb2_name = profile_json.givenName+" "+profile_json.surname;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "12px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb2_name) !== "undefined" && text_back_team_memb2_name !== null ){
                                        ctx_back.fillText(text_back_team_memb2_name, 176, 200);
                                    }

                                    var text_back_team_memb2_job = profile_json.jobTitle;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "9px 'CircularSpotifyText-Light'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb2_job) !== "undefined" && profile_json.jobTitle !== null ){
                                        ctx_back.fillText(text_back_team_memb2_job, 176, 218);
                                    }

                                    var text_back_team_memb2_nmls = "NMLS "+profile_json.nlmsNumber;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "9px 'CircularSpotifyText-Light'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb2_nmls) !== "undefined" && profile_json.nlmsNumber !== null ){
                                        ctx_back.fillText(text_back_team_memb2_nmls, 176, 232);
                                    }
                                }

                                if(get_team_member == 3){
                                    var text_back_team_memb3_name = profile_json.givenName+" "+profile_json.surname;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "12px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb3_name) !== "undefined" && text_back_team_memb3_name !== null ){
                                        ctx_back.fillText(text_back_team_memb3_name, 283, 200);
                                    }

                                    var text_back_team_memb3_job = profile_json.jobTitle;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "9px 'CircularSpotifyText-Light'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb3_job) !== "undefined" && profile_json.jobTitle !== null ){
                                        ctx_back.fillText(text_back_team_memb3_job, 283, 218);
                                    }

                                    var text_back_team_memb3_nmls = "NMLS "+profile_json.nlmsNumber;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "9px 'CircularSpotifyText-Light'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb3_nmls) !== "undefined" && profile_json.nlmsNumber !== null ){
                                        ctx_back.fillText(text_back_team_memb3_nmls, 283, 232);
                                    }
                                }

                                if(get_team_member == 4){
                                    var text_back_team_memb3_name = profile_json.givenName+" "+profile_json.surname;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "12px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb3_name) !== "undefined" && text_back_team_memb3_name !== null ){
                                        ctx_back.fillText(text_back_team_memb3_name, 390, 200);
                                    }

                                    var text_back_team_memb3_job = profile_json.jobTitle;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "9px 'CircularSpotifyText-Light'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb3_job) !== "undefined" && profile_json.jobTitle !== null ){
                                        ctx_back.fillText(text_back_team_memb3_job, 390, 218);
                                    }

                                    var text_back_team_memb3_nmls = "NMLS "+profile_json.nlmsNumber;
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "9px 'CircularSpotifyText-Light'";
                                    ctx_back.textAlign = "center";
                                    if (typeof(text_back_team_memb3_nmls) !== "undefined" && profile_json.nlmsNumber !== null ){
                                        ctx_back.fillText(text_back_team_memb3_nmls, 390, 232);
                                    }
                                }

                              }

                          },500);

                    }

                  }));

  });

  $(document).on("click",".customize_team_member_details .search-clear",function() {
          $(this).closest(".customize_team_member_details").find('[id$="first-name"]').val("");
          $(this).closest(".customize_team_member_details").find('[id$="last-name"]').val("");
          $(this).closest(".customize_team_member_details").find('[id$="job-title"]').val("");

          $(this).closest(".customize_team_member_details").find(".search-text").val("");
          $(this).closest(".customize_team_member_details").find(".import_incorrect_data").css("display","none");
          $(this).closest(".customize_team_member_details").find(".search-form-results-html").empty();
  });

		$(document).on("change", "#file", function(e) {
		    var image, file;
		
		    image = new Image;
		    file = new FileReader;

		    // Read file
		    file.onload = function(e) {
		        // Image loaded
		        image.onload = function() {
		
    		       setTimeout(function() {

                         var get_filter_option_type = $(".customize_your_business_cards_type_selection_section").attr("data-business-card-type-selected");
                         var canvas_front_pro_pic_circle = document.getElementById('main_profile-picture-canvas-circle');
                         var canvas_front_pro_pic_square = document.getElementById('main_profile-picture-canvas-square');
                         var ctx_front_pic_circle = canvas_front_pro_pic_circle.getContext('2d');
                         var ctx_front_pic_square = canvas_front_pro_pic_square.getContext('2d');

                          if(get_filter_option_type == "Standard"){
                                  var get_front_card_type = $("input[name='properties[Standard - Choose front]']:checked").val();

                                  if(get_front_card_type == "Circle Picture"){	

                                        if (image.width < 520 && image.height < 520) {
                                            $(".image_quality_error_msg_stand").hide().slideDown().delay(30000).slideUp();
                                            $(".image_quality_error_msg_stand").html("Low res image detected, we encourage you to send us the original version of your photo to ensure the best possible quality, Image size minimum width: 520px and height: 520px");
                                        }else{
                                            $(".image_quality_error_msg_stand").slideUp();

                                            ctx_front_pic_circle.beginPath();
                                            ctx_front_pic_circle.arc(260, 260, 260, 0, Math.PI * 2, false)
                                            ctx_front_pic_circle.clip();
                                            ctx_front_pic_circle.drawImage(image, 0, 0,520,520);

                                            var source_canvas_front_pro_pic_circle = document.getElementById('main_profile-picture-canvas-circle');
                                            ctx.drawImage(source_canvas_front_pro_pic_circle, 1100, 70,520,520);
                                        }
                                  }else if(get_front_card_type == "Square Picture"){	

                                        if (image.width < 590 && image.height < 971) {
                                            $(".image_quality_error_msg_stand").hide().slideDown().delay(30000).slideUp();
                                            $(".image_quality_error_msg_stand").html("Low res image detected, we encourage you to send us the original version of your photo to ensure the best possible quality, Image size minimum width: 590px and height: 971px");
                                        }else{
                                            $(".image_quality_error_msg_stand").slideUp();

                                            ctx_front_pic_square.drawImage(image, 0, 0,590,971);

                                            var source_canvas_front_pro_pic_square = document.getElementById('main_profile-picture-canvas-square');
                                            ctx.drawImage(source_canvas_front_pro_pic_square, 1110, 0,590,971);

                                        }

                                  }else if(get_front_card_type == "No Picture"){	

                                  }

                                  setTimeout(function(){
                                      applyFrontCardPreview();
                                      applyBackCardPreview();
                                  },2000);
                          }else{
                                  var get_front_card_type = $("input[name='properties[Team - Choose front]']:checked").val();

                                  if(get_front_card_type == "Circle Picture"){	
                                        if (image.width < 520 && image.height < 520) {
                                            $(".image_quality_error_msg_stand").hide().slideDown().delay(30000).slideUp();
                                            $(".image_quality_error_msg_stand").html("Low res image detected, we encourage you to send us the original version of your photo to ensure the best possible quality, Image size minimum width: 520px and height: 520px");
                                        }else{
                                            $(".image_quality_error_msg_stand").slideUp();
                                            ctx.beginPath();
                                            ctx.arc(1360, 330, 260, 0, Math.PI * 2, false)
                                            ctx.clip();
                                            ctx.drawImage(image, 1100, 70,520,520);
                                        }
                                  }else if(get_front_card_type == "Square Picture"){
                                        if (image.width < 590 && image.height < 971) {
                                            $(".image_quality_error_msg_stand").hide().slideDown().delay(30000).slideUp();
                                            $(".image_quality_error_msg_stand").html("Low res image detected, we encourage you to send us the original version of your photo to ensure the best possible quality, Image size minimum width: 590px and height: 971px");
                                        }else{
                                            $(".image_quality_error_msg_stand").slideUp();                                    	
                                            ctx.clearRect(1150, 0, 520, 971);
                                            ctx.drawImage(image, 1110, 0,590,971);
                                        }
                                  }else if(get_front_card_type == "No Picture"){	

                                  }

                                  setTimeout(function(){
                                      applyFrontCardPreview();
                                      applyBackCardPreview();
                                  },2000);
                          }

		            }, 10, clearTimeout)

		        };
		        image.src = e.target.result;
		    };
		    file.readAsDataURL(e.target.files[0]);
		});

  if($('#file').get(0).files.length === 0){
  }

		$(document).on("change", "#team_1_profile-picture", function(e) {
		    var image, file;
		
		    image = new Image;
		    file = new FileReader;

		    // Read file
		    file.onload = function(e) {
		        // Image loaded
		        image.onload = function() {
		
    		       setTimeout(function() {

                         var get_filter_option_type = $(".customize_your_business_cards_type_selection_section").attr("data-business-card-type-selected");

                          if(get_filter_option_type == "Team"){
                                  var get_back_card_type = $("input[name='properties[Team - Choose back]']:checked").val();
                                  var canvas_back_pro_1 = document.getElementById('team_1_profile-picture-canvas');
                                  var ctx_back_pro_1 = canvas_back_pro_1.getContext('2d');

                                  if(get_back_card_type == "2 Team Circle"){	
                                        if (image.width < 500 && image.height < 500) {
                                            $(".image_quality_error_msg_team").hide().slideDown().delay(30000).slideUp();
                                            $(".image_quality_error_msg_team").html("Low res image detected, we encourage you to send us the original version of your photo to ensure the best possible quality, Image size minimum width: 500px and height: 500px");
                                        }else{
                                            $(".image_quality_error_msg_team").slideUp();
                                            ctx_back_pro_1.beginPath();
                                            ctx_back_pro_1.arc(250, 250, 250, 0, Math.PI * 2, false)
                                            ctx_back_pro_1.clip();
                                            ctx_back_pro_1.drawImage(image, 0, 0,500,500);

                                            // select QR canvas elements
                                            var sourceCanvasPro1 = document.getElementById('team_1_profile-picture-canvas');
                                            ctx_back.drawImage(sourceCanvasPro1, 300, 300,400,400);
                                        }

                                  }else if(get_back_card_type == "3 Team Circle"){	

                                        if (image.width < 500 && image.height < 500) {
                                            $(".image_quality_error_msg_team").hide().slideDown().delay(30000).slideUp();
                                            $(".image_quality_error_msg_team").html("Low res image detected, we encourage you to send us the original version of your photo to ensure the best possible quality, Image size minimum width: 500px and height: 500px");
                                        }else{
                                            $(".image_quality_error_msg_team").slideUp();
                                            ctx_back_pro_1.beginPath();
                                            ctx_back_pro_1.arc(250, 250, 250, 0, Math.PI * 2, false)
                                            ctx_back_pro_1.clip();
                                            ctx_back_pro_1.drawImage(image, 0, 0,500,500);

                                            // select QR canvas elements
                                            var sourceCanvasPro1 = document.getElementById('team_1_profile-picture-canvas');
                                            ctx_back.drawImage(sourceCanvasPro1, 160, 300,360,360);
                                        }
                                  }else if(get_back_card_type == "4 Team Circle"){	
                                        if (image.width < 500 && image.height < 500) {
                                            $(".image_quality_error_msg_team").hide().slideDown().delay(30000).slideUp();
                                            $(".image_quality_error_msg_team").html("Low res image detected, we encourage you to send us the original version of your photo to ensure the best possible quality, Image size minimum width: 500px and height: 500px");
                                        }else{
                                            $(".image_quality_error_msg_team").slideUp();

                                            ctx_back_pro_1.beginPath();
                                            ctx_back_pro_1.arc(250, 250, 250, 0, Math.PI * 2, false)
                                            ctx_back_pro_1.clip();
                                            ctx_back_pro_1.drawImage(image, 0, 0,500,500);

                                            // select QR canvas elements
                                            var sourceCanvasPro1 = document.getElementById('team_1_profile-picture-canvas');
                                            ctx_back.drawImage(sourceCanvasPro1, 140, 340,290,290);
                                        }
                                  }

                                  setTimeout(function(){
                                      applyFrontCardPreview();
                                      applyBackCardPreview();
                                  },2000);
                          }

		            }, 10, clearTimeout)

		        };
		        image.src = e.target.result;
		    };
		    file.readAsDataURL(e.target.files[0]);
		});

		$(document).on("change", "#team_2_profile-picture", function(e) {
		    var image, file;
		
		    image = new Image;
		    file = new FileReader;

		    // Read file
		    file.onload = function(e) {
		        // Image loaded
		        image.onload = function() {
		
    		       setTimeout(function() {

                         var get_filter_option_type = $(".customize_your_business_cards_type_selection_section").attr("data-business-card-type-selected");

                          if(get_filter_option_type == "Team"){
                                  var get_back_card_type = $("input[name='properties[Team - Choose back]']:checked").val();
                                  var canvas_back_pro_2 = document.getElementById('team_2_profile-picture-canvas');
                                  var ctx_back_pro_2 = canvas_back_pro_2.getContext('2d');

                                  if(get_back_card_type == "2 Team Circle"){	
                                        if (image.width < 500 && image.height < 500) {
                                            $(".image_quality_error_msg_team").hide().slideDown().delay(30000).slideUp();
                                            $(".image_quality_error_msg_team").html("Low res image detected, we encourage you to send us the original version of your photo to ensure the best possible quality, Image size minimum width: 500px and height: 500px");
                                        }else{
                                            $(".image_quality_error_msg_team").slideUp();
                                            ctx_back_pro_2.beginPath();
                                            ctx_back_pro_2.arc(250, 250, 250, 0, Math.PI * 2, false)
                                            ctx_back_pro_2.clip();
                                            ctx_back_pro_2.drawImage(image, 0, 0,500,500);

                                            // select QR canvas elements
                                            var sourceCanvasPro2 = document.getElementById('team_2_profile-picture-canvas');
                                            ctx_back.drawImage(sourceCanvasPro2, 987, 300,400,400);
                                        }

                                  }else if(get_back_card_type == "3 Team Circle"){	
                                        if (image.width < 500 && image.height < 500) {
                                            $(".image_quality_error_msg_team").hide().slideDown().delay(30000).slideUp();
                                            $(".image_quality_error_msg_team").html("Low res image detected, we encourage you to send us the original version of your photo to ensure the best possible quality, Image size minimum width: 500px and height: 500px");
                                        }else{
                                            $(".image_quality_error_msg_team").slideUp();
                                            ctx_back_pro_2.beginPath();
                                            ctx_back_pro_2.arc(250, 250, 250, 0, Math.PI * 2, false)
                                            ctx_back_pro_2.clip();
                                            ctx_back_pro_2.drawImage(image, 0, 0,500,500);

                                            // select QR canvas elements
                                            var sourceCanvasPro2 = document.getElementById('team_2_profile-picture-canvas');
                                            ctx_back.drawImage(sourceCanvasPro2, 670, 300,360,360);
                                        }
                                  }else if(get_back_card_type == "4 Team Circle"){	
                                        if (image.width < 500 && image.height < 500) {
                                            $(".image_quality_error_msg_team").hide().slideDown().delay(30000).slideUp();
                                            $(".image_quality_error_msg_team").html("Low res image detected, we encourage you to send us the original version of your photo to ensure the best possible quality, Image size minimum width: 500px and height: 500px");
                                        }else{
                                            $(".image_quality_error_msg_team").slideUp();
                                            ctx_back_pro_2.beginPath();
                                            ctx_back_pro_2.arc(250, 250, 250, 0, Math.PI * 2, false)
                                            ctx_back_pro_2.clip();
                                            ctx_back_pro_2.drawImage(image, 0, 0,500,500);

                                            // select QR canvas elements
                                            var sourceCanvasPro2 = document.getElementById('team_2_profile-picture-canvas');
                                            ctx_back.drawImage(sourceCanvasPro2, 510, 340,290,290);
                                        }
                                  }

                                  setTimeout(function(){
                                      applyFrontCardPreview();
                                      applyBackCardPreview();
                                  },2000);
                          }

		            }, 10, clearTimeout)

		        };
		        image.src = e.target.result;
		    };
		    file.readAsDataURL(e.target.files[0]);
		});

		$(document).on("change", "#team_3_profile-picture", function(e) {
		    var image, file;
		
		    image = new Image;
		    file = new FileReader;

		    // Read file
		    file.onload = function(e) {
		        // Image loaded
		        image.onload = function() {
		
    		       setTimeout(function() {

                         var get_filter_option_type = $(".customize_your_business_cards_type_selection_section").attr("data-business-card-type-selected");

                          if(get_filter_option_type == "Team"){
                                  var get_back_card_type = $("input[name='properties[Team - Choose back]']:checked").val();
                                  var canvas_back_pro_3 = document.getElementById('team_3_profile-picture-canvas');
                                  var ctx_back_pro_3 = canvas_back_pro_3.getContext('2d');

                                  if(get_back_card_type == "2 Team Circle"){	

                                  }else if(get_back_card_type == "3 Team Circle"){	
                                        if (image.width < 500 && image.height < 500) {
                                            $(".image_quality_error_msg_team").hide().slideDown().delay(30000).slideUp();
                                            $(".image_quality_error_msg_team").html("Low res image detected, we encourage you to send us the original version of your photo to ensure the best possible quality, Image size minimum width: 500px and height: 500px");
                                        }else{
                                            $(".image_quality_error_msg_team").slideUp();

                                            ctx_back_pro_3.beginPath();
                                            ctx_back_pro_3.arc(250, 250, 250, 0, Math.PI * 2, false)
                                            ctx_back_pro_3.clip();
                                            ctx_back_pro_3.drawImage(image, 0, 0,500,500);

                                            // select QR canvas elements
                                            var sourceCanvasPro3 = document.getElementById('team_3_profile-picture-canvas');
                                            ctx_back.drawImage(sourceCanvasPro3, 1170, 300,360,360);
                                        }
                                  }else if(get_back_card_type == "4 Team Circle"){	
                                        if (image.width < 500 && image.height < 500) {
                                            $(".image_quality_error_msg_team").hide().slideDown().delay(30000).slideUp();
                                            $(".image_quality_error_msg_team").html("Low res image detected, we encourage you to send us the original version of your photo to ensure the best possible quality, Image size minimum width: 500px and height: 500px");
                                        }else{
                                            $(".image_quality_error_msg_team").slideUp();

                                            ctx_back_pro_3.beginPath();
                                            ctx_back_pro_3.arc(250, 250, 250, 0, Math.PI * 2, false)
                                            ctx_back_pro_3.clip();
                                            ctx_back_pro_3.drawImage(image, 0, 0,500,500);

                                            // select QR canvas elements
                                            var sourceCanvasPro3 = document.getElementById('team_3_profile-picture-canvas');
                                            ctx_back.drawImage(sourceCanvasPro3, 900, 340,290,290);
                                        }
                                  }

                                  setTimeout(function(){
                                      applyFrontCardPreview();
                                      applyBackCardPreview();
                                  },2000);
                          }

		            }, 10, clearTimeout)

		        };
		        image.src = e.target.result;
		    };
		    file.readAsDataURL(e.target.files[0]);
		});

		$(document).on("change", "#team_4_profile-picture", function(e) {
		    var image, file;
		
		    image = new Image;
		    file = new FileReader;

		    // Read file
		    file.onload = function(e) {
		        // Image loaded
		        image.onload = function() {
		
    		       setTimeout(function() {

                         var get_filter_option_type = $(".customize_your_business_cards_type_selection_section").attr("data-business-card-type-selected");

                          if(get_filter_option_type == "Team"){
                                  var get_back_card_type = $("input[name='properties[Team - Choose back]']:checked").val();
                                  var canvas_back_pro_4 = document.getElementById('team_4_profile-picture-canvas');
                                  var ctx_back_pro_4 = canvas_back_pro_4.getContext('2d');

                                  if(get_back_card_type == "2 Team Circle"){	

                                  }else if(get_back_card_type == "3 Team Circle"){	

                                  }else if(get_back_card_type == "4 Team Circle"){	

                                        if (image.width < 500 && image.height < 500) {
                                            $(".image_quality_error_msg_team").hide().slideDown().delay(30000).slideUp();
                                            $(".image_quality_error_msg_team").html("Low res image detected, we encourage you to send us the original version of your photo to ensure the best possible quality, Image size minimum width: 500px and height: 500px");
                                        }else{
                                            $(".image_quality_error_msg_team").slideUp();

                                            ctx_back_pro_4.beginPath();
                                            ctx_back_pro_4.arc(250, 250, 250, 0, Math.PI * 2, false)
                                            ctx_back_pro_4.clip();
                                            ctx_back_pro_4.drawImage(image, 0, 0,500,500);

                                            // select QR canvas elements
                                            var sourceCanvasPro4 = document.getElementById('team_4_profile-picture-canvas');
                                            ctx_back.drawImage(sourceCanvasPro4, 1280, 340,290,290);

                                        }
                                  }

                                  setTimeout(function(){
                                      applyFrontCardPreview();
                                      applyBackCardPreview();
                                  },2000);
                          }

		            }, 10, clearTimeout)

		        };
		        image.src = e.target.result;
		    };
		    file.readAsDataURL(e.target.files[0]);
		});

  $('[type="text"]').on('keyup keypress', function(e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
      e.preventDefault();
      return false;
    }
  });

  $("input[name='properties[Custom URL]']").on('click', function (){
      if($(this).is(':checked')){
        $("#qrUrl").removeClass("input_lock_field");
      }else{
        var get_default_officer_url = $(".product_page_customize_business_card_section").find("#qrUrl").attr("data-officer-url");
        $(".product_page_customize_business_card_section").find("#qrUrl").val(get_default_officer_url);
        $("#qrUrl").addClass("input_lock_field");
      }
  });

  $("#properties_pronouns").on('change', function (){
      $("#pronouns").val($(this).val());
      if ($('#properties_pronouns').val().length == 0) {
            $("#pronouns").val("No");
      }

  });

  $("#line-item_switch-rounded-business").on('change', function (){
    $('#business').trigger("change");
  });

  $("#line-item_switch-rounded-mobile").on('change', function (){
    $('#main_mobile').trigger("change");
  });

  $("#line-item_switch-rounded-fax").on('change', function (){
    $('#fax').trigger("change");
  });

  $('#business,#main_mobile,#fax').on('keyup change', function(e) {

    var input_data_value_fax = $('#fax').val();
    var input_data_value_main_mobile = $('#main_mobile').val();
    var input_data_value_business = $('#business').val();

    var arr_card_contact_number_edit = [];

    // append new value to the array
    if ( typeof(input_data_value_fax) !== "undefined" && input_data_value_fax !== null && input_data_value_fax.length != 0){
        let obj_contact = { name: "faxNumber", value: input_data_value_fax };
        arr_card_contact_number_edit.push(obj_contact);
    }
    if ( typeof(input_data_value_main_mobile) !== "undefined" && input_data_value_main_mobile !== null && input_data_value_main_mobile.length != 0 ){
        let obj_contact = { name: "mobilePhone", value: input_data_value_main_mobile };
        arr_card_contact_number_edit.push(obj_contact);
    }

    if ( typeof(input_data_value_business) !== "undefined" && input_data_value_business !== null && input_data_value_business.length != 0 ){
        let obj_contact = { name: "businessPhones", value: input_data_value_business };
        arr_card_contact_number_edit.push(obj_contact);
    }

    if(arr_card_contact_number_edit.length > 0){

         var get_filter_option_type = $(".customize_your_business_cards_type_selection_section").attr("data-business-card-type-selected");

        var sourceReset_canvas_info_full = document.getElementById('reset_canvas_info');
        ctx.drawImage(sourceReset_canvas_info_full, 60, 595,405,200);

          if(get_filter_option_type == "Team"){
                  var get_front_card_type = $("input[name='properties[Team - Choose front]']:checked").val();
                  var canvas_info_reset = document.getElementById('reset_canvas_info');
                  var ctx_info_reset = canvas_info_reset.getContext('2d');

                  if(get_front_card_type == "No Picture"){	

                        for (var i = 0; i < arr_card_contact_number_edit.length; i++) {
                            var text_label_number = "";
                            var get_value_Number = "";
                            if(arr_card_contact_number_edit[i].name == "faxNumber"){
                                text_label_number = "F ";
                                get_value_Number = arr_card_contact_number_edit[i].value;
                            }
                            if(arr_card_contact_number_edit[i].name == "mobilePhone"){
                                text_label_number = "M ";
                                get_value_Number = arr_card_contact_number_edit[i].value;
                            }
                            if(arr_card_contact_number_edit[i].name == "businessPhones"){
                                text_label_number = "O ";
                                get_value_Number = arr_card_contact_number_edit[i].value;
                            }

                            var sourceReset_canvas_info_full = document.getElementById('reset_canvas_info');

                            if (i == 0){

                                ctx_info_reset.rect(0, 0, 1000, 200);
                                ctx_info_reset.fillStyle = "white";
                                ctx_info_reset.fill();

                                var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                if ( typeof(get_value_Number) !== "undefined" && get_value_Number !== null && get_value_Number.length != 0 ){
                                    ctx.drawImage(sourceReset_canvas_info, 60, 595,405,50);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Bold'";
                                    ctx.fillText(text_label_number, 60, 620);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Book'";
                                    ctx.fillText(get_value_Number, 115, 620);
                                }else{
                                    ctx.drawImage(sourceReset_canvas_info, 60, 595,405,50);
                                }

                            }

                            if (i == 1){

                                ctx_info_reset.rect(0, 0, 1000, 200);
                                ctx_info_reset.fillStyle = "white";
                                ctx_info_reset.fill();

                                var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                if ( typeof(get_value_Number) !== "undefined" && get_value_Number !== null && get_value_Number.length != 0 ){
                                    ctx.drawImage(sourceReset_canvas_info, 60, 670,405,50);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Bold'";
                                    ctx.fillText(text_label_number, 60, 690);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Book'";
                                    ctx.fillText(get_value_Number, 115, 690);
                                }else{
                                    ctx.drawImage(sourceReset_canvas_info, 60, 670,405,50);
                                }

                            }

                            if (i == 2){

                                ctx_info_reset.rect(0, 0, 1000, 200);
                                ctx_info_reset.fillStyle = "white";
                                ctx_info_reset.fill();

                                var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                if ( typeof(get_value_Number) !== "undefined" && get_value_Number !== null && get_value_Number.length != 0 ){
                                    ctx.drawImage(sourceReset_canvas_info, 60, 740,405,50);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Bold'";
                                    ctx.fillText(text_label_number, 60, 760);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Book'";
                                    ctx.fillText(get_value_Number, 115, 760);
                                }else{
                                    ctx.drawImage(sourceReset_canvas_info, 60, 740,405,50);
                                }

                            }

                        }

                  }else if(get_front_card_type == "Circle Picture"){	

                        for (var i = 0; i < arr_card_contact_number_edit.length; i++) {
                            var text_label_number = "";
                            var get_value_Number = "";
                            if(arr_card_contact_number_edit[i].name == "faxNumber"){
                                text_label_number = "F ";
                                get_value_Number = arr_card_contact_number_edit[i].value;
                            }
                            if(arr_card_contact_number_edit[i].name == "mobilePhone"){
                                text_label_number = "M ";
                                get_value_Number = arr_card_contact_number_edit[i].value;
                            }
                            if(arr_card_contact_number_edit[i].name == "businessPhones"){
                                text_label_number = "O ";
                                get_value_Number = arr_card_contact_number_edit[i].value;
                            }

                            if (i == 0){

                                ctx_info_reset.rect(0, 0, 1000, 200);
                                ctx_info_reset.fillStyle = "white";
                                ctx_info_reset.fill();

                                var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                if ( typeof(get_value_Number) !== "undefined" && get_value_Number !== null && get_value_Number.length != 0){
                                    ctx.drawImage(sourceReset_canvas_info, 60, 595,405,50);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Bold'";
                                    ctx.fillText(text_label_number, 60, 620);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Book'";
                                    ctx.fillText(get_value_Number, 115, 620);
                                }else{
                                    ctx.drawImage(sourceReset_canvas_info, 60, 595,405,50);
                                }

                            }

                            if (i == 1){

                                ctx_info_reset.rect(0, 0, 1000, 200);
                                ctx_info_reset.fillStyle = "white";
                                ctx_info_reset.fill();

                                var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                if ( typeof(get_value_Number) !== "undefined" && get_value_Number !== null && get_value_Number.length != 0){
                                    ctx.drawImage(sourceReset_canvas_info, 60, 668,405,50);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Bold'";
                                    ctx.fillText(text_label_number, 60, 690);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Book'";
                                    ctx.fillText(get_value_Number, 115, 690);
                                }else{
                                    ctx.drawImage(sourceReset_canvas_info, 60, 668,405,50);
                                }

                            }

                            if (i == 2){

                                ctx_info_reset.rect(0, 0, 1000, 200);
                                ctx_info_reset.fillStyle = "white";
                                ctx_info_reset.fill();

                                var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                if ( typeof(get_value_Number) !== "undefined" && get_value_Number !== null && get_value_Number.length != 0){
                                    ctx.drawImage(sourceReset_canvas_info, 60, 740,405,50);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Bold'";
                                    ctx.fillText(text_label_number, 60, 760);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Book'";
                                    ctx.fillText(get_value_Number, 115, 760);
                                }else{
                                    ctx.drawImage(sourceReset_canvas_info, 60, 740,405,50);
                                }

                            }

                        }

                  }else if(get_front_card_type == "Square Picture"){	

                        for (var i = 0; i < arr_card_contact_number_edit.length; i++) {
                            var text_label_number = "";
                            var get_value_Number = "";
                            if(arr_card_contact_number_edit[i].name == "faxNumber"){
                                text_label_number = "F ";
                                get_value_Number = arr_card_contact_number_edit[i].value;
                            }
                            if(arr_card_contact_number_edit[i].name == "mobilePhone"){
                                text_label_number = "M ";
                                get_value_Number = arr_card_contact_number_edit[i].value;
                            }
                            if(arr_card_contact_number_edit[i].name == "businessPhones"){
                                text_label_number = "O ";
                                get_value_Number = arr_card_contact_number_edit[i].value;
                            }

                            if (i == 0){

                                ctx_info_reset.rect(0, 0, 1000, 200);
                                ctx_info_reset.fillStyle = "white";
                                ctx_info_reset.fill();

                                var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                if ( typeof(get_value_Number) !== "undefined" && get_value_Number !== null && get_value_Number.length != 0 ){
                                    ctx.drawImage(sourceReset_canvas_info, 60, 595,405,50);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Bold'";
                                    ctx.fillText(text_label_number, 60, 620);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Book'";
                                    ctx.fillText(get_value_Number, 115, 620);
                                }else{
                                    ctx.drawImage(sourceReset_canvas_info, 60, 595,405,50);
                                }

                            }

                            if (i == 1){

                                ctx_info_reset.rect(0, 0, 1000, 200);
                                ctx_info_reset.fillStyle = "white";
                                ctx_info_reset.fill();

                                var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                if ( typeof(get_value_Number) !== "undefined" && get_value_Number !== null && get_value_Number.length != 0 ){
                                    ctx.drawImage(sourceReset_canvas_info, 60, 670,405,50);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Bold'";
                                    ctx.fillText(text_label_number, 60, 690);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Book'";
                                    ctx.fillText(get_value_Number, 115, 690);
                                }else{
                                    ctx.drawImage(sourceReset_canvas_info, 60, 670,405,50);
                                }

                            }

                            if (i == 2){

                                ctx_info_reset.rect(0, 0, 1000, 200);
                                ctx_info_reset.fillStyle = "white";
                                ctx_info_reset.fill();

                                var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                if ( typeof(get_value_Number) !== "undefined" && get_value_Number !== null && get_value_Number.length != 0 ){
                                    ctx.drawImage(sourceReset_canvas_info, 60, 740,405,50);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Bold'";
                                    ctx.fillText(text_label_number, 60, 760);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Book'";
                                    ctx.fillText(get_value_Number, 115, 760);
                                }else{
                                    ctx.drawImage(sourceReset_canvas_info, 60, 740,405,50);
                                }

                            }

                        }

                  }

                  setTimeout(function(){
                      applyFrontCardPreview();
                      applyBackCardPreview();
                  },2000);

          }else if(get_filter_option_type == "Standard"){

                  var get_front_card_type = $("input[name='properties[Standard - Choose front]']:checked").val();
                  var canvas_info_reset = document.getElementById('reset_canvas_info');
                  var ctx_info_reset = canvas_info_reset.getContext('2d');

                  if(get_front_card_type == "No Picture"){	

                        for (var i = 0; i < arr_card_contact_number_edit.length; i++) {
                            var text_label_number = "";
                            var get_value_Number = "";
                            if(arr_card_contact_number_edit[i].name == "faxNumber"){
                                text_label_number = "F ";
                                get_value_Number = arr_card_contact_number_edit[i].value;
                            }
                            if(arr_card_contact_number_edit[i].name == "mobilePhone"){
                                text_label_number = "M ";
                                get_value_Number = arr_card_contact_number_edit[i].value;
                            }
                            if(arr_card_contact_number_edit[i].name == "businessPhones"){
                                text_label_number = "O ";
                                get_value_Number = arr_card_contact_number_edit[i].value;
                            }

                            var sourceReset_canvas_info_full = document.getElementById('reset_canvas_info');

                            if (i == 0){
                                ctx_info_reset.rect(0, 0, 1000, 200);
                                ctx_info_reset.fillStyle = "white";
                                ctx_info_reset.fill();

                                var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                if ( typeof(get_value_Number) !== "undefined" && get_value_Number !== null && get_value_Number.length != 0 ){
                                    ctx.drawImage(sourceReset_canvas_info, 60, 595,405,50);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Bold'";
                                    ctx.fillText(text_label_number, 60, 620);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Book'";
                                    ctx.fillText(get_value_Number, 115, 620);
                                }else{
                                    ctx.drawImage(sourceReset_canvas_info, 60, 595,405,50);
                                }

                            }

                            if (i == 1){
                                ctx_info_reset.rect(0, 0, 1000, 200);
                                ctx_info_reset.fillStyle = "white";
                                ctx_info_reset.fill();

                                var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                if ( typeof(get_value_Number) !== "undefined" && get_value_Number !== null && get_value_Number.length != 0 ){
                                    ctx.drawImage(sourceReset_canvas_info, 60, 670,405,50);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Bold'";
                                    ctx.fillText(text_label_number, 60, 690);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Book'";
                                    ctx.fillText(get_value_Number, 115, 690);
                                }else{
                                    ctx.drawImage(sourceReset_canvas_info, 60, 670,405,50);
                                }

                            }

                            if (i == 2){

                                ctx_info_reset.rect(0, 0, 1000, 200);
                                ctx_info_reset.fillStyle = "white";
                                ctx_info_reset.fill();

                                var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                if ( typeof(get_value_Number) !== "undefined" && get_value_Number !== null && get_value_Number.length != 0 ){
                                    ctx.drawImage(sourceReset_canvas_info, 60, 740,405,50);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Bold'";
                                    ctx.fillText(text_label_number, 60, 760);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Book'";
                                    ctx.fillText(get_value_Number, 115, 760);
                                }else{
                                    ctx.drawImage(sourceReset_canvas_info, 60, 740,405,50);
                                }

                            }

                        }

                  }else if(get_front_card_type == "Circle Picture"){	

                        for (var i = 0; i < arr_card_contact_number_edit.length; i++) {
                            var text_label_number = "";
                            var get_value_Number = "";
                            if(arr_card_contact_number_edit[i].name == "faxNumber"){
                                text_label_number = "F ";
                                get_value_Number = arr_card_contact_number_edit[i].value;
                            }
                            if(arr_card_contact_number_edit[i].name == "mobilePhone"){
                                text_label_number = "M ";
                                get_value_Number = arr_card_contact_number_edit[i].value;
                            }
                            if(arr_card_contact_number_edit[i].name == "businessPhones"){
                                text_label_number = "O ";
                                get_value_Number = arr_card_contact_number_edit[i].value;
                            }

                            if (i == 0){

                                ctx_info_reset.rect(0, 0, 1000, 200);
                                ctx_info_reset.fillStyle = "white";
                                ctx_info_reset.fill();

                                var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                if ( typeof(get_value_Number) !== "undefined" && get_value_Number !== null && get_value_Number.length != 0){
                                    ctx.drawImage(sourceReset_canvas_info, 60, 595,405,50);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Bold'";
                                    ctx.fillText(text_label_number, 60, 620);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Book'";
                                    ctx.fillText(get_value_Number, 115, 620);
                                }else{
                                    ctx.drawImage(sourceReset_canvas_info, 60, 595,405,50);
                                }

                            }

                            if (i == 1){

                                ctx_info_reset.rect(0, 0, 1000, 200);
                                ctx_info_reset.fillStyle = "white";
                                ctx_info_reset.fill();

                                var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                if ( typeof(get_value_Number) !== "undefined" && get_value_Number !== null && get_value_Number.length != 0){
                                    ctx.drawImage(sourceReset_canvas_info, 60, 668,405,50);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Bold'";
                                    ctx.fillText(text_label_number, 60, 690);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Book'";
                                    ctx.fillText(get_value_Number, 115, 690);
                                }else{
                                    ctx.drawImage(sourceReset_canvas_info, 60, 668,405,50);
                                }

                            }

                            if (i == 2){

                                ctx_info_reset.rect(0, 0, 1000, 200);
                                ctx_info_reset.fillStyle = "white";
                                ctx_info_reset.fill();

                                var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                if ( typeof(get_value_Number) !== "undefined" && get_value_Number !== null && get_value_Number.length != 0){
                                    ctx.drawImage(sourceReset_canvas_info, 60, 740,405,50);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Bold'";
                                    ctx.fillText(text_label_number, 60, 760);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Book'";
                                    ctx.fillText(get_value_Number, 115, 760);
                                }else{
                                    ctx.drawImage(sourceReset_canvas_info, 60, 740,405,50);
                                }

                            }

                        }

                  }else if(get_front_card_type == "Square Picture"){	

                        for (var i = 0; i < arr_card_contact_number_edit.length; i++) {
                            var text_label_number = "";
                            var get_value_Number = "";
                            if(arr_card_contact_number_edit[i].name == "faxNumber"){
                                text_label_number = "F ";
                                get_value_Number = arr_card_contact_number_edit[i].value;
                            }
                            if(arr_card_contact_number_edit[i].name == "mobilePhone"){
                                text_label_number = "M ";
                                get_value_Number = arr_card_contact_number_edit[i].value;
                            }
                            if(arr_card_contact_number_edit[i].name == "businessPhones"){
                                text_label_number = "O ";
                                get_value_Number = arr_card_contact_number_edit[i].value;
                            }

                            if (i == 0){

                                ctx_info_reset.rect(0, 0, 1000, 200);
                                ctx_info_reset.fillStyle = "white";
                                ctx_info_reset.fill();

                                var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                if ( typeof(get_value_Number) !== "undefined" && get_value_Number !== null && get_value_Number.length != 0 ){
                                    ctx.drawImage(sourceReset_canvas_info, 60, 595,405,50);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Bold'";
                                    ctx.fillText(text_label_number, 60, 620);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Book'";
                                    ctx.fillText(get_value_Number, 115, 620);
                                }else{
                                    ctx.drawImage(sourceReset_canvas_info, 60, 595,405,50);
                                }

                            }

                            if (i == 1){

                                ctx_info_reset.rect(0, 0, 1000, 200);
                                ctx_info_reset.fillStyle = "white";
                                ctx_info_reset.fill();

                                var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                if ( typeof(get_value_Number) !== "undefined" && get_value_Number !== null && get_value_Number.length != 0 ){
                                    ctx.drawImage(sourceReset_canvas_info, 60, 670,405,50);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Bold'";
                                    ctx.fillText(text_label_number, 60, 690);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Book'";
                                    ctx.fillText(get_value_Number, 115, 690);
                                }else{
                                    ctx.drawImage(sourceReset_canvas_info, 60, 670,405,50);
                                }

                            }

                            if (i == 2){

                                ctx_info_reset.rect(0, 0, 1000, 200);
                                ctx_info_reset.fillStyle = "white";
                                ctx_info_reset.fill();

                                var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                                if ( typeof(get_value_Number) !== "undefined" && get_value_Number !== null && get_value_Number.length != 0 ){
                                    ctx.drawImage(sourceReset_canvas_info, 60, 740,405,50);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Bold'";
                                    ctx.fillText(text_label_number, 60, 760);

                                    ctx.fillStyle = "#262a82";
                                    ctx.textBaseline = 'middle';
                                    ctx.font = "50px 'CircularStd-Book'";
                                    ctx.fillText(get_value_Number, 115, 760);
                                }else{
                                    ctx.drawImage(sourceReset_canvas_info, 60, 740,405,50);
                                }

                            }

                        }
                  }

                  setTimeout(function(){
                      applyFrontCardPreview();
                      applyBackCardPreview();
                  },2000);
          }
    }

  });

  $("#line-item_switch-rounded-street").on('change', function (){
    $('#street').trigger("change");
    $('#city').trigger("change");
    $('#state').trigger("change");
    $('#zip-code').trigger("change");
  });

  $('#streetf').on('keyup change', function(e) {
    var input_data_value = $(this).val();
    if(input_data_value.length<=35){
         var get_filter_option_type = $(".customize_your_business_cards_type_selection_section").attr("data-business-card-type-selected");

          if(get_filter_option_type == "Team"){
                  var get_front_card_type = $("input[name='properties[Team - Choose front]']:checked").val();
                  var canvas_info_reset = document.getElementById('reset_canvas_info');
                  var ctx_info_reset = canvas_info_reset.getContext('2d');

                  if(get_front_card_type == "No Picture"){	
                        ctx_info_reset.rect(0, 0, 1000, 200);
                        ctx_info_reset.fillStyle = "white";
                        ctx_info_reset.fill();
                        ctx.fillStyle = "#262a82";
                        ctx.textBaseline = 'middle';
                        ctx.font = "50px 'CircularStd-Book'";
                        var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                        if ( typeof(input_data_value) !== "undefined" && input_data_value !== null ){
                            ctx.drawImage(sourceReset_canvas_info, 480, 590,650,60);
                            ctx.fillText(input_data_value, 480, 620);
                        }else{
                            ctx.fillText(" - ", 480, 620);
                        }
                  }else if(get_front_card_type == "Circle Picture"){	
                        ctx_info_reset.rect(0, 0, 1000, 200);
                        ctx_info_reset.fillStyle = "white";
                        ctx_info_reset.fill();
                        ctx.fillStyle = "#262a82";
                        ctx.textBaseline = 'middle';
                        ctx.font = "50px 'CircularStd-Book'";
                        var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                        if ( typeof(input_data_value) !== "undefined" && input_data_value !== null ){
                            ctx.drawImage(sourceReset_canvas_info, 480, 590,650,60);
                            ctx.fillText(input_data_value, 480, 620);
                        }else{
                            ctx.fillText(" - ", 480, 620);
                        }
                  }else if(get_front_card_type == "Square Picture"){	

                        ctx_info_reset.rect(0, 0, 1000, 200);
                        ctx_info_reset.fillStyle = "white";
                        ctx_info_reset.fill();
                        ctx.fillStyle = "#262a82";
                        ctx.textBaseline = 'middle';
                        ctx.font = "50px 'CircularStd-Book'";
                        var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                        if ( typeof(input_data_value) !== "undefined" && input_data_value !== null ){
                            ctx.drawImage(sourceReset_canvas_info, 480, 590,640,60);
                            ctx.fillText(input_data_value, 480, 620);
                        }else{
                            ctx.fillText(" - ", 480, 620);
                        }
                  }
                  setTimeout(function(){
                      applyFrontCardPreview();
                      applyBackCardPreview();
                  },2000);
          }else if(get_filter_option_type == "Standard"){

                  var get_front_card_type = $("input[name='properties[Standard - Choose front]']:checked").val();
                  var canvas_info_reset = document.getElementById('reset_canvas_info');
                  var ctx_info_reset = canvas_info_reset.getContext('2d');

                  if(get_front_card_type == "No Picture"){	
                        ctx_info_reset.rect(0, 0, 1000, 200);
                        ctx_info_reset.fillStyle = "white";
                        ctx_info_reset.fill();
                        ctx.fillStyle = "#262a82";
                        ctx.textBaseline = 'middle';
                        ctx.font = "50px 'CircularStd-Book'";
                        var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                        if ( typeof(input_data_value) !== "undefined" && input_data_value !== null ){
                            ctx.drawImage(sourceReset_canvas_info, 480, 590,650,60);
                            wrapText(ctx, input_data_value, 480, 620, 670, 75);
                        }else{
                            ctx.fillText(" - ", 480, 620);
                        }
                  }else if(get_front_card_type == "Circle Picture"){	
                        ctx_info_reset.rect(0, 0, 1000, 200);
                        ctx_info_reset.fillStyle = "white";
                        ctx_info_reset.fill();
                        ctx.fillStyle = "#262a82";
                        ctx.textBaseline = 'middle';
                        ctx.font = "50px 'CircularStd-Book'";
                        var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                        if ( typeof(input_data_value) !== "undefined" && input_data_value !== null ){
                            ctx.drawImage(sourceReset_canvas_info, 480, 590,800,60);
                            ctx.fillText(input_data_value, 480, 620);
                        }else{
                            ctx.fillText(" - ", 480, 620);
                        }
                  }else if(get_front_card_type == "Square Picture"){	

                        ctx_info_reset.rect(0, 0, 1000, 200);
                        ctx_info_reset.fillStyle = "white";
                        ctx_info_reset.fill();
                        ctx.fillStyle = "#262a82";
                        ctx.textBaseline = 'middle';
                        ctx.font = "50px 'CircularStd-Book'";
                        var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                        if ( typeof(input_data_value) !== "undefined" && input_data_value !== null ){
                            ctx.drawImage(sourceReset_canvas_info, 480, 590,640,60);
                            ctx.fillText(input_data_value, 480, 620);
                        }else{
                            ctx.fillText(" - ", 480, 620);
                        }
                  }

                  setTimeout(function(){
                      applyFrontCardPreview();
                      applyBackCardPreview();
                  },2000);
          }
    }

  });

  $('#street,#city,#state,#zip-code').on('keyup change', function(e) {
    var input_data_value_lower_address = " ";
    var input_data_value_street = $("#street").val();
    var input_data_value_city = $("#city").val();
    var input_data_value_state = $("#state").val();
    var input_data_value_zip_code = $("#zip-code").val();
    if ( typeof(input_data_value_street) !== "undefined" && input_data_value_street !== null ){
        input_data_value_lower_address = input_data_value_street +", ";
    }else{
        input_data_value_lower_address = " ";
    }

    if ( typeof(input_data_value_city) !== "undefined" && input_data_value_city !== null ){
        input_data_value_lower_address = input_data_value_lower_address + input_data_value_city +", ";
    }else{
        input_data_value_lower_address = input_data_value_lower_address + " ";
    }

    if ( typeof(input_data_value_state) !== "undefined" && input_data_value_state !== null ){
        input_data_value_lower_address = input_data_value_lower_address + input_data_value_state +", ";
    }else{
        input_data_value_lower_address = input_data_value_lower_address + " ";
    }

    if ( typeof(input_data_value_zip_code) !== "undefined" && input_data_value_zip_code !== null ){
        input_data_value_lower_address = input_data_value_lower_address + input_data_value_zip_code;
    }else{
        input_data_value_lower_address = input_data_value_lower_address + " ";
    }

    if(input_data_value_lower_address.length<=150){
         var get_filter_option_type = $(".customize_your_business_cards_type_selection_section").attr("data-business-card-type-selected");

          if(get_filter_option_type == "Team"){
                  var get_front_card_type = $("input[name='properties[Team - Choose front]']:checked").val();
                  var canvas_info_reset = document.getElementById('reset_canvas_info');
                  var ctx_info_reset = canvas_info_reset.getContext('2d');

                  if(get_front_card_type == "No Picture"){	
                        ctx_info_reset.rect(0, 0, 1000, 200);
                        ctx_info_reset.fillStyle = "white";
                        ctx_info_reset.fill();
                        ctx.fillStyle = "#262a82";
                        ctx.textBaseline = 'middle';
                        ctx.font = "50px 'CircularStd-Book'";
                        var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                        if ( typeof(input_data_value_lower_address) !== "undefined" && input_data_value_lower_address !== null ){

                            ctx.drawImage(sourceReset_canvas_info, 480, 590,650,220);
                            wrapText(ctx, input_data_value_lower_address, 480, 620, 670, 75);

                        }else{
                            ctx.fillText(" - ", 480, 690);
                        }
                  }else if(get_front_card_type == "Circle Picture"){	
                        ctx_info_reset.rect(0, 0, 1000, 200);
                        ctx_info_reset.fillStyle = "white";
                        ctx_info_reset.fill();
                        ctx.fillStyle = "#262a82";
                        ctx.textBaseline = 'middle';
                        ctx.font = "50px 'CircularStd-Book'";
                        var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                        if ( typeof(input_data_value_lower_address) !== "undefined" && input_data_value_lower_address !== null ){

                            ctx.drawImage(sourceReset_canvas_info, 480, 590,700.5,220);
                            wrapText(ctx, input_data_value_lower_address, 480, 620, 670, 75);

                        }else{
                            ctx.fillText(" - ", 480, 690);
                        }
                  }else if(get_front_card_type == "Square Picture"){	

                        ctx_info_reset.rect(0, 0, 1000, 200);
                        ctx_info_reset.fillStyle = "white";
                        ctx_info_reset.fill();
                        ctx.fillStyle = "#262a82";
                        ctx.textBaseline = 'middle';
                        ctx.font = "50px 'CircularStd-Book'";
                        var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                        if ( typeof(input_data_value_lower_address) !== "undefined" && input_data_value_lower_address !== null ){

                            ctx.drawImage(sourceReset_canvas_info, 480, 590,640,220);
                            wrapText(ctx, input_data_value_lower_address, 480, 620, 640, 75);

                        }else{
                            ctx.fillText(" - ", 480, 690);
                        }
                  }
                  setTimeout(function(){
                      applyFrontCardPreview();
                      applyBackCardPreview();
                  },2000);
          }else if(get_filter_option_type == "Standard"){

                  var get_front_card_type = $("input[name='properties[Standard - Choose front]']:checked").val();
                  var canvas_info_reset = document.getElementById('reset_canvas_info');
                  var ctx_info_reset = canvas_info_reset.getContext('2d');

                  if(get_front_card_type == "No Picture"){	
                        ctx_info_reset.rect(0, 0, 1000, 200);
                        ctx_info_reset.fillStyle = "white";
                        ctx_info_reset.fill();
                        ctx.fillStyle = "#262a82";
                        ctx.textBaseline = 'middle';
                        ctx.font = "50px 'CircularStd-Book'";
                        var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                        if ( typeof(input_data_value_lower_address) !== "undefined" && input_data_value_lower_address !== null ){

                            ctx.drawImage(sourceReset_canvas_info, 480, 590,650,220);
                            wrapText(ctx, input_data_value_lower_address, 480, 620, 670, 75);

                        }else{
                            ctx.fillText(" - ", 480, 690);
                        }
                  }else if(get_front_card_type == "Circle Picture"){	
                        ctx_info_reset.rect(0, 0, 1000, 200);
                        ctx_info_reset.fillStyle = "white";
                        ctx_info_reset.fill();
                        ctx.fillStyle = "#262a82";
                        ctx.textBaseline = 'middle';
                        ctx.font = "50px 'CircularStd-Book'";
                        var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                        if ( typeof(input_data_value_lower_address) !== "undefined" && input_data_value_lower_address !== null ){

                            ctx.drawImage(sourceReset_canvas_info, 480, 590,700.5,220);
                            wrapText(ctx, input_data_value_lower_address, 480, 620, 670, 75);

                        }else{
                            ctx.fillText(" - ", 480, 690);
                        }
                  }else if(get_front_card_type == "Square Picture"){	

                        ctx_info_reset.rect(0, 0, 1000, 200);
                        ctx_info_reset.fillStyle = "white";
                        ctx_info_reset.fill();
                        ctx.fillStyle = "#262a82";
                        ctx.textBaseline = 'middle';
                        ctx.font = "50px 'CircularStd-Book'";
                        var sourceReset_canvas_info = document.getElementById('reset_canvas_info');
                        if ( typeof(input_data_value_lower_address) !== "undefined" && input_data_value_lower_address !== null ){

                            ctx.drawImage(sourceReset_canvas_info, 480, 590,640,220);
                            wrapText(ctx, input_data_value_lower_address, 480, 620, 640, 75);
                        }else{
                            ctx.fillText(" - ", 480, 690);
                        }
                  }

                  setTimeout(function(){
                      applyFrontCardPreview();
                      applyBackCardPreview();
                  },2000);
          }
    }

  });

  $("#custom-url").on('change', function (){
    $('#qrUrl').trigger("change");
  });

  $('#qrUrl').on('keyup change', function(e) {
    var input_data_value = $(this).val();
         var get_filter_option_type = $(".customize_your_business_cards_type_selection_section").attr("data-business-card-type-selected");

          if(get_filter_option_type == "Team"){

          }else if(get_filter_option_type == "Standard"){

                  var get_back_card_type = $("input[name='properties[Standard - Choose back]']:checked").val();

                  if(get_back_card_type == "QR - Yellow"){	

                        img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_QR-Y8_HD_Yellow_blank.jpg?v=1742215689";
                        ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                        ctx_back.drawImage(img_back,0,0,1600,922);

                        setTimeout(function(){

                            ctx_back.fillStyle = "#262a82";
                            ctx_back.textBaseline = 'middle';
                            ctx_back.font = "50px 'CircularStd-Bold'";

                            var get_officer_url_split = input_data_value;

                            if(get_officer_url_split.indexOf("www.") != -1){
                                var text_Officer_URL_text = get_officer_url_split.split("www.");
                                ctx_back.fillText(text_Officer_URL_text[1], 140, 640);
                            }else{
                                ctx_back.fillText(input_data_value, 140, 640);
                            }

                            ctx_back.fillStyle = "#262a82";
                            ctx_back.textBaseline = 'middle';
                            ctx_back.font = "50px 'CircularStd-Bold'";
                            var text_Officer_Licensed_text = "Licensed in State(s) option";

                            var text_Officer_Licensed_opt = $("#licensed-in-ex-nc-and-va").val();
                            if ( typeof(text_Officer_Licensed_opt) !== "undefined" && text_Officer_Licensed_opt !== null ){
                                text_Officer_Licensed_text = "Licensed in State(s) "+text_Officer_Licensed_opt;
                                ctx_back.fillText(text_Officer_Licensed_text, 140, 720);
                            }else{
                                text_Officer_Licensed_text = " ";
                                ctx_back.fillText(text_Officer_Licensed_text, 140, 720);
                            }

                            ctx_back.fillStyle = "#262a82";
                            ctx_back.textBaseline = 'middle';
                            ctx_back.font = "60px 'CircularStd-Bold'";
                            var text_Officer_additional_text = "Se habla espanol";

                            var get_spanish = $("#spanish-se-habla-espanol").val();

                            if(get_spanish == "Yes"){
                                text_Officer_additional_text = "Se habla espanol";
                                ctx_back.fillText(text_Officer_additional_text, 140, 800);
                            }else{
                                text_Officer_additional_text = " ";
                                ctx_back.fillText(text_Officer_additional_text, 140, 800);
                            }

                            // select QR canvas elements
                            var sourceCanvas = document.querySelectorAll(".bg canvas")[0];
                            if (sourceCanvas) {
                                ctx_back.drawImage(sourceCanvas,1250,110,360,360);
                            }

                        },100);

                  }else if(get_back_card_type == "QR - Blue"){	

                        img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_QR-Y8_Blue_HD_blank.jpg?v=1742219405";
                        ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                        ctx_back.drawImage(img_back,0,0,1600,922);

                        setTimeout(function(){

                            ctx_back.fillStyle = "#ffffff";
                            ctx_back.textBaseline = 'middle';
                            ctx_back.font = "50px 'CircularStd-Bold'";

                            var get_officer_url_split = input_data_value;

                            if(get_officer_url_split.indexOf("www.") != -1){
                                var text_Officer_URL_text = get_officer_url_split.split("www.");
                                ctx_back.fillText(text_Officer_URL_text[1], 140, 640);
                            }else{
                                ctx_back.fillText(get_officer_url_split, 140, 640);
                            }

                            ctx_back.fillStyle = "#ffffff";
                            ctx_back.textBaseline = 'middle';
                            ctx_back.font = "50px 'CircularStd-Bold'";
                            var text_Officer_Licensed_text = "Licensed in State(s) option";

                            var text_Officer_Licensed_opt = $("#licensed-in-ex-nc-and-va").val();
                            if ( typeof(text_Officer_Licensed_opt) !== "undefined" && text_Officer_Licensed_opt !== null ){
                                text_Officer_Licensed_text = "Licensed in State(s) "+text_Officer_Licensed_opt;
                                ctx_back.fillText(text_Officer_Licensed_text, 140, 720);
                            }else{
                                text_Officer_Licensed_text = " ";
                                ctx_back.fillText(text_Officer_Licensed_text, 140, 720);
                            }

                            ctx_back.fillStyle = "#ffffff";
                            ctx_back.textBaseline = 'middle';
                            ctx_back.font = "60px 'CircularStd-Bold'";
                            var text_Officer_additional_text = "Se habla espanol";

                            var get_spanish = $("#spanish-se-habla-espanol").val();

                            if(get_spanish == "Yes"){
                                text_Officer_additional_text = "Se habla espanol";
                                ctx_back.fillText(text_Officer_additional_text, 140, 800);
                            }else{
                                text_Officer_additional_text = " ";
                                ctx_back.fillText(text_Officer_additional_text, 140, 800);
                            }

                            // select QR canvas elements
                            var sourceCanvas = document.querySelectorAll(".bg canvas")[0];
                            if (sourceCanvas) {
                                ctx_back.drawImage(sourceCanvas,1250,90,360,360);
                            }

                        },100);

                  }else if(get_back_card_type == "QR - Angle Yellow"){	

                        img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_QR-Y8_angle_HD_blank.jpg?v=1742216438";

                        ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                        ctx_back.drawImage(img_back,0,0,1600,922);

                        setTimeout(function(){

                            ctx_back.fillStyle = "#262a82";
                            ctx_back.textBaseline = 'middle';
                            ctx_back.font = "50px 'CircularStd-Bold'";

                            var get_officer_url_split = input_data_value;

                            if(get_officer_url_split.indexOf("www.") != -1){
                                var text_Officer_URL_text = get_officer_url_split.split("www.");
                                ctx_back.fillText(text_Officer_URL_text[1], 130, 540);
                            }else{
                                ctx_back.fillText(get_officer_url_split, 130, 540);
                            }

                            ctx_back.fillStyle = "#262a82";
                            ctx_back.textBaseline = 'middle';
                            ctx_back.font = "50px 'CircularStd-Bold'";
                            var text_Officer_Licensed_text = "Licensed in State(s) option";

                            var text_Officer_Licensed_opt = $("#licensed-in-ex-nc-and-va").val();
                            if ( typeof(text_Officer_Licensed_opt) !== "undefined" && text_Officer_Licensed_opt !== null ){
                                text_Officer_Licensed_text = "Licensed in State(s) "+text_Officer_Licensed_opt;
                                ctx_back.fillText(text_Officer_Licensed_text, 130, 620);
                            }else{
                                text_Officer_Licensed_text = " ";
                                ctx_back.fillText(text_Officer_Licensed_text, 130, 620);
                            }

                            ctx_back.fillStyle = "#262a82";
                            ctx_back.textBaseline = 'middle';
                            ctx_back.font = "60px 'CircularStd-Bold'";
                            var text_Officer_additional_text = "Se habla espanol";

                            var get_spanish = $("#spanish-se-habla-espanol").val();

                            if(get_spanish == "Yes"){
                                text_Officer_additional_text = "Se habla espanol";
                                ctx_back.fillText(text_Officer_additional_text, 130, 700);
                            }else{
                                text_Officer_additional_text = " ";
                                ctx_back.fillText(text_Officer_additional_text, 130, 700);
                            }

                            // select QR canvas elements
                            var sourceCanvas = document.querySelectorAll(".bg canvas")[0];
                            if (sourceCanvas) {
                                ctx_back.drawImage(sourceCanvas,1200,95,370,370);
                            }

                        },100);

                  }else if(get_back_card_type == "QR - Mix Color"){	

                        img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_QR-NEW-HD_blank.jpg?v=1742284474";

                        ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                        ctx_back.drawImage(img_back,0,0,1600,922);

                        setTimeout(function(){

                            ctx_back.fillStyle = "#ffffff";
                            ctx_back.textBaseline = 'middle';
                            ctx_back.textAlign = "right";
                            ctx_back.font = "50px 'CircularStd-Bold'";

                            var get_officer_url_split = input_data_value;

                            if(get_officer_url_split.indexOf("www.") != -1){
                                var text_Officer_URL_text = get_officer_url_split.split("www.");
                                wrapText(ctx_back, text_Officer_URL_text[1], 1580, 540, 1000, 50);
                            }else{
                                wrapText(ctx_back, get_officer_url_split, 1580, 540, 1000, 50);

                            }

                            ctx_back.fillStyle = "#ffffff";
                            ctx_back.textBaseline = 'middle';
                            ctx_back.textAlign = "right";
                            ctx_back.font = "50px 'CircularStd-Bold'";
                            var text_Officer_Licensed_text = "Licensed in State(s) option";

                            var text_Officer_Licensed_opt = $("#licensed-in-ex-nc-and-va").val();
                            if ( typeof(text_Officer_Licensed_opt) !== "undefined" && text_Officer_Licensed_opt !== null ){
                                text_Officer_Licensed_text = "Licensed in State(s) "+text_Officer_Licensed_opt;
                                ctx_back.fillText(text_Officer_Licensed_text, 1580, 670);
                            }else{
                                text_Officer_Licensed_text = " ";
                                ctx_back.fillText(text_Officer_Licensed_text, 1580, 670);
                            }

                            ctx_back.fillStyle = "#ffffff";
                            ctx_back.textBaseline = 'middle';
                            ctx_back.textAlign = "right";
                            ctx_back.font = "60px 'CircularStd-Bold'";
                            var text_Officer_additional_text = "Se habla espanol";

                            var get_spanish = $("#spanish-se-habla-espanol").val();

                            if(get_spanish == "Yes"){
                                text_Officer_additional_text = "Se habla espanol";
                                ctx_back.fillText(text_Officer_additional_text, 1580, 750);
                            }else{
                                text_Officer_additional_text = " ";
                                ctx_back.fillText(text_Officer_additional_text, 1580, 750);
                            }

                            // select QR canvas elements
                            var sourceCanvas = document.querySelectorAll(".bg canvas")[0];
                            if (sourceCanvas) {
                                ctx_back.drawImage(sourceCanvas,85,525,360,360);
                            }

                        },100);

                  }

                  setTimeout(function(){
                      applyFrontCardPreview();
                      applyBackCardPreview();
                  },2000);
          }

  });

  $('#spanish-se-habla-espanol').on('change', function(e) {
    var input_data_value = $('#qrUrl').val();
         var get_filter_option_type = $(".customize_your_business_cards_type_selection_section").attr("data-business-card-type-selected");

          if(get_filter_option_type == "Team"){

                  var get_back_card_type = $("input[name='properties[Team - Choose back]']:checked").val();

                              if(get_back_card_type == "2 Team Circle"){

                                    img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_2TeamCrc4_HD_blank_B.jpg?v=1746453584";
                                    ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                                    ctx_back.drawImage(img_back,0,0,1600,922);

                                    setTimeout(function(){

                                        var text_back_top_title = "branches.guildmortgage.com/st/city";
                                        ctx_back.fillStyle = "#262a82";
                                        ctx_back.textBaseline = 'middle';
                                        ctx_back.font = "50px 'CircularStd-Bold'";
                                        ctx_back.textAlign = "right";
                                        ctx_back.fillText(text_back_top_title, 1600, 100);

                                        ctx_back.fillStyle = "#994396";
                                        ctx_back.textBaseline = 'middle';
                                        ctx_back.font = "55px 'CircularStd-Bold'";
                                        var text_back_top_subtitle = "Se habla espanol";
                                        ctx_back.textAlign = "right";

                                        var get_spanish = $("#spanish-se-habla-espanol").val();

                                        if(get_spanish == "Yes"){
                                            text_back_top_subtitle = "Se habla espanol";
                                            ctx_back.fillText(text_back_top_subtitle, 1600, 170);
                                        }else{
                                            text_back_top_subtitle = " ";
                                            ctx_back.fillText(text_back_top_subtitle, 1600, 170);
                                        }
                                    },100);

                              }else if(get_back_card_type == "3 Team Circle"){

                                  img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_3TeamCrc5_HD_blank_B.jpg?v=1746453584";
                                  ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                                  ctx_back.drawImage(img_back,0,0,1600,922);

                                  setTimeout(function(){
                                    var text_back_top_title = "branches.guildmortgage.com/st/city";
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "50px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "right";
                                    ctx_back.fillText(text_back_top_title, 1600, 100);

                                    ctx_back.fillStyle = "#994396";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "55px 'CircularStd-Bold'";
                                    var text_back_top_subtitle = "Se habla espanol";
                                    ctx_back.textAlign = "right";

                                    var get_spanish = $("#spanish-se-habla-espanol").val();

                                    if(get_spanish == "Yes"){
                                        text_back_top_subtitle = "Se habla espanol";
                                        ctx_back.fillText(text_back_top_subtitle, 1600, 170);
                                    }else{
                                        text_back_top_subtitle = " ";
                                        ctx_back.fillText(text_back_top_subtitle, 1600, 170);
                                    }
                                  },100);

                              }else if(get_back_card_type == "4 Team Circle"){

                                    img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_4TeamCrc6_HD_blank_B.jpg?v=1746453584";
                                    ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                                    ctx_back.drawImage(img_back,0,0,1600,922);

                                setTimeout(function(){
                                    var text_back_top_title = "branches.guildmortgage.com/st/city";
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "50px 'CircularStd-Bold'";
                                    ctx_back.textAlign = "right";
                                    ctx_back.fillText(text_back_top_title, 1600, 100);

                                    ctx_back.fillStyle = "#994396";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "55px 'CircularStd-Bold'";
                                    var text_back_top_subtitle = "Se habla espanol";
                                    ctx_back.textAlign = "right";

                                    var get_spanish = $("#spanish-se-habla-espanol").val();

                                    if(get_spanish == "Yes"){
                                        text_back_top_subtitle = "Se habla espanol";
                                        ctx_back.fillText(text_back_top_subtitle, 1600, 170);
                                    }else{
                                        text_back_top_subtitle = " ";
                                        ctx_back.fillText(text_back_top_subtitle, 1600, 170);
                                    }
                                  },100);
                              }

          }else if(get_filter_option_type == "Standard"){

                  var get_back_card_type = $("input[name='properties[Standard - Choose back]']:checked").val();

                  if(get_back_card_type == "QR - Yellow"){	

                        img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_QR-Y8_HD_Yellow_blank.jpg?v=1742215689";
                        ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                        ctx_back.drawImage(img_back,0,0,1600,922);

                        setTimeout(function(){

                            ctx_back.fillStyle = "#262a82";
                            ctx_back.textBaseline = 'middle';
                            ctx_back.font = "50px 'CircularStd-Bold'";

                            var get_officer_url_split = input_data_value;

                            if(get_officer_url_split.indexOf("www.") != -1){
                                var text_Officer_URL_text = get_officer_url_split.split("www.");
                                ctx_back.fillText(text_Officer_URL_text[1], 140, 640);
                            }else{
                                ctx_back.fillText(input_data_value, 140, 640);
                            }

                            ctx_back.fillStyle = "#262a82";
                            ctx_back.textBaseline = 'middle';
                            ctx_back.font = "50px 'CircularStd-Bold'";
                            var text_Officer_Licensed_text = "Licensed in State(s) option";

                            var text_Officer_Licensed_opt = $("#licensed-in-ex-nc-and-va").val();
                            if ( typeof(text_Officer_Licensed_opt) !== "undefined" && text_Officer_Licensed_opt !== null ){
                                text_Officer_Licensed_text = "Licensed in State(s) "+text_Officer_Licensed_opt;
                                if(text_Officer_Licensed_opt.length > 35){
                                    wrapText(ctx_back, text_Officer_Licensed_text, 140, 720, 1400, 55);

                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "60px 'CircularStd-Bold'";
                                    var text_Officer_additional_text = "Se habla espanol";

                                    var get_spanish = $("#spanish-se-habla-espanol").val();

                                    if(get_spanish == "Yes"){
                                        text_Officer_additional_text = "Se habla espanol";
                                        ctx_back.fillText(text_Officer_additional_text, 140, 850);
                                    }else{
                                        text_Officer_additional_text = " ";
                                        ctx_back.fillText(text_Officer_additional_text, 140, 850);
                                    }

                                }else{
                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "60px 'CircularStd-Bold'";
                                    var text_Officer_additional_text = "Se habla espanol";

                                    var get_spanish = $("#spanish-se-habla-espanol").val();

                                    if(get_spanish == "Yes"){
                                        text_Officer_additional_text = "Se habla espanol";
                                        ctx_back.fillText(text_Officer_additional_text, 140, 800);
                                    }else{
                                        text_Officer_additional_text = " ";
                                        ctx_back.fillText(text_Officer_additional_text, 140, 800);
                                    }
                                }

                            }else{
                                text_Officer_Licensed_text = " ";
                                ctx_back.fillText(text_Officer_Licensed_text, 140, 720);

                                ctx_back.fillStyle = "#262a82";
                                ctx_back.textBaseline = 'middle';
                                ctx_back.font = "60px 'CircularStd-Bold'";
                                var text_Officer_additional_text = "Se habla espanol";

                                var get_spanish = $("#spanish-se-habla-espanol").val();

                                if(get_spanish == "Yes"){
                                    text_Officer_additional_text = "Se habla espanol";
                                    ctx_back.fillText(text_Officer_additional_text, 140, 800);
                                }else{
                                    text_Officer_additional_text = " ";
                                    ctx_back.fillText(text_Officer_additional_text, 140, 800);
                                }

                            }

                            // select QR canvas elements
                            var sourceCanvas = document.querySelectorAll(".bg canvas")[0];
                            if (sourceCanvas) {
                                ctx_back.drawImage(sourceCanvas,1250,110,360,360);
                            }

                        },100);

                  }else if(get_back_card_type == "QR - Blue"){	

                        img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_QR-Y8_Blue_HD_blank.jpg?v=1742219405";
                        ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                        ctx_back.drawImage(img_back,0,0,1600,922);

                        setTimeout(function(){

                            ctx_back.fillStyle = "#ffffff";
                            ctx_back.textBaseline = 'middle';
                            ctx_back.font = "50px 'CircularStd-Bold'";

                            var get_officer_url_split = input_data_value;

                            if(get_officer_url_split.indexOf("www.") != -1){
                                var text_Officer_URL_text = get_officer_url_split.split("www.");
                                ctx_back.fillText(text_Officer_URL_text[1], 140, 640);
                            }else{
                                ctx_back.fillText(get_officer_url_split, 140, 640);
                            }

                            ctx_back.fillStyle = "#ffffff";
                            ctx_back.textBaseline = 'middle';
                            ctx_back.font = "50px 'CircularStd-Bold'";
                            var text_Officer_Licensed_text = "Licensed in State(s) option";

                            var text_Officer_Licensed_opt = $("#licensed-in-ex-nc-and-va").val();
                            if ( typeof(text_Officer_Licensed_opt) !== "undefined" && text_Officer_Licensed_opt !== null ){
                                text_Officer_Licensed_text = "Licensed in State(s) "+text_Officer_Licensed_opt;

                                if(text_Officer_Licensed_opt.length > 35){
                                    wrapText(ctx_back, text_Officer_Licensed_text, 140, 720, 1400, 55);

                                    ctx_back.fillStyle = "#ffffff";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "60px 'CircularStd-Bold'";
                                    var text_Officer_additional_text = "Se habla espanol";

                                    var get_spanish = $("#spanish-se-habla-espanol").val();

                                    if(get_spanish == "Yes"){
                                        text_Officer_additional_text = "Se habla espanol";
                                        ctx_back.fillText(text_Officer_additional_text, 140, 850);
                                    }else{
                                        text_Officer_additional_text = " ";
                                        ctx_back.fillText(text_Officer_additional_text, 140, 850);
                                    }

                                }else{
                                    ctx_back.fillStyle = "#ffffff";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "60px 'CircularStd-Bold'";
                                    var text_Officer_additional_text = "Se habla espanol";

                                    var get_spanish = $("#spanish-se-habla-espanol").val();

                                    if(get_spanish == "Yes"){
                                        text_Officer_additional_text = "Se habla espanol";
                                        ctx_back.fillText(text_Officer_additional_text, 140, 800);
                                    }else{
                                        text_Officer_additional_text = " ";
                                        ctx_back.fillText(text_Officer_additional_text, 140, 800);
                                    }
                                }

                            }else{
                                text_Officer_Licensed_text = " ";
                                ctx_back.fillText(text_Officer_Licensed_text, 140, 720);

                                ctx_back.fillStyle = "#ffffff";
                                ctx_back.textBaseline = 'middle';
                                ctx_back.font = "60px 'CircularStd-Bold'";
                                var text_Officer_additional_text = "Se habla espanol";

                                var get_spanish = $("#spanish-se-habla-espanol").val();

                                if(get_spanish == "Yes"){
                                    text_Officer_additional_text = "Se habla espanol";
                                    ctx_back.fillText(text_Officer_additional_text, 140, 800);
                                }else{
                                    text_Officer_additional_text = " ";
                                    ctx_back.fillText(text_Officer_additional_text, 140, 800);
                                }
                            }

                            // select QR canvas elements
                            var sourceCanvas = document.querySelectorAll(".bg canvas")[0];
                            if (sourceCanvas) {
                                ctx_back.drawImage(sourceCanvas,1250,90,360,360);
                            }

                        },100);

                  }else if(get_back_card_type == "QR - Angle Yellow"){	

                        img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_QR-Y8_angle_HD_blank.jpg?v=1742216438";

                        ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                        ctx_back.drawImage(img_back,0,0,1600,922);

                        setTimeout(function(){

                            ctx_back.fillStyle = "#262a82";
                            ctx_back.textBaseline = 'middle';
                            ctx_back.font = "50px 'CircularStd-Bold'";

                            var get_officer_url_split = input_data_value;

                            if(get_officer_url_split.indexOf("www.") != -1){
                                var text_Officer_URL_text = get_officer_url_split.split("www.");
                                ctx_back.fillText(text_Officer_URL_text[1], 130, 540);
                            }else{
                                ctx_back.fillText(get_officer_url_split, 130, 540);
                            }

                            ctx_back.fillStyle = "#262a82";
                            ctx_back.textBaseline = 'middle';
                            ctx_back.font = "50px 'CircularStd-Bold'";
                            var text_Officer_Licensed_text = "Licensed in State(s) option";

                            var text_Officer_Licensed_opt = $("#licensed-in-ex-nc-and-va").val();
                            if ( typeof(text_Officer_Licensed_opt) !== "undefined" && text_Officer_Licensed_opt !== null ){
                                text_Officer_Licensed_text = "Licensed in State(s) "+text_Officer_Licensed_opt;

                                if(text_Officer_Licensed_opt.length > 35){
                                    wrapText(ctx_back, text_Officer_Licensed_text, 130, 620, 1400, 55);

                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "60px 'CircularStd-Bold'";
                                    var text_Officer_additional_text = "Se habla espanol";

                                    var get_spanish = $("#spanish-se-habla-espanol").val();

                                    if(get_spanish == "Yes"){
                                        text_Officer_additional_text = "Se habla espanol";
                                        ctx_back.fillText(text_Officer_additional_text, 130, 750);
                                    }else{
                                        text_Officer_additional_text = " ";
                                        ctx_back.fillText(text_Officer_additional_text, 130, 750);
                                    }

                                }else{

                                    ctx_back.fillStyle = "#262a82";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.font = "60px 'CircularStd-Bold'";
                                    var text_Officer_additional_text = "Se habla espanol";

                                    var get_spanish = $("#spanish-se-habla-espanol").val();

                                    if(get_spanish == "Yes"){
                                        text_Officer_additional_text = "Se habla espanol";
                                        ctx_back.fillText(text_Officer_additional_text, 130, 700);
                                    }else{
                                        text_Officer_additional_text = " ";
                                        ctx_back.fillText(text_Officer_additional_text, 130, 700);
                                    }
                                }

                            }else{
                                text_Officer_Licensed_text = " ";
                                ctx_back.fillText(text_Officer_Licensed_text, 130, 620);

                                ctx_back.fillStyle = "#262a82";
                                ctx_back.textBaseline = 'middle';
                                ctx_back.font = "60px 'CircularStd-Bold'";
                                var text_Officer_additional_text = "Se habla espanol";

                                var get_spanish = $("#spanish-se-habla-espanol").val();

                                if(get_spanish == "Yes"){
                                    text_Officer_additional_text = "Se habla espanol";
                                    ctx_back.fillText(text_Officer_additional_text, 130, 700);
                                }else{
                                    text_Officer_additional_text = " ";
                                    ctx_back.fillText(text_Officer_additional_text, 130, 700);
                                }

                            }

                            // select QR canvas elements
                            var sourceCanvas = document.querySelectorAll(".bg canvas")[0];
                            if (sourceCanvas) {
                                ctx_back.drawImage(sourceCanvas,1200,95,370,370);
                            }

                        },100);

                  }else if(get_back_card_type == "QR - Mix Color"){	

                        img_back.src = "https://cdn.shopify.com/s/files/1/0597/0978/4112/files/Business-Card-Templates_QR-NEW-HD_blank.jpg?v=1742284474";

                        ctx_back.clearRect(0, 0, canvas_back.width, canvas_back.height);
                        ctx_back.drawImage(img_back,0,0,1600,922);

                        setTimeout(function(){

                            ctx_back.fillStyle = "#ffffff";
                            ctx_back.textBaseline = 'middle';
                            ctx_back.textAlign = "right";
                            ctx_back.font = "50px 'CircularStd-Bold'";

                            var get_officer_url_split = input_data_value;

                            if(get_officer_url_split.indexOf("www.") != -1){
                                var text_Officer_URL_text = get_officer_url_split.split("www.");
                                wrapText(ctx_back, text_Officer_URL_text[1], 1580, 540, 1000, 50);
                            }else{
                                wrapText(ctx_back, get_officer_url_split, 1580, 540, 1000, 50);

                            }

                            ctx_back.fillStyle = "#ffffff";
                            ctx_back.textBaseline = 'middle';
                            ctx_back.textAlign = "right";
                            ctx_back.font = "50px 'CircularStd-Bold'";
                            var text_Officer_Licensed_text = "Licensed in State(s) option";

                            var text_Officer_Licensed_opt = $("#licensed-in-ex-nc-and-va").val();
                            if ( typeof(text_Officer_Licensed_opt) !== "undefined" && text_Officer_Licensed_opt !== null ){
                                text_Officer_Licensed_text = "Licensed in State(s) "+text_Officer_Licensed_opt;

                                if(text_Officer_Licensed_opt.length > 35){
                                    wrapText(ctx_back, text_Officer_Licensed_text, 1580, 670, 1000, 55);

                                    ctx_back.fillStyle = "#ffffff";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.textAlign = "right";
                                    ctx_back.font = "60px 'CircularStd-Bold'";
                                    var text_Officer_additional_text = "Se habla espanol";

                                    var get_spanish = $("#spanish-se-habla-espanol").val();

                                    if(get_spanish == "Yes"){
                                        text_Officer_additional_text = "Se habla espanol";
                                        ctx_back.fillText(text_Officer_additional_text, 1580, 850);
                                    }else{
                                        text_Officer_additional_text = " ";
                                        ctx_back.fillText(text_Officer_additional_text, 1580, 850);
                                    }

                                }else{

                                    ctx_back.fillText(text_Officer_Licensed_text, 1580, 670);

                                    ctx_back.fillStyle = "#ffffff";
                                    ctx_back.textBaseline = 'middle';
                                    ctx_back.textAlign = "right";
                                    ctx_back.font = "60px 'CircularStd-Bold'";
                                    var text_Officer_additional_text = "Se habla espanol";

                                    var get_spanish = $("#spanish-se-habla-espanol").val();

                                    if(get_spanish == "Yes"){
                                        text_Officer_additional_text = "Se habla espanol";
                                        ctx_back.fillText(text_Officer_additional_text, 1580, 750);
                                    }else{
                                        text_Officer_additional_text = " ";
                                        ctx_back.fillText(text_Officer_additional_text, 1580, 750);
                                    }
                                }

                            }else{
                                text_Officer_Licensed_text = " ";
                                ctx_back.fillText(text_Officer_Licensed_text, 1580, 670);

                                ctx_back.fillStyle = "#ffffff";
                                ctx_back.textBaseline = 'middle';
                                ctx_back.textAlign = "right";
                                ctx_back.font = "60px 'CircularStd-Bold'";
                                var text_Officer_additional_text = "Se habla espanol";

                                var get_spanish = $("#spanish-se-habla-espanol").val();

                                if(get_spanish == "Yes"){
                                    text_Officer_additional_text = "Se habla espanol";
                                    ctx_back.fillText(text_Officer_additional_text, 1580, 750);
                                }else{
                                    text_Officer_additional_text = " ";
                                    ctx_back.fillText(text_Officer_additional_text, 1580, 750);
                                }

                            }

                            // select QR canvas elements
                            var sourceCanvas = document.querySelectorAll(".bg canvas")[0];
                            if (sourceCanvas) {
                                ctx_back.drawImage(sourceCanvas,85,525,360,360);
                            }

                        },100);

                  }

                  setTimeout(function(){
                      applyFrontCardPreview();
                      applyBackCardPreview();
                  },2000);
          }

  });

});

 